import React from 'react';
import  { useState, useRef, useCallback } from 'react';
import  { useEffect }from 'react';
import  { 
    useMemo,
  
    StrictMode, } from 'react';

import './BijeleStranice.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';
import { useHistory, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from "./redux/actions";

import { APICall } from './services/api.service';
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';

import { Autocomplete} from '@mui/material';

import Fab from '@mui/material/Fab';
import { useSelector, useDispatch } from 'react-redux';

import * as useLocalStorage from './services/useLocalStorage'
import { TbMap2 } from 'react-icons/tb';
import { AiOutlineConsoleSql } from 'react-icons/ai';



import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import Swal from 'sweetalert2';

import { useSearchParams } from "react-router-dom";



import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,

    RowSelectionModule,
    RowApiModule,
    RowStyleModule


} from "ag-grid-community";


import useDebouncedClick from "./useDebouncedClick";

//import SpecialCellRenderer from './CustomCellRenderer';

import { styled } from "@mui/material/styles";


const MyTextField = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "black",
    color: "black"
  }
}));
  
  
ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule,
    RowStyleModule
    
]);
  
  
  


  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    //fontSize: 16,
    fontWeight:400

  });
/*

const myTheme = themeQuartz.withParams({
    
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    //cellFontFamily: "serif",
    //headerFontFamily: "Georgia",
    //fontSize: 16,
    fontWeight:400
  

});

  */


const theme = createTheme({
    palette: {
        primary: {
            main: '#520074',
            lightyellow: '#FFFDD0' 
        }
    },
});



const SpecialCellRenderer = (props) => {
    
    const buttonRef = React.useRef();

    const upRef = React.useRef();
    const downRef = React.useRef();
  
    useEffect(() => {

        //console.log("🧠 SpecialCellRenderer props:", props);
        //console.log("🔍 props.context:", props.context);
        const handleUpClick = (e) => {
            e.stopPropagation();

           
            //handleUp(props.data);

            props.context.handleUp(props.data);
         
            
          };
      
          const handleDownClick = (e) => {
            e.stopPropagation();

            //handleDown(props.data);

            props.context.handleDown(props.data);



          };
      
          const upBtn = upRef.current;
          const downBtn = downRef.current;
  
          if (upBtn) upBtn.addEventListener("click", handleUpClick);
          if (downBtn) downBtn.addEventListener("click", handleDownClick);
  
      return () => {
        if (upBtn) upBtn.removeEventListener("click", handleUpClick);
        if (downBtn) downBtn.removeEventListener("click", handleDownClick);
      };
    }, [props.data]);
  
    const baseStyle = {
        border: "1px solid #d0d7de",
        borderRadius: "12px",
        padding: "4px 6px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)",
      };
    
      const upStyle = {
        ...baseStyle,
        backgroundColor: "#fff9db", // light yellow
      };
    
      const downStyle = {
        ...baseStyle,
        backgroundColor: "#dbf0ff", // light blue
      };
    
      const arrowStyle = {
        width: "14px",
        height: "14px",
        stroke: "#444",
      };

    return (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
        <button ref={upRef} style={upStyle}>
          <svg style={arrowStyle} viewBox="0 0 24 24" fill="none" strokeWidth="2">
            <path d="M18 15l-6-6-6 6" stroke="currentColor" />
          </svg>
        </button>
        <button ref={downRef} style={downStyle}>
          <svg style={arrowStyle} viewBox="0 0 24 24" fill="none" strokeWidth="2">
            <path d="M6 9l6 6 6-6" stroke="currentColor" />
          </svg>
        </button>
      </div>
    );
  };



function BijeleStranice(props) {
   


/**************************************************ZUTE POPUP GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);


    const rowClassRules = useMemo(() => { 
        return {
            // zuto na naslove
            'rag-green-outer': (params) => { return params.data.year === 2008; },

            // apply amber 2004
            'rag-amber-outer': (params) => { return params.data.year === 2004; },

            // apply red to 2000
            'rag-red-outer': (params) => { return params.data.year === 2000; }
        };
    }, []);

    const getRowStyle = useCallback(params => {

        console.log("Setting background:");
        console.log(params.node.data.Objava)
    //if (params.node.rowIndex % 2 === 0) {
    //    return { background: 'red' };
    //}
    if(params.node.data.Objava=='naslov'){
        return { background: 'lightyellow' };
    }
    }, []);

    const autoSizeStrategy = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : true
        };
      }, []);

      const autoSizeAll = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll = useCallback((event) =>{
            //console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            //console.log("Selected");
      }, []);

      const onColumnResized = useCallback((params) => {
        //console.log(params);
      }, []);

      const themeAG = useMemo(() => {
        return myTheme;
      }, []);
    
      const onRowSelected = useCallback((event) => {

      }, []);


    
      const onSelectionChanged = useCallback((event) => {

        
       
        let selDjel=[]
     

       
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selDjel.push(event.api.getSelectedNodes()[i].data.sifra_djel);

        }
        
       
        setSelectedZuteStr(selDjel);

        console.log("Selecteeeed");
        console.log(selDjel);
        console.log(event.api.getSelectedNodes()[0]);

     
      
      }, []);



      const handleSingleClickZute = (event) => {
        console.log("1 klik: ", event);
        console.log(event.node);
        cellClicked(event.node);
      };
    
      const handleDoubleClickZute = (event) => {
        console.log("2 klika:", event);


        console.log(event.node);
        console.log(event.node.data);

        cellClicked(event.node);
        
        console.log("Chosen row!!!!!");

        console.log(sifra);
        console.log(tkcFirma)
        //console.log(row.naziv_djelatnosti)
        //console.log(row.fd_djel);

        Swal.fire({
            customClass: {
                container: 'my-swal'
                },
            title: "Želite li obrisati ili urediti odabranu djelatnost?",
            showDenyButton: true,
            showCancelButton: true,
            showConfirmButton:true,
            confirmButtonText: "Uredi",
            denyButtonText: 'Obriši',
            cancelButtonText: 'Odustani'
            }).then((result) => {
            if (result.isConfirmed) {


                console.log("Going to edit!!!!!!");


                setUlicaZute(event.node.data.Ulica)
                setSelectedUlicaZute({'ULICA_ID': event.node.data.sifra_ulice, 'NAZIV':event.node.data.Ulica});

                console.log(event.node.data.sifra_ulice);
                console.log(event.node.data.Ulica)
                setEditKBRZute(event.node.data.KBR?event.node.data.KBR:'');
                setEditAlfaZute(event.node.data.Alfa?event.node.data.Alfa:'');

                setEditNazivZute(event.node.data.Naziv);
                setEditKomentarZute(event.node.data.Komentar);
                setEditMrezaZute(event.node.data.Mreza);
                setEditTelZute(event.node.data.Tel);
                setEditKnjigaZute(event.node.data.Knjiga);
                setEditObjavaZute(event.node.data.Objava)

                setEditDjelZute(event.node.data.sifra_djel);

                setEditRedosZute(event.node.data.Redos)

                

                if(event.node.data.Objava==('naslov')){
                        console.log("Editiram naslov!!!");

                        setFlagEditZute(0)

                        setIsEditZute(true);

                        //editDjelatnostZute();
                } else {
                        console.log("Editiram strukturu!!!");

                        setFlagEditZute(1)

                        setIsEditZute(true);

                        //editStrukturaZute();

                }

       

                
            } else if (result.isDenied) {
                    
         

                console.log("Trebam obrisati");

                deleteDjelatnostZute(event.node.data.sifra_djel, sifra, tkcFirma);
                /*
                if(event.node.data.Objava.localeCompare('naslov')){
                        console.log("Brišem naslov!!!");

                        deleteDjelatnostZute(event.node.data.sifra_djel, sifra, tkcFirma);
                } else {
                        console.log("Editiram strukturu!!!");

                        deleteStrukturaZute();

                }    
                */           

                
                
            }else if(result.isDismissed){
                console.log('Odusataoooooo')
            }
            });  



      };
    
    const debounceClickZute = useDebouncedClick(handleSingleClickZute, handleDoubleClickZute, 500);

    const cellClicked = useCallback((cell)=>{

   
                console.log("ClickedCell!")
               
                console.log(cell);

                console.log(cell.data.sifra_djel);
                setSelectedDjel(cell.data.sifra_djel);

                //let tmp = [];
                //tmp.push(cell.data.sifra_djel);
                //setSelectedZuteStr(tmp);

              


                //setMJESTO_ID(cell.data.MJESTO);



    })



const deleteDjelatnostZute = (sifra_djel, sifraTvrtke, tmpTKC) => {



    console.log("Deleting djelatnost");

    console.log(sifra_djel);


    console.log(tmpTKC);

    if(!tmpTKC || tmpTKC=="" || !sifraTvrtke || sifraTvrtke=="" || !sifra_djel || sifra_djel==''){

            toast.warning("Nije ispravno unešeni svi podaci potrebni za brisanje djelatnosti", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/deleteDjelatnostZute", {

                platform: '0',
                version:'1.0',
                tkc: tmpTKC,

                sifra: sifraTvrtke,
                sifra_djel: sifra_djel,

            }, {
                token
            }).then(response=>{
                
                console.log(response)

                setEditDjelZute(false);

                dispatch(actions.isNotLoading());

                
                    console.log(response)
                    if(response.status !== 200) {

                                    if(response.status == 401){

                                        console.log("Istekla sesija");

                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');

                                    } else{
                                    
                                        toast.error(response.data.message, toastError);

                                        

                                    }


                    } else {
                        console.log("Success");
                        console.log(response.data);

                        setZuteStranice(false);
                        toast.success(response.data.message, toastSuccess);





                    }

                
            
            }).catch(error=> {
                    
                    console.log(error);

                    dispatch(actions.isNotLoading());


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 

const editDjelatnostZute = () => {



    console.log("Editing djelatnost");



    console.log(editDjelZute);

    console.log(selectedUlicaZute);

    console.log(tkcFirma);

    console.log(sifra);



    if(!tkcFirma || tkcFirma=="" || !sifra || sifra=="" || !editDjelZute || editDjelZute=='' || !selectedUlicaZute || !selectedUlicaZute.ULICA_ID || selectedUlicaZute.ULICA_ID==''){

            toast.warning("Nije ispravno unešeni svi podaci potrebni za uređivanje djelatnosti", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/editDjelatnostZute", {

                platform: '0',
                version:'1.0',
                tkc: tkcFirma,

                sifra: sifra,
                sifra_djel: editDjelZute,
         
                mreza: editMrezaZute,
                tel: editTelZute,
                komentar: editKomentarZute,
                naziv: editNazivZute,
                ulica: selectedUlicaZute?(selectedUlicaZute.ULICA_ID?selectedUlicaZute.ULICA_ID:(selectedUlicaZute.ulica_id?selectedUlicaZute.ulica_id:'-2')):'-2',
                kbr: editKBRZute,
                alfa: editAlfaZute?editAlfaZute.toUpperCase():'',
                objava: editObjavaZute,
                knjiga: editKnjigaZute,
                ref: ref




            }, {
                token
            }).then(response=>{
                
                console.log(response)

                setEditDjelZute(false);

                dispatch(actions.isNotLoading());

                
                    console.log(response)
                    if(response.status !== 200) {

                                    if(response.status == 401){

                                        console.log("Istekla sesija");

                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');

                                    } else{
                                    
                                        toast.error(response.data.message, toastError);

                                        

                                    }


                    } else {
                        console.log("Success");
                        console.log(response.data);

                        setZuteStranice(false);
                        toast.success(response.data.message, toastSuccess);





                    }

                
            
            }).catch(error=> {
                    
                    console.log(error);

                    dispatch(actions.isNotLoading());


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 

const editStrukturaZute = () => {



    console.log("Editing djelatnost");

    console.log(editDjelZute);

    console.log(selectedUlicaZute);

    console.log(tkcFirma);

    console.log(sifra);



    if(!tkcFirma || tkcFirma=="" || !sifra || sifra=="" || !editDjelZute || editDjelZute=='' || !selectedUlicaZute || !selectedUlicaZute.ULICA_ID || selectedUlicaZute.ULICA_ID==''){

            toast.warning("Nije ispravno unešeni svi podaci potrebni za uređivanje strukture", toastInfo)

    } else {

            dispatch(actions.isLoading());

            APICall("/editStrukturaZute", {

                platform: '0',
                version:'1.0',
                tkc: tkcFirma,

                sifra: sifra,
                sifra_djel: editDjelZute,
         
                mreza: editMrezaZute,
                tel: editTelZute,
                komentar: editKomentarZute,
                naziv: editNazivZute,
                ulica: selectedUlicaZute?(selectedUlicaZute.ULICA_ID?selectedUlicaZute.ULICA_ID:(selectedUlicaZute.ulica_id?selectedUlicaZute.ulica_id:'-2')):'-2',
                kbr: editKBRZute,
                alfa: editAlfaZute?editAlfaZute.toUpperCase():'',
                objava: editObjavaZute,
                knjiga: editKnjigaZute,
                redos: editRedosZute,
                ref: ref




            }, {
                token
            }).then(response=>{
                
                console.log(response)

                dispatch(actions.isNotLoading());

                
                    console.log(response)

                    setEditDjelZute(false);
                    if(response.status !== 200) {

                                    if(response.status == 401){

                                        console.log("Istekla sesija");

                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');

                                    } else{
                                    
                                        toast.error(response.data.message, toastError);

                                        

                                    }


                    } else {
                        console.log("Success");
                        console.log(response.data);

                        setZuteStranice(false);
                        toast.success(response.data.message, toastSuccess);





                    }

                
            
            }).catch(error=> {
                    
                    console.log(error);

                    dispatch(actions.isNotLoading());


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 


const [isEditZute, setIsEditZute] = useState(false);
const [editMrezaZute, setEditMrezaZute] = useState('');
const [editTelZute, setEditTelZute] = useState('');
const [editNazivZute, setEditNazivZute] = useState('');


const [editKBRZute, setEditKBRZute] = useState('');
const [editAlfaZute, setEditAlfaZute] = useState('');
const [editKomentarZute, setEditKomentarZute] = useState('');
const [editObjavaZute, setEditObjavaZute] = useState('1');
const [editKnjigaZute, setEditKnjigaZute] = useState('1');

const [flagEditZute, setFlagEditZute] = useState(0);

const [editDjelZute, setEditDjelZute] = useState('');

const [editRedosZute, setEditRedosZute] = useState('');
               

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

/**************************************************PH GRID*********************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
const gridRef_PH = useRef();



const autoSizeStrategy_PH = useMemo(() => {
    return {
      type: "fitCellContents",
      skipHeader : true
    };
  }, []);

  const autoSizeAll_PH = useCallback((skipHeader) => {
    const allColumnIds = [];
    gridRef_PH.current.api.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef_PH.current.api.autoSizeColumns(allColumnIds, skipHeader);
  }, []);


  const onGridReady_PH = useCallback((event) => {
    console.log("Grid ready *********************************************************************************")
    let nodes = event.api.getRenderedNodes();
    autoSizeAll_PH();
    if (nodes.length) {
      //nodes[0].setSelected(true); //selects the first row in the rendered view
      //nodes[1].setSelected(true);
    }
  }, []);

  const selectAll_PH = useCallback((event) =>{
        //console.log("I wanna select it all!!!!!");

        event.api.selectAll();
        //console.log("Selected");
  }, []);

  const onColumnResized_PH = useCallback((params) => {
    //console.log(params);
  }, []);



  const onRowSelected_PH = useCallback((event) => {

  }, []);



  const onSelectionChanged_PH = useCallback((event) => {

  
  }, []);






 const cellClicked_PH = useCallback((cell)=>{


            console.log("ClickedCell!")
           
            console.log(cell);

            console.log(cell.data);


            GetPHDetalji(cell.data.id_subjekta);
    


 })


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

/**************************************************PH GRID*********************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
const gridRef_MB = useRef();



const autoSizeStrategy_MB = useMemo(() => {
    return {
      type: "fitCellContents",
      skipHeader : true
    };
  }, []);

  const autoSizeAll_MB = useCallback((skipHeader) => {
    const allColumnIds = [];
    gridRef_MB.current.api.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef_MB.current.api.autoSizeColumns(allColumnIds, skipHeader);
  }, []);


  const onGridReady_MB = useCallback((event) => {
    console.log("Grid ready *********************************************************************************")
    let nodes = event.api.getRenderedNodes();
    autoSizeAll_MB();
    if (nodes.length) {
      //nodes[0].setSelected(true); //selects the first row in the rendered view
      //nodes[1].setSelected(true);
    }
  }, []);

  const selectAll_MB = useCallback((event) =>{
        //console.log("I wanna select it all!!!!!");

        event.api.selectAll();
        //console.log("Selected");
  }, []);

  const onColumnResized_MB = useCallback((params) => {
    //console.log(params);
  }, []);



  const onRowSelected_MB = useCallback((event) => {

  }, []);



  const onSelectionChanged_MB = useCallback((event) => {

  
  }, []);






 const cellClicked_MB = useCallback((cell)=>{


            console.log("ClickedCell!")
           
            console.log(cell);

            console.log(cell.data);

            setMB_Current(cell.data.naziv);

            setChosenMB(cell.data);

    


 })


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

/**************************************************PROPS GRID******************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
const gridRef_Props = useRef();



const autoSizeStrategy_Props = useMemo(() => {
    return {
      type: "fitCellContents",
      skipHeader : true
    };
  }, []);

  const autoSizeAll_Props = useCallback((skipHeader) => {
    const allColumnIds = [];
    gridRef_Props.current.api.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef_Props.current.api.autoSizeColumns(allColumnIds, skipHeader);
  }, []);


  const onGridReady_Props = useCallback((event) => {
    console.log("Grid ready *********************************************************************************")
    let nodes = event.api.getRenderedNodes();
    //autoSizeAll_Props();
    if (nodes.length) {
      //nodes[0].setSelected(true); //selects the first row in the rendered view
      //nodes[1].setSelected(true);
    }
  }, []);

  const selectAll_Props = useCallback((event) =>{
        //console.log("I wanna select it all!!!!!");

        event.api.selectAll();
        //console.log("Selected");
  }, []);

  const onColumnResized_Props = useCallback((params) => {
    //console.log(params);
  }, []);



  const onRowSelected_Props = useCallback((event) => {

  }, []);



  const onSelectionChanged_Props = useCallback((event) => {
    //const rowCount = event.api.getSelectedNodes().length;
    //console.log("selection changed, " + rowCount + " rows selected");

 
  
  }, []);








 const handleCellDoubleClick = (params) => {
    const value = params.value;
  
    // Optional: only copy for certain columns
    // if (params.colDef.field !== 'name') return;

    console.log(params);
    console.log(params.value);
  
    if (params.colDef.field == 'Novi Telefon') {
            let tmpTel = '';
            if (value !== undefined && value !== null) {
                if(value.toString().startsWith('01')){

                    tmpTel = value.toString().slice(2);
            
                }else {
                    tmpTel = value.toString().slice(3);
            
                }
                navigator.clipboard.writeText(tmpTel)
                .then(() => {
                    console.log('Copied to clipboard:', tmpTel);
                    toast.success("Uspješno ste kopirali: " + tmpTel, toastSuccess);
                })
                .catch(err => {
                    console.error('Failed to copy:', err);
                });
            }    

    } else {
            if (value !== undefined && value !== null) {
            navigator.clipboard.writeText(value.toString())
                .then(() => {
                console.log('Copied to clipboard:', value);
                toast.success("Uspješno ste kopirali: " + value, toastSuccess);
                })
                .catch(err => {
                console.error('Failed to copy:', err);
                });
            }
    }
  };
  

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

/**************************************************TVRTKE GRID******************************************************************* */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const gridRef_Tvrtke = useRef();



const autoSizeStrategy_Tvrtke  = useMemo(() => {
    return {
      type: "fitCellContents",
      skipHeader : true
    };
  }, []);

  const autoSizeAll_Tvrtke  = useCallback((skipHeader) => {
    const allColumnIds = [];
    gridRef_Tvrtke .current.api.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
    gridRef_Tvrtke .current.api.autoSizeColumns(allColumnIds, skipHeader);
  }, []);


  const onGridReady_Tvrtke  = useCallback((event) => {
    console.log("Grid ready *********************************************************************************")
    let nodes = event.api.getRenderedNodes();
    autoSizeAll_Tvrtke ();
    if (nodes.length) {
      //nodes[0].setSelected(true); //selects the first row in the rendered view
      //nodes[1].setSelected(true);
    }
  }, []);



  const onColumnResized_Tvrtke  = useCallback((params) => {
    //console.log(params);
  }, []);



 const cellClicked_Tvrtke  = useCallback((cell)=>{


            let row = cell.data;
            console.log(row)
           
           
            console.log("Firma kontaktiiiiiiiiiiiiiiiiiiii");
            console.log(row.kontakti);
           
            setCurrentCompany(row);

            console.log("**************************Current comapny: *********************************");
            console.log(row)

            localStorage.setItem("lastComp", row.sifra);
            localStorage.setItem("lastCompTKC", row.tkc)
           
           
            setNaziv(row.naziv)
           
            setMjesto(row.NAZIV_MJESTA)
           
            setUlica(row.NAZIV_ULICA)
            

           
           
            setKbr(row.kbr)
           
           
            setKbr_znak(row.alfa);
           
            setKomentar(row.komentar)
           
            setKomentar2(row.komentar2)
           
            setSifra(row.sifra);
           
            setTkcFirma(row.tkc);
           
            console.log("Set firma tkc: ");
            console.log(row.tkc);
           
            console.log("Setting the data for company:");
            console.log(sifra);
            console.log(tkcFirma);
            console.log(row.tkc);
            console.log(row.sifra);
           
            setNazivKratki(row.naziv_kratki);
            setNazivMas(row.naziv_mas);
            setNazivNemas(row.naziv_nemas);
            setNazivZnak(row.naziv_znak)
            
           
            console.log("Objava tvrtke!!!");
            console.log(row.objava);
            console.log("Vrsta sloga");
            console.log(row.vrsta_sloga);
            setObjava(row.objava);
            setVrstaSloga(row.vrsta_sloga);
           
           
            let insertDate = new Date(row.dat_unosa);
            let azurDate = new Date(row.dat_zadnjeg_azur);
           
           
            const options = {
             
                year: "numeric",
                month: "numeric",
                day: "numeric",
              };
            let newFormInsert = insertDate.toLocaleDateString("hr-HR", options);
            let newFormAzur = azurDate.toLocaleDateString("hr-HR", options);
           
           
            setDatumUnos(newFormInsert);
            setDatumAzur(newFormAzur);
           
            setSelectedUlica({'ULICA_ID': row.sifra_ulice, 'NAZIV':row.NAZIV_ULICA?row.NAZIV_ULICA:row.naziv_ulica});

            console.log("Chosen ulica for company!!!!!");
            console.log(row.sifra_ulice);
            console.log(row.NAZIV_ULICA);
            console.log(row.naziv_ulica)

            setListUlice([selectedUlica]);
           
            setSelectedMjesto({'MJESTO_ID': row.MJESTO_ID, 'NAZIV':row.NAZIV_MJESTA});
           
            setMatBr(row.MB);
            setOIB(row.oib);
           
            console.log("Setting the TKC from company in function---------------");
           
           
            console.log("Gonna get strukture!!!!!");
           
            setDisableSelNet(true);
           
           
            setTvrtkeModal(false);
           
            console.log("Gonna get strukture!!!!!");
           
            getBijeleStrukture(row.sifra, row.tkc);

 })




/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

/**************************************************STRUKTURE GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

    const gridRef_Strukt = useRef();
    const containerStyle_Strukt = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle_Strukt = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy_Strukt = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : true
        };
      }, []);

      const autoSizeAll_Strukt = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Strukt.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Strukt.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady_Strukt = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Strukt();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll_Strukt = useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized_Strukt = useCallback((params) => {
        console.log(params);
      }, []);

      const themeAG_Strukt = useMemo(() => {
        return myTheme;
      }, []);
    

      const onRowSelected_Strukt = useCallback((event) => {
                //console.log("Row was selected:");
                //console.log(event.data);
      }, []);


    
      const onSelectionChanged_Strukt = useCallback((event) => {


        const rowCount = event.api.getSelectedNodes().length;
       
        let selStr=[]
     

       
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selStr.push(event.api.getSelectedNodes()[i].data);

        }
        
       
        setSelectedStrukt(selStr);


      }, []);



      const handleSingleClick = (event) => {
            console.log("1 klik: ");
            cellClicked_Strukt(event.node);
      };
    
      const handleDoubleClick = (event) => {
            
            console.log("2 klika:", event);

            console.log(event.node.data);


        
            setMemoStrukt(event.node.data);

            toast.success("Uspješno ste kopirali strukturu", toastSuccess);


      };
    
      const debounceClick = useDebouncedClick(handleSingleClick, handleDoubleClick, 500);


      const cellClicked_Strukt = useCallback((cell)=>{

   
            console.log("ClickedCell!")
        
            console.log(cell.data);


            console.log(cell.data.telefon);
            console.log(cell.data.mreza);
            let tmpPhone = "0" + cell.data.mreza + "" + cell.data.telefon;
            getDataPhone(tmpPhone);
            console.log(cell.data);
            setNewStrukt(false);
            setNewStruktChecked(false);
            setRedosStrukt(cell.data.redos)
            setNivoStrukt(cell.data.nivo);
            setMrezaStrukt(cell.data.mreza);
            setTelStrukt(cell.data.telefon);


            //let tmp = cell.data.objava==7?false:true;
            //console.log(tmp)
            //setObjavaStrukt(tmp);
            //if(tmp) { setObjavaStruktChecked('DA')} else {setObjavaStruktChecked('NE')};

            setObjavaStrukt(cell.data.objava);
            setObjavaStruktChecked(cell.data.objava);




            setUlicaStrukt(cell.data.ulica_naziv);
            setSelectedUlicaST({'ULICA_ID': cell.data.sifr_ul, 'NAZIV':cell.data.ulica_naziv});
            setKbrStrukt(cell.data.kbr?cell.data.kbr:'');
            setKbr_znakStrukt(cell.data.alfa?cell.data.alfa:'');



            setNazivStrukt(cell.data.naziv);
            setKomentStrukt(cell.data.komentar?cell.data.komentar:'');
            setDatStr1(cell.data.datum_unosa);
            setDatStr2(cell.data.dat_zadnjeg_azur);
            setKnjigaStrukt(cell.data.knjiga);
            setPojam1Strukt(cell.data.pojam1);
            setPojam2Strukt(cell.data.pojam2);
            setPojam3Strukt(cell.data.pojam3);

            setBelow(false);
            setAbove(false);

            
            setWebPodruznice(cell.data.podruznica)

            

            //setMemoStrukt(row);


            

    })


    const handleUp =(chosenData)=>{

        console.log(chosenData)
        setRedosStrukt('')
        setNivoStrukt('')
        setMrezaStrukt('')
        setTelStrukt('')
        
        //setObjavaStrukt(false);
        //setObjavaStruktChecked('NE');

        setObjavaStrukt(1);
        setObjavaStruktChecked(1);
        

        setUlicaStrukt('')
        setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});

        setKbrStrukt('')
        setKbr_znakStrukt('');

        setNazivStrukt('')
        setKomentStrukt('')
        setDatStr1('')
        setDatStr2('')
        setKnjigaStrukt('')
        setPojam1Strukt('')
        setPojam2Strukt('')
        setPojam3Strukt('')
        console.log("Dodajem iznad");

        console.log(chosenData.redos)

        if(chosenData.redos == 1){

            //prva je, stavi prvu na neku kasniju poziciju, ovo stavi kao prvo

            let tmp = chosenData.redos;
            
            setNewStrukt(true);
            setNewStruktChecked(true);
            setRedosStrukt(tmp);
            setChangeRedos(chosenData);
            setAbove(true);

        } else {

            let tmp = chosenData.redos;
            
            setNewStrukt(true);
            setNewStruktChecked(true);
            setRedosStrukt(tmp);
            setChangeRedos(chosenData);

            setAbove(true);
        }
    }
    const handleDown =(chosenData)=>{

        console.log("Dodajem ispod!!!!!")


        setRedosStrukt('')
        setNivoStrukt('')
        setMrezaStrukt('')
        setTelStrukt('')
        
        //setObjavaStrukt(false);
        //setObjavaStruktChecked('NE');
 
        setObjavaStrukt(1);
        setObjavaStruktChecked(1);        
        

        setUlicaStrukt('')
        setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
        setKbrStrukt('');
        setKbr_znakStrukt('');
        
        setNazivStrukt('')
        setKomentStrukt('')
        setDatStr1('')
        setDatStr2('')
        setKnjigaStrukt('')
        setPojam1Strukt('')
        setPojam2Strukt('')
        setPojam3Strukt('')
        console.log("Dodajem ispod");
        console.log(chosenData)



        if(chosenData.redos < 10 && chosenData.redos!= 9){
            let tmp = chosenData.redos + 1;
            setNewStrukt(true);
            setNewStruktChecked(true)
            setRedosStrukt(tmp)
            console.log("Dodan");
            console.log(tmp)
            setBelow(true)
        }else if(chosenData.redos>=10 && chosenData.redos!=90 && chosenData.redos%10==0){
            let tmp = chosenData.redos + 10;
            setRedosStrukt(tmp)    
            setNewStrukt(true);
            setNewStruktChecked(true) 
            console.log("Dodan");
            console.log(tmp)      
            setBelow(true)                                                             

                       
        } else {

             let tmp = chosenData.redos + 1;
            setRedosStrukt(tmp) 
            setBelow(true)
            setNewStrukt(true);
            setNewStruktChecked(true)
            console.log("Dodanooooo");
            console.log(tmp)
        }

    }


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


     const [sortType, setSortType] = useState(0);

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */



    const [tableDataModal, setTableDataModal] = useState ([]);
    const [openModal, setOpenModal] = useState(true);



    const handleOpen = () => setOpenModal(true);
    const handleClose = () => setOpenModal(false);



    const [curr_time, setCurrTime] = useState('');

    const token = localStorage.getItem("token");

    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");

    const lastComp = localStorage.getItem("lastComp");
    const lastCompTKC = localStorage.getItem("lastCompTKC");

    const location = useLocation();


    const { row } = location.state?location.state:'';






    const [listOfPozivni, setListOfPozivni] = useState([]);

    const [selectedNetwork, setSelectedNetwork] = useState(null);

    const [disableSelNet, setDisableSelNet] = useState(false);

    

   

    //*----------------------------------*/

    const [isPoslovnaHrvaska, setIsPoslovnaHrvaska] = useState(false)

    const [OIBIzBijelihStranica, setOIBIzBijelihStranica] = useState("")
    const [zadajOIB, setZadajOIB] = useState("")
    const [zadajDioNaziva, setZadajDioNaziva] = useState("")
    const [zadajMjesto, setZadajMjesto] = useState("")
    const [zadajPTT, setZadajPTT] = useState("")
    //*----------------------------------*/
    const dispatch = useDispatch()

    const [isDragging, setIsDragging] = useState(false)
    const [modalPosition, setModalPosition] = useState({x:0,y:0})
    const startPosition = useRef({x:0,y:0})
    const popupRef = useRef(null)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false);

    const [zuteStranice, setZuteStranice] = useState(false)
    const [MB, setMB] = useState(false)
    const [tableDataMB, setTableDataMB] = useState([])
    const [tableDataZuteStranice, setTableDataZuteStranice] = useState([],[])

    const [tvrtkeModal, setTvrtkeModal] = useState(false)
    const [tableDataZuteTvrtke, setTableDataZuteTvrtke] = useState()
    const navigate = useNavigate();

    const [naziv, setNaziv] = useState('');
    const [sifra, setSifra] = useState('');
    const [ulica, setUlica] = useState('');
    const [mjesto, setMjesto] = useState('');
    const [kbr, setKbr] = useState('');
    const [kbr_znak, setKbr_znak] = useState('');
    const [komentar, setKomentar] = useState('');
    const [komentar2, setKomentar2] = useState('');

    const [MB_Current, setMB_Current] = useState('');
    const [chosenMB, setChosenMB] = useState(null);
    const [memoMBName, setMemoMBName] = useState('');
    const [memoMBTKC, setMemoMBTKC] = useState('');
    const [memoMBSifra, setMemoMBSifra] = useState('');
    const [memoMB, setMemoMB] = useState(null);

    const [objava, setObjava] = useState(null);
    const [MatBr, setMatBr] = useState('');
    const [OIB, setOIB] = useState('');
    const [kontakti, setKontakti] = useState('');






    const [nazivKratki, setNazivKratki] = useState('');
    const [nazivMas, setNazivMas] = useState('');
    const [nazivNemas, setNazivNemas] = useState('');
    const [nazivZnak, setNazivZnak] = useState('');



    const [datumUnos, setDatumUnos] = useState('');
    const [datumAzur, setDatumAzur] = useState('');


    const [nivoStrukt, setNivoStrukt] = useState('');
    const [mrezaStrukt, setMrezaStrukt] = useState('');
    const [telStrukt, setTelStrukt] = useState('');
    const [objavaStrukt, setObjavaStrukt] = useState(1);
    const [objavaStruktChecked, setObjavaStruktChecked] = useState(1);
    const [ulicaStrukt, setUlicaStrukt] = useState('');
    const [kbrStrukt, setKbrStrukt] = useState('');
    const [kbr_znakStrukt, setKbr_znakStrukt] = useState('');

    const [nazivStrukt, setNazivStrukt] = useState('');
    const [komentStrukt, setKomentStrukt] = useState('');
    const [dateStr1, setDatStr1] = useState('');
    const [dateStr2, setDatStr2] = useState('');
    const [knjigeStrukt, setKnjigaStrukt] = useState('');
    const [pojam1Strukt, setPojam1Strukt] = useState('');
    const [pojam2Strukt, setPojam2Strukt] = useState('');
    const [pojam3Strukt, setPojam3Strukt] = useState('');
    const [redosStrukt, setRedosStrukt] = useState('');

    const [webPodruznice, setWebPodruznice] = useState('');

    const [tkcFirma, setTkcFirma] = useState('');
    const [listUlice, setListUlice] = useState([]);
    const [listUliceST, setListUliceST] = useState([]);
    const [listUliceZute, setListUliceZute] = useState([]);
    const [selectedUlica, setSelectedUlica] = useState({ULICA_ID:'', NAZIV:''});
    const [selectedUlicaST, setSelectedUlicaST] = useState({ULICA_ID:'', NAZIV:''});
    const [selectedUlicaZute, setSelectedUlicaZute] = useState({ULICA_ID:'', NAZIV:''});

    const [ulicaZute, setUlicaZute] = useState('');

    
    const [listMjesta, setListMjesta] = useState([]);
    const [selectedMjesto, setSelectedMjesto] = useState({MJESTO_ID:'', NAZIV:''});

    const [propsNaziv, setPropsNaziv] = useState('');
    const [propsRow, setPropsRow] = useState([], []);
    const [propsTelefon, setPropsTelefon] = useState('');
    const [propsMjesto, setPropsMjesto] = useState('');
    const [propsMjesto_ID, setPropsMjesto_ID] = useState('');
    const [propsAdresa, setPropsAdresa] = useState('');
    const [propsPTT, setPropsPTT] = useState('');

    const [propsInfo, setPropsInfo] = useState(false);
    const [propsInfoVisible, setPropsInfoVisible] = useState(false);

    const [vrstaSloga, setVrstaSloga] = useState(null);

    const [below, setBelow] = useState(false);
    const [above, setAbove] = useState(false);

    const [searchParams, setSearchParams] = useSearchParams();

    const [selectedDjel, setSelectedDjel] = useState('');
    const [newDjel, setNewDjel] = useState(false);


    const [struktureArr, setStruktureArr] = useState([],[]);
        

    const [newStrukt, setNewStrukt] = useState(false);
    const [newStruktChecked, setNewStruktChecked] = useState(false);

    const [newCompany, setNewCompany] = useState(false);
    const [newCompanyChecked, setNewCompanyChecked] = useState(false);

    const [changeRedos, setChangeRedos] = useState('');

    
    const [bureInfo, setBureInfo] = useState('');

    const [addNazivContainerIsVisible,setAddNazivContainerIsVisible] = useState("")
    const [searchNaziv, setSearchNaziv] = useState("");
    const [allDjelatnosti, setAllDjelatnosti] = useState([])



    const [addNew, setAddNew] = useState(false);

    const [companyAdded, setCompanyAdded] = useState(false);

    const [filteredTableData, setFilteredTableData] = useState([])

    const [memoStrukt, setMemoStrukt] = useState('');

    const [selectedStrukt, setSelectedStrukt] = useState([]);
    const [selectedZuteStr, setSelectedZuteStr] = useState([]);

    const [phCompany, setPHCompany] = useState([],[]);

    const [phNaziv, setPHNaziv] = useState('');

    const [phOIB, setPHOIB] = useState('');

    const [phSubjekt, setPHSubjekt] = useState('');

    const [phBlokiran, setPHBlokiran] = useState('');

    const [phOsnovano, setPHOsnovano] = useState('');

    const [phVlasnik, setPHVlasnik] = useState('');

    const [phOdgovoran, setPHOdgovoran] = useState('');

    const [phZaposleni, setPHZaposleni] = useState('');

    const [phPrihodi, setPHPrihodi] = useState('');

    const [phRashodi, setPHRashodi] = useState('');

    const [phMjesto, setPHMjesto] = useState('');
    const [phPTT, setPHPTT] = useState('');
    const [phAdresa, setPHAdresa] = useState('');
    const [phOpis, setPHOpis] = useState('');
    const [phPravni, setPHPravni] = useState('');
    const [phRegSud, setPHRegSud] = useState('');
    const [phTel, setPHTel] = useState('');
    const [phMob, setPHMob] = useState('');
    const [phMail, setPHMail] = useState('');
    const [phAktivan, setPHAktivan] = useState('');
  


    const [currentIDFocus, setCurrentIDFocus] = useState(null);

    const nazMas_ref = useRef(null);
    const nazZnak_ref = useRef(null);
    const nazNemas_ref = useRef(null);
    const mb_ref = useRef(null);
    const oib_ref = useRef(null);
    const kontakti_ref = useRef(null);
    const mjesto_ref = useRef(null);
    const ulica_ref = useRef(null);
    const kbr_ref = useRef(null);
    const kbrZnak_ref = useRef(null);
    const komentar1_ref = useRef(null);
    const komentar2_ref = useRef(null);
    const pojam1_ref = useRef(null);
    const pojam2_ref = useRef(null);
    const pojam3_ref = useRef(null);

    const nivoStrukt_ref = useRef(null);
    const redosStrukt_ref = useRef(null);
    const mrezaStrukt_ref = useRef(null);
    const telStrukt_ref = useRef(null);
    const nazivStrukt_ref = useRef(null);
    const ulicaStrukt_ref = useRef(null);
    const kbrStrukt_ref = useRef(null);
    const kbrZnakStrukt_ref = useRef(null);
    const webStrukt_ref = useRef(null);
    const komentarStrukt_ref = useRef(null);
    const pojam1Strukt_ref = useRef(null);
    const pojam2Strukt_ref = useRef(null);
    const pojam3Strukt_ref = useRef(null);


    const ulica_refZute = useRef(null);
    const kbr_refZute = useRef(null);
    const kbrZnak_refZute = useRef(null);

    




/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************STATE VARIJABLE**************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


const toastError = {                                                        
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
};

const toastSuccess = {                                                        
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
};

const toastInfo = {                                                        
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
};


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************USE EFFECT********************************************************************************* */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

useEffect(() => {


    GetPozivni();

    console.log("Opening bijele*********************************************************")
    console.log(lastComp);

    const storedData = sessionStorage.getItem("selectedNet");

    console.log(storedData)
    if (storedData) {

        console.log("Found stored data somehow?")
        try {
            const parsedData = JSON.parse(storedData);
            setSelectedNetwork(parsedData);
            console.log(parsedData);
            } catch (error) {
            console.error("Error parsing sessionStorage:", error);
            sessionStorage.removeItem("selectedNet"); 
            }

    }

    console.log("location", location) //HERE IS THE INFORMATION COMING FROM THE DNEVNEPROMJENE***
    setModalIsOpen(props.bijeleStraniceIsOpen)




    console.log("props", props)

    let tmp = new Date();

    console.log(tmp);

    tmp.setMinutes(tmp.getMinutes() - 25);

    console.log(tmp);

    let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();

    console.log(timeNow);

    
    setCurrTime(timeNow);

    console.log("props", props)

    if(props.state && props.state.row && props.state.row!=''){

                    console.log("PropsState")
                    console.log(props.state);

                    if(props.state.currentCodeBijele && props.state.currentCodeBijele!='' &&
                        props.state.currentTKCBijele && props.state.currentTKCBijele!='' 
                    ){

                                console.log("Dobili smo company i tkc!!");

                                let tmpCode = props.state.currentCodeBijele;
                    
                                let tmpTKC = props.state.currentTKCBijele;
                    
                                console.log(tmpCode);
                    
                                console.log(tmpTKC);
                    
                                setSifra(tmpCode);

                                let sel = '';

                                console.log(listOfPozivni);
                    
                            
                                if(tmpTKC && tmpTKC!='' && listOfPozivni && listOfPozivni.length!=0){
                                    const selected = listOfPozivni.find((obj) => {
                                        console.log("Checking");
                                        console.log(obj);
                                        console.log(obj.pozivni);
                                        console.log(tmpTKC);
                                        
                                        if (obj.tkc === tmpTKC)
                                        return obj;
                                    });
                                    console.log(selected);
                                    setSelectedNetwork(selected);
                        
                                    sel = selected;
                                    sessionStorage.setItem("selectedNet", JSON.stringify(selected));
                        
                                } else {
                        
                                    sel = {pozivni:'', tkc:''}
                                    console.log("Setting");
                                    console.log(sel);
                                    setSelectedNetwork(sel);
                                    sessionStorage.setItem("selectedNet", JSON.stringify(sel));
                        
                                }


                    
                                console.log("Calling the function!!!");
                    
                                getFirmaBijeleNazivSifraWithParams('', tmpCode, tmpTKC);

                                                            //setNaziv(props.state.row.Naziv);


                                let tmpRow = [];

                                tmpRow.push(props.state.row);

                                console.log("DOLAZNI PODACI--------------------------");
                                console.log(props.state.row);
                       

                                let columns= Object.getOwnPropertyNames(tmpRow[0]).map((column,index)=>{
                                var a = column.charAt(0).toUpperCase() + column.slice(1)
                                    return(
                                        {
                                            "field": column,
                                            "getRowId": index
                                        }
                                    )
                                })


                                const updatedColumns = columns.map((col) => {
                

                                    if(col.field == "Novi naziv"){
                                        return {
                                            field: col.field,
                                            headerName: 'Naziv',
                                            
                                        }
                                    }else if(col.field== "Novi Telefon"){
                                        return {
                                            field: col.field,
                                            headerName: 'Telefon',
                                            
                                        }
                                    } else if(col.field=='newMjesto'){
        
                                        return {
                                            field: col.field,
                                            headerName: 'Mjesto',
                                            
                                        }
                                    }else if(col.field== 'newUlica'){
                                        return {
                                            field: col.field,
                                            headerName: 'Adresa',
                                            
                                        }
                                    }else if(col.field== 'newKBR'){
                                        return {
                                            field: col.field,
                                            headerName: 'KBR',
                                            
                                        }
                                    }else if(col.field== 'newKBR_Dod'){
                                        return {
                                            field: col.field,
                                            headerName: 'KBR znak',
                                            
                                        }
                                    }else if(col.field== 'OIB_n'){
                                        return {
                                            field: col.field,
                                            headerName: 'OIB',
                                            
                                        }
                        
                                    } else {
        
                                        return {
                                            field: col.field,
                                            hide:true
                                            
                                        }
                                    }
                    
                    
                                    //return col;
                                });
                    
                    
                                columns = updatedColumns;



                                let rows = tmpRow.map((item, index)=> {
                                    return({...item,id:index})
                                })

                                setPropsRow({
                                        columns,
                                        rows
                                })






                                setPropsNaziv(props.state.row.Naziv);
                                setPropsTelefon(props.state.row["Novi Telefon"]);
                                setPropsMjesto(props.state.row.Mjesto);
                                setPropsMjesto_ID(props.state.row.MJESTO);
                                setPropsAdresa(props.state.row.Adresa);
                                setPropsPTT(props.state.row.PTT);

                                setPropsInfo(true);

                    } else {


                    

                            //setNaziv(props.state.row.Naziv);

                            console.log(props.state.row.Naziv);

                            let tmpRow = [];

                            tmpRow.push(props.state.row);

                            

                            let columns= Object.getOwnPropertyNames(tmpRow[0]).map((column,index)=>{
                            var a = column.charAt(0).toUpperCase() + column.slice(1)
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index
                                    }
                                )
                            })


                            const updatedColumns = columns.map((col) => {
            

                                if(col.field == "Naziv"){
                                    return {
                                        field: col.field,
                                        headerName: 'Naziv',
                                        
                                    }
                                }else if(col.field== "Novi Telefon"){
                                    return {
                                        field: col.field,
                                        headerName: 'Telefon',
                                        
                                    }
                                } else if(col.field=='Mjesto'){
    
                                    return {
                                        field: col.field,
                                        headerName: 'Mjesto',
                                        
                                    }
                                }else if(col.field== 'Adresa'){
                                    return {
                                        field: col.field,
                                        headerName: 'Adresa',
                                        
                                    }
                                }else if(col.field== 'OIB'){
                                    return {
                                        field: col.field,
                                        headerName: 'OIB',
                                        
                                    }
                     
                                } else {
    
                                    return {
                                        field: col.field,
                                        hide:true
                                        
                                    }
                                }
                
                
                                //return col;
                            });
                
                
                            columns = updatedColumns;



                            let rows = tmpRow.map((item, index)=> {
                                return({...item,id:index})
                            })

                            setPropsRow({
                                    columns,
                                    rows
                            })






                            setPropsNaziv(props.state.row.Naziv);
                            setPropsTelefon(props.state.row["Novi Telefon"]);
                            setPropsMjesto(props.state.row.Mjesto);
                            setPropsMjesto_ID(props.state.row.MJESTO);
                            setPropsAdresa(props.state.row.Adresa);
                            setPropsPTT(props.state.row.PTT);

                            setPropsInfo(true);



                            //getFirmaBijeleNazivSifra(props.state.row.Naziv, '');

                            
                            //toast.info("Nisu pronađeni podaci o traženoj tvrtci u bazi podataka", toastError);  
                    
                    }

    } else if(searchParams.get("companyCode") && searchParams.get("companyCode")!=''){

        console.log("Došli smo preko search query podataka!");

        let tmpCode = searchParams.get("companyCode")?searchParams.get("companyCode"):'';

        let tmpTKC = searchParams.get("tkc")?searchParams.get("tkc"):'';

        console.log(searchParams.get("companyCode"));

        console.log(searchParams.get('tkc'));

        setSifra(searchParams.get("companyCode"));


        let sel = '';

        if(tmpTKC && tmpTKC!='' && listOfPozivni &&listOfPozivni.length!=0){
                const selected = listOfPozivni.find((obj) => {
                    console.log("Checking");
                    console.log(obj);
                    console.log(obj.pozivni);
                    console.log(tmpTKC);
                    
                    if (obj.tkc === tmpTKC)
                    return obj;
                });
                console.log(selected);
                setSelectedNetwork(selected);

                sel = selected;
                sessionStorage.setItem("selectedNet", JSON.stringify(selected));

        } else {

                sel = {pozivni:'', tkc:''}
                console.log("Setting");
                console.log(sel);
                setSelectedNetwork(sel);
                sessionStorage.setItem("selectedNet", JSON.stringify(sel));

        }

        console.log("Calling the function!!!");

        console.log(tmpCode);
        console.log(tmpTKC);

        getFirmaBijeleNazivSifraWithParams('', tmpCode, tmpTKC);




    } else {

            console.log("Nema ničeg!!!");
    }



}, []);


useEffect(()=>{

    console.log("Shoould I retitle???????????????????????????????????")
    console.log(props.bijeleStraniceIsOpen)
    if(!props.bijeleStraniceIsOpen){

        document.title="Bijele stranice"
    }
},[])

/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*************************************FUNKCIJE*********************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const GetPozivni = async() => {
    dispatch(actions.isLoading());
    await  APICall("/GetPozivni", {
      platform: '0',
      version:'1.0'
    },{
      token
    }).then(response =>{
            if(response.status !== 200) {

              if(response.status == 401){

                      console.log("Istekla sesija");

                      toast.error(response.data.message, toastError);
                      
                      dispatch(actions.logOut());
                      navigate('/');

              } else{

                      //toast.error(response.data.message, toastError);

              }


          } else {
              

                  let tmp = response.data.list;
                  tmp = tmp.sort((a,b) => a.pozivni - b.pozivni);

                  console.log("aaaaaaaaaaa list of pozivni seeeeeeeeeeet")

                  setListOfPozivni(tmp);
          }


          if (response==undefined) dispatch(actions.isNotLoading());
    })
    dispatch(actions.isNotLoading());
};

const handleChange = (event) => {

    console.log(event.target);

    let sel = '';

    if(event.target.value && event.target.value!=''){
            const selected = listOfPozivni.find((obj) => {
                console.log("Checking");
                console.log(obj);
                console.log(obj.pozivni);
                console.log(event.target.value);
                
                if (obj.pozivni === event.target.value)
                return obj;
            });
            console.log(selected);
            setSelectedNetwork(selected);

            sel = selected;
            sessionStorage.setItem("selectedNet", JSON.stringify(selected));

    } else {

            sel = {pozivni:'', tkc:''}
            console.log("Setting");
            console.log(sel);
            setSelectedNetwork(sel);
            sessionStorage.setItem("selectedNet", JSON.stringify(sel));

    }

    console.log("Did the network change!!!");


};


const [currentCompany, setCurrentCompany] = useState(null);

async function getFirmaBijeleNazivSifraWithParams(naz, sif, tk) {



    let tmp = tk?tk:'';

    console.log(naz);
    console.log(sif);
    console.log(tk);

    console.log("Searching for it!!!");


    dispatch(actions.isLoading());


    APICall(
        '/GetBijeleNazivSifra',
        {

            platform: '0',
            version:'1.0',
            naziv: naz,
            sifra: sif,
            tkc: tmp

        },
        {
            token
        }).then(

            (response) => {
                console.log(response)
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                if (response.status==200) {

                    if(response.data.list && response.data.list.length > 1){
                                    
                                    
                                    var dataTmp = response.data.list;
                                    
                                    console.log(dataTmp)

                                    let i = 0;

                                    let columns= Object.getOwnPropertyNames(dataTmp[0]).map((column,index)=>{

                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index
                                            }
                                        )
                                    })


                                    const updatedColumns = columns.map((col) => {
                    
    
                                        if(col.field == "sifra"){
                                            return {
                                                field: col.field,
                                                headerName: 'Šifra',
                                                
                                            }
                                        }else if(col.field== 'oib'){
                                            return {
                                                field: col.field,
                                                headerName: 'OIB',
                                                
                                            }
                                        } else if(col.field=='naziv'){
            
                                            return {
                                                field: col.field,
                                                headerName: 'Naziv',
                                                
                                            }
                                        }else if(col.field== 'vrsta_sloga'){
                                            return {
                                                field: col.field,
                                                headerName: 'Vrsta sloga',
                                                
                                            }
                                        }else if(col.field== 'tkc'){
                                            return {
                                                field: col.field,
                                                headerName: 'TKC',
                                                
                                            }
                                        }else if(col.field== 'objava'){
                                            return {
                                                field: col.field,
                                                headerName: 'Objava',
                                                
                                            }
                                        }else if(col.field== 'NAZIV_ULICA'){
                                            return {
                                                field: col.field,
                                                headerName: 'Ulica',
                                                
                                            }
                                        }else if(col.field== 'NAZIV_MJESTA'){
                                            return {
                                                field: col.field,
                                                headerName: 'Mjesto',
                                                
                                            }
                                        }else if(col.field== 'kbr'){
                                            return {
                                                field: col.field,
                                                headerName: 'Kbr',
                                                
                                            }
                                        }else if(col.field== 'alfa'){
                                            return {
                                                field: col.field,
                                                headerName: 'Znak',
                                                
                                            }
                                        } else if(col.field == 'datum_unosa'){
                        
                                            return {
                                                ...col,
                                                headerName:'Datum',
                                                valueFormatter: ({ value }) => {
                                                if (value) {
                                                    
                                                
                                                    let date = new Date(value);
                        
                        
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                    
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    };
                                                    return date.toLocaleDateString("hr-HR", options);
                                                    
                                                
                                                }
                                                return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                                },
                                            };
                                            
                        
                                        } else if(col.field== 'datum_zadnjeg_azur'){
            
                                            return {
                                                ...col,
                                                headerName:'Zadnje ažuriranje',
                                                valueFormatter: ({ value }) => {
                                                if (value) {
                                                    
                                                
                                                    let date = new Date(value);
                        
                        
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                    
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    };
                                                    return date.toLocaleDateString("hr-HR", options);
                                                    
                                                
                                                }
                                                return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                                },
                                            };
                                            
                                        } else {
            
                                            return {
                                                field: col.field,
                                                hide:true
                                                
                                            }
                                        }
                        
                        
                                        //return col;
                                    });
                        
                        
                                    columns = updatedColumns;



                                    let rows =dataTmp.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setTableDataZuteTvrtke({
                                            columns,
                                            rows
                                    })

                                    setTvrtkeModal(true)






                    } else if(response.data.list && response.data.list.length==1){

                                    console.log("Chosen:");

                                    console.log(response.data.list[0]);

                                    let row = response.data.list[0];

                                    setCurrentCompany(row);
                                    console.log("**************************Current comapny: *********************************");
                                    console.log(row)

                                                                        localStorage.setItem("lastComp", row.sifra)
                                    localStorage.setItem("lastCompTKC", row.tkc)


                                    console.log("Firma kontaktiiiiiiiiiiiiiiiiiiii");
                                    console.log(row.kontakti);




                                    setNaziv(row.naziv)
                        
                                    setMjesto(row.NAZIV_MJESTA)

                                    setUlica(row.NAZIV_ULICA)

                                    setKbr(row.kbr)

                                    setKbr_znak(row.alfa);

                                    setKomentar(row.komentar)

                                    setKomentar2(row.komentar2)

                                    setSifra(row.sifra);

                                    setTkcFirma(row.tkc);

                                    console.log("Setting the data for company:");
                                    console.log(sifra);
                                    console.log(tkcFirma);
                                    console.log(row.tkc);
                                    console.log(row.sifra);

                                    setNazivKratki(row.naziv_kratki);
                                    setNazivMas(row.naziv_mas);
                                    setNazivNemas(row.naziv_nemas);

                                    setNazivZnak(row.naziv_znak);
                                    

                                    console.log("Objava tvrtke!!!");
                                    console.log(row.objava);
                                    console.log("Vrsta sloga");
                                    console.log(row.vrsta_sloga);
                                    setObjava(row.objava);
                                    setVrstaSloga(row.vrsta_sloga);


                                    let insertDate = new Date(row.dat_unosa);
                                    let azurDate = new Date(row.dat_zadnjeg_azur);

                                
                                    const options = {
                                    
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                    };
                                    let newFormInsert = insertDate.toLocaleDateString("hr-HR", options);
                                    let newFormAzur = azurDate.toLocaleDateString("hr-HR", options);


                                    setDatumUnos(newFormInsert);
                                    setDatumAzur(newFormAzur);

                                    setSelectedUlica({'ULICA_ID': row.sifra_ulice, 'NAZIV':row.NAZIV_ULICA});

                                    setSelectedMjesto({'MJESTO_ID': row.MJESTO_ID, 'NAZIV':row.NAZIV_MJESTA});

                                    setMatBr(row.MB);
                                    setOIB(row.oib);

                                    console.log("Setting the TKC from company in function---------------");


                                    console.log("Gonna get strukture!!!!!");

                                    setDisableSelNet(true);

                                    getBijeleStrukture(row.sifra, row.tkc);

                                    setTableDataZuteTvrtke([],[]);


                    } else {

                                    console.log("Nema tvrtke?");

                                    toast.error("Nije pronađena nijedna tvrtka s traženim parametrima, molimo provjerite naziv i/ili šifru tvrtke", toastError);

                                    setDisableSelNet(false);

                                    setTableDataZuteTvrtke([],[]);


                    }
                
                } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            setTableDataZuteTvrtke([],[]);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                    toast.error(response.data.message, toastError);

                                    setDisableSelNet(false);
                            }

                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   
                setTableDataZuteTvrtke([],[]);

            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            setDisableSelNet(false);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                                setDisableSelNet(false);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);

                                            setDisableSelNet(false);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  

async function getFirmaBijeleNazivSifra() {



        console.log("Getting the company!!!");

        let tmp = selectedNetwork?selectedNetwork.tkc:'';

        console.log(selectedNetwork)
        console.log(tmp)

        dispatch(actions.isLoading());

 
        APICall(
            '/GetBijeleNazivSifra',
            {

                platform: '0',
                version:'1.0',
                naziv: naziv,
                sifra: sifra,
                tkc: tmp

            },
            {
                token
            }).then(

                (response) => {
                    console.log(response)
                    
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());

                    if (response.status==200) {
                        if(response.data.list && response.data.list.length > 1){
 
                        
                        
                                    var dataTmp = response.data.list;
                                    
                                    console.log(dataTmp)


                                    let columns= Object.getOwnPropertyNames(dataTmp[0]).map((column,index)=>{
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index
                                            }
                                        )
                                    })




                                    const updatedColumns = columns.map((col) => {
                                
                
                                        if(col.field == "sifra"){
                                            return {
                                                field: col.field,
                                                headerName: 'Šifra',
                                                
                                            }
                                        }else if(col.field== 'oib'){
                                            return {
                                                field: col.field,
                                                headerName: 'OIB',
                                                
                                            }
                                        } else if(col.field=='naziv'){

                                            return {
                                                field: col.field,
                                                headerName: 'Naziv',
                                                
                                            }
                                        }else if(col.field== 'vrsta_sloga'){
                                            return {
                                                field: col.field,
                                                headerName: 'Vrsta sloga',
                                                
                                            }
                                        }else if(col.field== 'tkc'){
                                            return {
                                                field: col.field,
                                                headerName: 'TKC',
                                                
                                            }
                                        }else if(col.field== 'objava'){
                                            return {
                                                field: col.field,
                                                headerName: 'Objava',
                                                
                                            }
                                        }else if(col.field== 'NAZIV_ULICA'){
                                            return {
                                                field: col.field,
                                                headerName: 'Ulica',
                                                
                                            }
                                        }else if(col.field== 'NAZIV_MJESTA'){
                                            return {
                                                field: col.field,
                                                headerName: 'Mjesto',
                                                
                                            }
                                        }else if(col.field== 'kbr'){
                                            return {
                                                field: col.field,
                                                headerName: 'Kbr',
                                                
                                            }
                                        }else if(col.field== 'alfa'){
                                            return {
                                                field: col.field,
                                                headerName: 'Znak',
                                                
                                            }
                                        } else if(col.field == 'datum_unosa'){
                        
                                            return {
                                                ...col,
                                                headerName:'Datum',
                                                valueFormatter: ({ value }) => {
                                                if (value) {
                                                    
                                                
                                                    let date = new Date(value);
                        
                        
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                    
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    };
                                                    return date.toLocaleDateString("hr-HR", options);
                                                    
                                                
                                                }
                                                return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                                },
                                            };
                                            
                        
                                        } else if(col.field== 'datum_zadnjeg_azur'){

                                            return {
                                                ...col,
                                                headerName:'Zadnje ažuriranje',
                                                valueFormatter: ({ value }) => {
                                                if (value) {
                                                    
                                                
                                                    let date = new Date(value);
                        
                        
                                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                                    const options = {
                                                    
                                                        year: "numeric",
                                                        month: "numeric",
                                                        day: "numeric",
                                                    };
                                                    return date.toLocaleDateString("hr-HR", options);
                                                    
                                                
                                                }
                                                return value;
                                                },
                                                sortComparator: (v1, v2) => {
                                                const date1 = new Date(v1);
                                                const date2 = new Date(v2);
                                                return date1 - date2; // Compare dates
                                                },
                                            };
                                            
                                        } else {

                                            return {
                                                field: col.field,
                                                hide:true
                                                
                                            }
                                        }
                        
                        
                                        //return col;
                                    });
                        
                        
                                    columns = updatedColumns;



                                    let rows =dataTmp.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setTableDataZuteTvrtke({
                                            columns,
                                            rows
                                    })

                                    setTvrtkeModal(true)



            
                        } else if(response.data.list && response.data.list.length==1){

                                    console.log("Chosen:");

                                    console.log(response.data.list[0]);

                                    let row = response.data.list[0];


                                    console.log("Firma kontaktiiiiiiiiiiiiiiiiiiii");
                                    console.log(row.kontakti);

                                    setCurrentCompany(row);

                                    localStorage.setItem("lastComp", row.sifra)
                                    localStorage.setItem("lastCompTKC", row.tkc)

                                    console.log("**************************Current comapny: *********************************");
                                    console.log(row)




                                    setNaziv(row.naziv)
                        
                                    setMjesto(row.NAZIV_MJESTA)

                                    setUlica(row.NAZIV_ULICA)

                                    setKbr(row.kbr)

                                    setKbr_znak(row.alfa);

                                    setKomentar(row.komentar)

                                    setKomentar2(row.komentar2)

                                    setSifra(row.sifra);

                                    setTkcFirma(row.tkc);

                                    console.log("Setting the data for company:");
                                    console.log(sifra);
                                    console.log(tkcFirma);
                                    console.log(row.tkc);
                                    console.log(row.sifra);

                                    setNazivKratki(row.naziv_kratki);
                                    setNazivMas(row.naziv_mas);
                                    setNazivNemas(row.naziv_nemas);

                                    setNazivZnak(row.naziv_znak);
                                    

                                    console.log("Objava tvrtke!!!");
                                    console.log(row.objava);
                                    console.log("Vrsta sloga");
                                    console.log(row.vrsta_sloga);
                                    setObjava(row.objava);
                                    setVrstaSloga(row.vrsta_sloga);


                                    let insertDate = new Date(row.dat_unosa);
                                    let azurDate = new Date(row.dat_zadnjeg_azur);

                                
                                    const options = {
                                    
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                    };
                                    let newFormInsert = insertDate.toLocaleDateString("hr-HR", options);
                                    let newFormAzur = azurDate.toLocaleDateString("hr-HR", options);


                                    setDatumUnos(newFormInsert);
                                    setDatumAzur(newFormAzur);

                                    setSelectedUlica({'ULICA_ID': row.sifra_ulice, 'NAZIV':row.NAZIV_ULICA});

                                    setSelectedMjesto({'MJESTO_ID': row.MJESTO_ID, 'NAZIV':row.NAZIV_MJESTA});

                                    setMatBr(row.MB);
                                    setOIB(row.oib);

                                    console.log("Setting the TKC from company in function---------------");


                                    console.log("Gonna get strukture!!!!!");

                                    setDisableSelNet(true);

                                    getBijeleStrukture(row.sifra, row.tkc);

                                    setTableDataZuteTvrtke([],[]);


                        } else {

                                    console.log("Nema tvrtke?");

                                    toast.error("Nije pronađena nijedna tvrtka s traženim parametrima, molimo provjerite naziv i/ili šifru tvrtke", toastError);

                                    setDisableSelNet(false);

                                    setTableDataZuteTvrtke([],[]);


                        }
                




                    
                    } else {

                            console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                            console.log(response);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                toast.error(response.data.message, toastError);

                                setDisableSelNet(false);
                            }

                    }

            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
       


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                                
                                setDisableSelNet(false);
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                    setDisableSelNet(false);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);

                                                    setDisableSelNet(false);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });

                
                
}  






async function getBijeleStrukture(codeCompany, tkcTmp) {
    //async function getBijeleStrukture() {



        let tmp = tkcTmp;
        

        console.log("TKC firme za trazenje strukture");
        console.log(tkcFirma);





        console.log("Getting strukture");
        console.log(tmp);
        //console.log(codeCompany)
        dispatch(actions.isLoading());



    
    APICall(
        '/GetBijeleStrukture',
        {

            platform: '0',
            version:'1.0',
            //sifra: sifra,
            sifra:codeCompany,
            tkc: tmp

        },
        {
            token
        }).then(


            (response) => {
                console.log(response)
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
                if (response.status==200) {
                    
                    var dataTmp = response.data.msg;



                    console.log(dataTmp)

                    /*

                    let struktArr = response.data.strukture.map(item=>{

                        if (item) {
                              
                             
                            let insertDate = new Date(item.datum_unosa);
                            let azurDate = new Date(item.datum_zadnjeg_azur);

                            console.log("Datum unosa:");
                            console.log(item.datum_unosa);
                            console.log(item.datum_zadnjeg_azur);


                          
                            const options = {
                             
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                              };
                            let newFormInsert = insertDate.toLocaleDateString("hr-HR", options);
                            let newFormAzur = azurDate.toLocaleDateString("hr-HR", options);

                            console.log(newFormInsert);
                            console.log(newFormAzur);

                        

                            return {
                            ...item,
                            datum_unosa: newFormInsert,
                            datum_zadnjeg_azur : newFormAzur
                            };
                            
                           
                        } 
                        
                    })



                    //setTableDataModal(response.data.strukture)
                    setTableDataModal(struktArr);

                    */
                    

                    let columns= Object.getOwnPropertyNames(response.data.strukture[0]).map((column,index)=>{
                        
                        return(
                            {
                                "field": column,
                                "getRowId": index,
                                
                            
                            }
                        )
                    })

                
    
                        

        
                    const updatedColumns = columns.map((col) => {
                

                        if(col.field == "Akcija"){
                            return {
                                field: col.field,
                                cellRenderer: SpecialCellRenderer
                            }
                        }
                        if(col.field == 'datum_unosa' || col.field== 'datum_zadnjeg_azur'){
        
                            return {
                                ...col,
                                valueFormatter: ({ value }) => {
                                if (value) {
                                    
                                
                                    let date = new Date(value);
        
        
                                    //return date.toLocaleDateString("DD.MM.YYYY"); // Format as MM/DD/YYYY (or customize)
                                    const options = {
                                    
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                    };
                                    return date.toLocaleDateString("hr-HR", options);
                                    
                                
                                }
                                return value;
                                },
                                sortComparator: (v1, v2) => {
                                const date1 = new Date(v1);
                                const date2 = new Date(v2);
                                return date1 - date2; // Compare dates
                                },
                            };
                            
        
                        }
        
        
                        return col;
                    });
        
        
                    columns = updatedColumns;
        
                        
                    let rows =response.data.strukture.map((item, index)=> {
                            return({...item,id:index})
                    })
        
                    console.log("Setting strukture array--------------------------------");
                    console.log(columns);
                    console.log(rows);

                 
                    
        
                    setStruktureArr({
                                columns,
                                rows
                    })
                



                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  



async function getZuteStranice() {




    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Mreža to set");
    console.log(mrezaStrukt);

    console.log("Sifra firme");
    console.log(sifra);
    console.log(tmp);


    dispatch(actions.isLoading());


    APICall(
        '/GetZuteinBijele_New',
        {

            platform: '0',
            version:'1.0',
            sifra: sifra,
            tkc: tmp

        },
        {
            token
        }).then(

            (response) => {
                console.log(response)
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                if (response.status==200) {

                    
                    
                    var dataTmp = response.data.list;
                    
                    console.log(dataTmp)

                    let i = 0;

                    let columns= Object.getOwnPropertyNames(dataTmp[0]).map((column,index)=>{
                      //var a = column.charAt(0).toUpperCase() + column.slice(1)
                        console.log("Doing zute columns!!!!!!!!");
                        console.log(column);
                        if(column == "makni" || column == "sifra_ulice" || column =='sifra_djel'){
                            return(
                                {
                                    "field": column,
                                    "getRowId": index,
                                    "hide": true,
                                }
                            )
                        
                        } else {
                          return(
                              {
                                  "field": column,
                                  "getRowId": index,
                              }
                          )
                        }
                      })
                      let rows =dataTmp.map((item, index)=> {
                          return({...item,id:index})
                      })

                      console.log(columns);
                      console.log(rows);

                      console.log("Settiiiiiiing");

                      setTableDataZuteStranice({
                              columns,
                              rows
                      })

                      setZuteStranice(true)
                
                } else {

                        console.log("Tuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuuu");
                        console.log(response);

                        if(response.status == 401){

                                toast.error(response.data.message,
                                    toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   


                        } else {

                                //toast.error(response.data.message, toastError);


                            setTableDataZuteStranice(
                                    [],[]
                            );
      
                            setZuteStranice(true)
                        }

                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  




const deleteBijeleCompany =()=>{
    Swal.fire({
        customClass: {
            container: 'my-swal'
          },
        title: `Jeste li sigurni da želite obrisati odabranu tvrtku?`,
        text: "Ova radnja se ne može poništiti",
        icon: "warning",
        iconSize: '5',

        showCancelButton: true,
        confirmButtonColor: "#e31b2e",
        cancelButtonColor: "#29648a",
        showCancelButton: true,
        confirmButtonText: "Obriši",
        cancelButtonText: "Odustani",
        reverseButtons: true
    }).then((result) => {
        if (result.isConfirmed) {

            
            DeleteBijeleComp();
        }
    });
}

async function DeleteBijeleComp() {



    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Sifra firma:");
    console.log(sifra);

    if(tkcFirma && tkcFirma!=''  && sifra && sifra!=''){


                dispatch(actions.isLoading());



                console.log("Deleting company");
            


                    APICall(
                        '/brisiFirmuBijele',
                        {

                        
                            tkc: tkcFirma,

                            sifra: sifra,
                            ref: ref
                    
                    
                        },
                        {
                            token
                        }).then(
                    
                    
                            (response) => {
                                console.log(response)
                                dispatch(actions.isNotLoading());
                    
                                if(response==undefined) dispatch(actions.isNotLoading());
                                if (response.status==200) {
                                    
                                    var dataTmp = response.data.msg;

                                    console.log(dataTmp)
                    
                                    toast.success(response.data.msg,
                                        toastSuccess);

                                                                setNaziv('');

                                                                
                    
                    
                                                                setMjesto('');
                        
                                                                setUlica('');

                                                              
                                                                setKbr('');

                                                                setKbr_znak('');
                        
                                                                setKomentar('');
                        
                                                                setKomentar2('');
    
                                                                setSifra('');

                                                                setTkcFirma('');

                                                                setDisableSelNet(false);
    
                                                                setNazivKratki('');
                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});
                                                                setNazivMas('');
                                                                setNazivNemas('');
                                                                setNazivZnak('');
    
                                                                setDatumUnos('');
                                                                setDatumAzur('');

                                                                setTableDataModal([]);

                                                                setRedosStrukt('')
                                                                setNivoStrukt('')
                                                                setMrezaStrukt('')
                                                                setTelStrukt('')
                                                                
                                                               // setObjavaStrukt(false);
                                                               // setObjavaStruktChecked('NE');

                                                                setObjavaStrukt(1);
                                                                setObjavaStruktChecked(1);
                                                                
                                                                setUlicaStrukt('')
                                                                setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});

                                                                setKbrStrukt('')
                                                                setKbr_znakStrukt('')
                                                                setNazivStrukt('')
                                                                setKomentStrukt('')
                                                                setDatStr1('')
                                                                setDatStr2('')
                                                                setKnjigaStrukt('')
                                                                setPojam1Strukt('')
                                                                setPojam2Strukt('')
                                                                setPojam3Strukt('')
                                                                setTableDataModal([]);
                                                                setMatBr('');
                                                                setOIB('');

                                                                setBelow(false);
                                                                setAbove(false);

                                                                setMemoStrukt('');
                                                                setStruktureArr([],[]);

                                                                setSelectedStrukt([]);
                                                                setMemoStrukt('');

                                            
                                }
                    
                        
                                    
                            
                            },
                    
                            (error) => {
                    
                                dispatch(actions.isNotLoading());
   
                            
                                        if(!error.response){
                    
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                toastError);
                                        
                    
                    
                                        } else {
                    
                    
                                            if(!error.response.status){
                    
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                toastError);
                    
                                            }else{
                    
                                                if (error.response.status == 401) {
                            
                                        
                                                    toast.error(error.response.data.message,
                                                            toastError);
                                                    
                                                            setTimeout(() => {
                                                                dispatch(actions.logOut());
                                                                navigate('/');
                                                            }, 5000);   
                    
                                                
                                            
                                                } else {
                                            
                                            
                                                            toast.error(error.response.data.message,
                                                                toastError);
                                                                                        
                                                    
                                                }
                                            }
                                        }
                                    
                                
                            
                            
                            });

    } else {

        toast.error("Nije ispravno odabrana tvrtka za brisanje, provjerite jeste li pronašli tvrtku", toastError);
    }
}  



const brisiStrukt =()=>{

    console.log("Brisem")

             
    console.log(memoStrukt);

    console.log(sifra);
    console.log(tkcFirma);
    console.log(redosStrukt);

    if(memoStrukt && memoStrukt.redos && memoStrukt.redos!='' && redosStrukt == memoStrukt.redos && selectedStrukt && selectedStrukt.length==1){

        DeleteBijeleStrukture();

    } else {

                Swal.fire({
                    customClass: {
                        container: 'my-swal'
                    },
                    title: `Jeste li sigurni da želite obrisati odabranu strukturu? To nije trenutno zapamćena struktura, u memo imate strukturu na poziciji redos ` + memoStrukt.redos + `.`,
                    text: "Ova radnja se ne može poništiti",
                    icon: "warning",
                    iconSize: '5',

                    showCancelButton: true,
                    confirmButtonColor: "#e31b2e",
                    cancelButtonColor: "#29648a",
                    showCancelButton: true,
                    confirmButtonText: "Obriši",
                    cancelButtonText: "Odustani",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {

                        
                        DeleteBijeleStrukture();
                    }
                });

    }



}

async function DeleteBijeleStrukture() {



    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);


    dispatch(actions.isLoading());



    console.log("Deleting");
 

    console.log(redosStrukt);




        APICall(
            '/DeleteBijeleStrukture',
            {
        
                platform: '0',
                version:'1.0',
                sifra: sifra,
            
                tkc: tmp,

                redos: redosStrukt,
                ref:ref
        
        
            },
            {
                token
            }).then(
        
        
                (response) => {
                    console.log(response)
                    dispatch(actions.isNotLoading());
        
                    if(response==undefined) dispatch(actions.isNotLoading());
                    if (response.status==200) {
                        
                        var dataTmp = response.data.msg;
        
        
        
                        console.log(dataTmp)
        
                        toast.success(response.data.msg,
                            toastSuccess);

                            setRedosStrukt('')
                            setNivoStrukt('')
                            setMrezaStrukt('')
                            setTelStrukt('')
                            
                            //setObjavaStrukt(false);
                            //setObjavaStruktChecked('NE');

                                    setObjavaStrukt(1);
                            setObjavaStruktChecked(1);

                            setUlicaStrukt('')
                            setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                            setKbrStrukt('')
                            setKbr_znakStrukt('');

                            setNazivStrukt('')
                            setKomentStrukt('')
                            setDatStr1('')
                            setDatStr2('')
                            setKnjigaStrukt('')
                            setPojam1Strukt('')
                            setPojam2Strukt('')
                            setPojam3Strukt('');

                            getBijeleStrukture(sifra, tkcFirma);

                            setSelectedStrukt([]);
                                
                    }
        
            
                        
                
                },
        
                (error) => {
        
                    dispatch(actions.isNotLoading());
        
                
        
        
        
                
                            if(!error.response){
        
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
        
        
                            } else {
        
        
                                if(!error.response.status){
        
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
        
                                }else{
        
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
        
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });

  
}  



async function setBijeleStrukture() {


    console.log("Setting strzukturaaaaaaaaa")
    console.log(selectedUlica);


    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Mreža to set");
    console.log(mrezaStrukt);

    let tmp2 = mrezaStrukt?mrezaStrukt:'';


    console.log("Setting strukture");
    console.log(tmp);
    //console.log(codeCompany)
    

    //let tmpOb = 7;
    //if(objavaStrukt) tmpOb = 1;
    let tmpOb = objavaStrukt;

    console.log("Shold I create new?");
    console.log(newStrukt);

    console.log(redosStrukt);

    let tmpRedos = 1;
    let tmpNivo = 400;

    console.log("*************KBR************************")
    console.log(kbrStrukt)

    let tmp_kbr = kbrStrukt?kbrStrukt:null;

    console.log(tmp_kbr);

    console.log("*****************************");
    console.log(kbr_znakStrukt);
    console.log("*****************************");

    if(newStrukt){

        dispatch(actions.isLoading());
    
                APICall(
                 
                    '/CreateBijeleStrukture',
                    {
                
                        platform: '0',
                        version:'1.0',
                        sifra: sifra,
                        //sifra: codeCompany,
                        tkc: tmp,
                        mreza: tmp2,
                        nivo:nivoStrukt,
                        nivo: tmpNivo,
                        tel: telStrukt,
                        naziv: nazivStrukt,
                        ulica: selectedUlicaST.ULICA_ID?selectedUlicaST.ULICA_ID:selectedUlicaST.ulica_id,
                        //kbr: kbrStrukt,
                        kbr: tmp_kbr,
                        kbrAlfa:kbr_znakStrukt,
                        komentar: komentStrukt,
                        pojam1: pojam1Strukt,
                        pojam2: pojam2Strukt,
                        pojam3: pojam3Strukt,
                        objava: tmpOb,
                        new: newStrukt,
                        redos: tmpRedos,
                        ref:ref
                
                
                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);

                                    setRedosStrukt('')
                                    setNivoStrukt('')
                                    setMrezaStrukt('')
                                    setTelStrukt('')
                                    
                                    //setObjavaStrukt(false);
                                    //setObjavaStruktChecked('NE');

        setObjavaStrukt(1);
        setObjavaStruktChecked(1);                                    
                                    
                                    setUlicaStrukt('')
                                    setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                    setKbrStrukt('')
                                    setKbr_znakStrukt('');
                                    setNazivStrukt('')
                                    setKomentStrukt('')
                                    setDatStr1('')
                                    setDatStr2('')
                                    setKnjigaStrukt('')
                                    setPojam1Strukt('')
                                    setPojam2Strukt('')
                                    setPojam3Strukt('')

                                    getBijeleStrukture(sifra, tkcFirma);

                                    setSelectedStrukt([]);
                                        

                
                             } else {

                                    if(response.status==401){
                                                toast.error(response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   

                                    } else {

                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                    } 


                            }                   
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });

    } else {

        if(selectedStrukt && selectedStrukt.length==1){

                dispatch(actions.isLoading());
                        APICall(
                            //'/GetDnevneFiksni',
                            '/SetBijeleStrukture',
                            {
                        
                                platform: '0',
                                version:'1.0',
                                sifra: sifra,
                                //sifra: codeCompany,
                                tkc: tmp,
                                nivo: nivoStrukt,
                                tel: telStrukt,
                                naziv: nazivStrukt,
                                ulica: selectedUlicaST.ULICA_ID?selectedUlicaST.ULICA_ID:selectedUlicaST.ulica_id,
                                //kbr: kbrStrukt,
                                kbr: tmp_kbr,
                                alfa:kbr_znakStrukt,
                                komentar: komentStrukt,
                                pojam1: pojam1Strukt,
                                pojam2: pojam2Strukt,
                                pojam3: pojam3Strukt,
                                objava: tmpOb,
                                new: newStrukt,
                                redos: redosStrukt,
                                ref:ref
                        
                        
                            },
                            {
                                token
                            }).then(
                        
                        
                                (response) => {
                                    console.log(response)
                                    dispatch(actions.isNotLoading());
                        
                                    if(response==undefined) dispatch(actions.isNotLoading());
                                    if (response.status==200) {
                                        
                                        var dataTmp = response.data.msg;
                        
                        
                        
                                        console.log(dataTmp)
                        
                                        toast.success("Uspješno spremljene izmjene",
                                            toastSuccess);

                                            setRedosStrukt('')
                                            setNivoStrukt('')
                                            setMrezaStrukt('')
                                            setTelStrukt('')
                                            
                                            //setObjavaStrukt(false);
                                            //setObjavaStruktChecked('NE');

                        setObjavaStrukt(1);
                        setObjavaStruktChecked(1);                            
                                            
                                            setUlicaStrukt('')
                                            setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                            setKbrStrukt('')
                                            setKbr_znakStrukt('');
                                            setNazivStrukt('')
                                            setKomentStrukt('')
                                            setDatStr1('')
                                            setDatStr2('')
                                            setKnjigaStrukt('')
                                            setPojam1Strukt('')
                                            setPojam2Strukt('')
                                            setPojam3Strukt('');

                                            setSelectedStrukt([]);
                                            getBijeleStrukture(sifra, tkcFirma);
                                                
                                            } else {

                                                    if(response.status==401){
                                                                toast.error(response.data.message,
                                                                        toastError);
                                                                
                                                                        setTimeout(() => {
                                                                            dispatch(actions.logOut());
                                                                            navigate('/');
                                                                        }, 5000);   

                                                    } else {

                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                                    } 


                                            }
                        
                            
                                        
                                
                                },
                        
                                (error) => {
                        
                                    dispatch(actions.isNotLoading());
                        
                                
                        
                        
                        
                                
                                            if(!error.response){
                        
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            
                        
                        
                                            } else {
                        
                        
                                                if(!error.response.status){
                        
                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                        
                                                }else{
                        
                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                        
                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    
                                
                                
                                });
            } else {

                if(!selectedStrukt){

                        toast.error("Morate odabrati strukturu kojoj mijenjate podatke ili odabrati opciju Unos nove strukture", toastError);

                } else if(selectedStrukt.length==0){

                        toast.error("Morate odabrati strukturu kojoj mijenjate podatke ili odabrati opciju Unos nove strukture", toastError);

                } else {
                        console.log("Mijenja se više struktura!!!");
                        console.log(selectedStrukt.length);

                        Swal.fire({
                            customClass: {
                                container: 'my-swal'
                            },
                            title: `Jeste li sigurni da želite izmijeniti podatke za sve odabrane strukture? Odabrano je ` + selectedStrukt.length + ` struktura. Želite li mijenjati objavu ili adresu?`,
                            text: "Ova radnja se ne može poništiti",
                            icon: "warning",
                            iconSize: '5',

                            showCancelButton: true,
                            showDenyButton:true,
                            confirmButtonColor: "#e31b2e",
                            cancelButtonColor: "#29648a",
                            denyButtonColor:'#AFE1AF',
                            showCancelButton: true,
                            confirmButtonText: "Izmijeni adresu",
                            cancelButtonText: "Odustani",
                            denyButtonText:"Izmijeni objavu",
                            reverseButtons: true
                        }).then((result) => {
                            if (result.isConfirmed) {

                                
                                setBijeleStrArray();
                            } else if(result.isDenied){

                                setBijeleArrayObjava();
                            }
                        });                       
                }

            }

    }




        
        
}  

async function setBijeleStrArray() {
    
    console.log("Setting struktureeeeee")
    console.log(selectedUlica);


    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Mreža to set");
    console.log(mrezaStrukt);

    let tmp2 = mrezaStrukt?mrezaStrukt:'';


    console.log("Setting strukture");
    console.log(tmp);
 
    
    //let tmpOb = 7;
    //if(objavaStrukt) tmpOb = 1;
    let tmpOb = objavaStrukt;

    console.log(redosStrukt);

    let tmpRedos = 1;
    let tmpNivo = 400;

    console.log("*************KBR************************")
    console.log(kbrStrukt)

                    dispatch(actions.isLoading());
                        APICall(
                        
                            '/setBijeleStruktureArray',
                            {
                        
                                platform: '0',
                                version:'1.0',
                                sifra: sifra,
                                tkc: tkcFirma,
                          
                                //naziv: nazivStrukt,
                                ulica: selectedUlicaST.ULICA_ID?selectedUlicaST.ULICA_ID:selectedUlicaST.ulica_id,
                                kbr: kbrStrukt,
                                alfa:kbr_znakStrukt,
                                //komentar: komentStrukt,
                               
                                //objava: tmpOb,
                               
                                redosArray: selectedStrukt,
                                ref:ref
                        
                        
                            },
                            {
                                token
                            }).then(
                        
                        
                                (response) => {
                                    console.log(response)
                                    dispatch(actions.isNotLoading());
                        
                                    if(response==undefined) dispatch(actions.isNotLoading());
                                    if (response.status==200) {
                                        
                                        var dataTmp = response.data.msg;
                        
                        
                        
                                        console.log(dataTmp)
                        
                                        toast.success("Uspješno spremljene izmjene",
                                            toastSuccess);

                                            setRedosStrukt('')
                                            setNivoStrukt('')
                                            setMrezaStrukt('')
                                            setTelStrukt('')
                                            
                                            //setObjavaStrukt(false);
                                            //setObjavaStruktChecked('NE');

                        setObjavaStrukt(1);
                        setObjavaStruktChecked(1);                            
                                            
                                            setUlicaStrukt('')
                                            setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                            setKbrStrukt('')
                                            setKbr_znakStrukt('');
                                            setNazivStrukt('')
                                            setKomentStrukt('')
                                            setDatStr1('')
                                            setDatStr2('')
                                            setKnjigaStrukt('')
                                            setPojam1Strukt('')
                                            setPojam2Strukt('')
                                            setPojam3Strukt('');

                                            setSelectedStrukt([]);
                                            getBijeleStrukture(sifra, tkcFirma);
                                                
                                            } else {

                                                    if(response.status==401){
                                                                toast.error(response.data.message,
                                                                        toastError);
                                                                
                                                                        setTimeout(() => {
                                                                            dispatch(actions.logOut());
                                                                            navigate('/');
                                                                        }, 5000);   

                                                    } else {

                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                                    } 


                                            }
                        
                            
                                        
                                
                                },
                        
                                (error) => {
                        
                                    dispatch(actions.isNotLoading());
                        
                                
                        
                        
                        
                                
                                            if(!error.response){
                        
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            
                        
                        
                                            } else {
                        
                        
                                                if(!error.response.status){
                        
                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                        
                                                }else{
                        
                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                        
                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    
                                
                                
                                });

}

async function setBijeleArrayObjava() {
    
    console.log("Setting struktureeeeee")
    console.log(selectedUlica);


    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Mreža to set");
    console.log(mrezaStrukt);

    let tmp2 = mrezaStrukt?mrezaStrukt:'';


    console.log("Setting strukture");
    console.log(tmp);
 
    
    let tmpOb = objavaStrukt;

    console.log(redosStrukt);


    console.log("*************KBR************************")
    console.log(kbrStrukt)

                    dispatch(actions.isLoading());
                        APICall(
                        
                            '/setBijeleStruktureArrayObjava',
                            {
                        
                                platform: '0',
                                version:'1.0',
                                sifra: sifra,
                                tkc: tkcFirma,
                          
                                objava: tmpOb,

                                redosArray: selectedStrukt,
                                ref:ref
                        
                        
                            },
                            {
                                token
                            }).then(
                        
                        
                                (response) => {
                                    console.log(response)
                                    dispatch(actions.isNotLoading());
                        
                                    if(response==undefined) dispatch(actions.isNotLoading());
                                    if (response.status==200) {
                                        
                                        var dataTmp = response.data.msg;
                        
                        
                        
                                        console.log(dataTmp)
                        
                                        toast.success("Uspješno spremljene izmjene",
                                            toastSuccess);

                                            setRedosStrukt('')
                                            setNivoStrukt('')
                                            setMrezaStrukt('')
                                            setTelStrukt('')
                                            
                                            //setObjavaStrukt(false);
                                            //setObjavaStruktChecked('NE');

                                            setObjavaStrukt(1);
                                            setObjavaStruktChecked(1);                            
                                                                
                                            setUlicaStrukt('')
                                            setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                            setKbrStrukt('')
                                            setKbr_znakStrukt('');
                                            setNazivStrukt('')
                                            setKomentStrukt('')
                                            setDatStr1('')
                                            setDatStr2('')
                                            setKnjigaStrukt('')
                                            setPojam1Strukt('')
                                            setPojam2Strukt('')
                                            setPojam3Strukt('');

                                            setSelectedStrukt([]);
                                            getBijeleStrukture(sifra, tkcFirma);
                                                
                                            } else {

                                                    if(response.status==401){
                                                                toast.error(response.data.message,
                                                                        toastError);
                                                                
                                                                        setTimeout(() => {
                                                                            dispatch(actions.logOut());
                                                                            navigate('/');
                                                                        }, 5000);   

                                                    } else {

                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                                    toastError);
                                                    } 


                                            }
                        
                            
                                        
                                
                                },
                        
                                (error) => {
                        
                                    dispatch(actions.isNotLoading());
                        
                                
                        
                        
                        
                                
                                            if(!error.response){
                        
                                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                            
                        
                        
                                            } else {
                        
                        
                                                if(!error.response.status){
                        
                                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                        
                                                }else{
                        
                                                    if (error.response.status == 401) {
                                
                                            
                                                        toast.error(error.response.data.message,
                                                                toastError);
                                                        
                                                                setTimeout(() => {
                                                                    dispatch(actions.logOut());
                                                                    navigate('/');
                                                                }, 5000);   
                        
                                                    
                                                
                                                    } else {
                                                
                                                
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                                                            
                                                        
                                                    }
                                                }
                                            }
                                        
                                    
                                
                                
                                });

}


async function setBijeleStrukture_Above(up) {




    let tmp = tkcFirma;

    console.log("TKC firma: ");
    console.log(tkcFirma);

    console.log("Mreža to set");
    console.log(mrezaStrukt);

    let tmp2 = mrezaStrukt?mrezaStrukt:'';


    console.log("Setting strukture");
    console.log(tmp);
    //console.log(codeCompany)
    dispatch(actions.isLoading());

    //let tmpOb = 7;
    //if(objavaStrukt) tmpOb = 1;
    let tmpOb = objavaStrukt;

    console.log("Shold I create new?");
    console.log(newStrukt);

    console.log(redosStrukt);

    console.log("Mora biti iznad:")

    console.log(redosStrukt);

    console.log(up)

    setBelow(false);
    setAbove(false);

    let changePrevious = ''
    if(up==0){

        console.log("Mijenjamo prethodnu strukturu!!!")

        console.log(changeRedos);
        changePrevious = changeRedos;
    }

console.log('**********************************************************')    
console.log('**********************************************************')    
console.log('**********************************************************')    
console.log(selectedUlicaST.ULICA_ID?selectedUlicaST.ULICA_ID:(selectedUlicaST.ulica_id?selectedUlicaST.ulica_id:''));
console.log(selectedUlicaST);


    let tmpNivo = 1;

   

    
                APICall(
                    //'/GetDnevneFiksni',
                    '/CreateBijeleStrukture_Above',
                    {
                
                        platform: '0',
                        version:'1.0',
                        sifra: sifra,
                        //sifra: codeCompany,
                        tkc: tmp,
                        mreza: tmp2,
                        nivo:nivoStrukt,
                        nivo: tmpNivo,
                        tel: telStrukt,
                        naziv: nazivStrukt,
                        //ulica: selectedUlicaST.ULICA_ID,
                        ulica:selectedUlicaST.ULICA_ID?selectedUlicaST.ULICA_ID:(selectedUlicaST.ulica_id?selectedUlicaST.ulica_id:''),
                        kbr: kbrStrukt,
                        alfa:kbr_znakStrukt,
                        komentar: komentStrukt,
                        pojam1: pojam1Strukt,
                        pojam2: pojam2Strukt,
                        pojam3: pojam3Strukt,
                        objava: tmpOb,
                        new: newStrukt,
                        redos: redosStrukt,
                        up:up,
                        changePrevious: changePrevious,
                        ref: ref
                
                
                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);

                                    setRedosStrukt('')
                                    setNivoStrukt('')
                                    setMrezaStrukt('')
                                    setTelStrukt('')
                                    
                                    //setObjavaStrukt(false);
                                    //setObjavaStruktChecked('NE');
                                            setObjavaStrukt(1);
        setObjavaStruktChecked(1);
                                    setUlicaStrukt('')
                                    setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                    setKbrStrukt('')
                                    setKbr_znakStrukt('')
                                    setNazivStrukt('')
                                    setKomentStrukt('')
                                    setDatStr1('')
                                    setDatStr2('')
                                    setKnjigaStrukt('')
                                    setPojam1Strukt('')
                                    setPojam2Strukt('')
                                    setPojam3Strukt('')

                                    setSelectedStrukt([]);
                                 

                                    setBelow(false);
                                    setAbove(false);

                                getBijeleStrukture(sifra, tkcFirma);
                                        
                            }
                
                    
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });

 




        
        
}  



const [open, setOpen] = React.useState(false);
const [loading, setLoading] = React.useState(false);
const inputRefUlice = React.useRef();

const [highlightedOption, setHighlightedOption] = React.useState(null);

const [openMjesto, setOpenMjesto] = React.useState(false);
const [loadingMjesto, setLoadingMjesto] = React.useState(false);
const inputRefMjesto = React.useRef();

const [highlightedOptionMjesto, setHighlightedOptionMjesto] = React.useState(null);


const [openST, setOpenST] = React.useState(false);
const [loadingST, setLoadingST] = React.useState(false);
const inputRefUliceST = React.useRef();

const [highlightedOptionST, setHighlightedOptionST] = React.useState(null);

const [openZute, setOpenZute] = React.useState(false);
const [loadingZute, setLoadingZute] = React.useState(false);
const inputRefUliceZute = React.useRef();

const [highlightedOptionZute, setHighlightedOptionZute] = React.useState(null);


React.useEffect(() => {
    const fetchData = async () => {
      if (ulica && ulica.length >= 3) {
        setLoading(true);
        await searchForUlica(ulica, 'ulice');
     
        setOpen(true);
        setLoading(false);
      } else {
        setOpen(false);

      }
    };
    
    fetchData();
  }, [ulica]);


  React.useEffect(() => {
    const fetchDataMjesto = async () => {
      if (mjesto && mjesto.length >= 3) {
        console.log("I'm gonna attempt searching!!!!!");
        console.log(mjesto);
        setLoadingMjesto(true);
        await searchForMjesto(mjesto);
     
        setOpenMjesto(true);
        setLoadingMjesto(false);
      } else {
        setOpenMjesto(false);

      }
    };
    
    fetchDataMjesto();
  }, [mjesto]);

  React.useEffect(() => {
    const fetchDataST = async () => {
      if (ulicaStrukt && ulicaStrukt.length >= 3) {
        setLoadingST(true);
        await searchForUlica(ulicaStrukt, 'uliceST');
     
        setOpenST(true);
        setLoadingST(false);
      } else {
        setOpenST(false);

      }
    };
    
    fetchDataST();
  }, [ulicaStrukt]);

React.useEffect(() => {
    const fetchDataZute = async () => {
      if (ulicaZute && ulicaZute.length >= 3) {
        setLoadingZute(true);
        await searchForUlica(ulicaZute, 'uliceZute');
     
        setOpenZute(true);
        setLoadingZute(false);
      } else {
        setOpenZute(false);

      }
    };
    
    fetchDataZute();
  }, [ulicaZute]);


  const handleKeyDownUlica = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedUlica && highlightedOption) {
        console.log(highlightedOption);
        setSelectedUlica(highlightedOption);

        // blur the input after selection
        if (inputRefUlice.current) {
          inputRefUlice.current.blur();
        }
        setOpen(false); // close dropdown

        
      }
      if(selectedUlica){
        kbr_ref.current.focus();
      }
    }
  };


  const handleKeyDownMjesto = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      console.log("aaaaaaaaaaaaaaaaaaaaaaaaa")

      console.log(selectedMjesto);
      console.log(highlightedOptionMjesto)
      if (!selectedMjesto && highlightedOptionMjesto) {

        console.log(highlightedOptionMjesto);
        setSelectedMjesto(highlightedOptionMjesto);

        console.log(inputRefMjesto)
        console.log(inputRefMjesto.current);
        console.log("******")

        // blur the input after selection
        if (inputRefMjesto.current) {
          inputRefMjesto.current.blur();
        }
        setOpenMjesto(false); // close dropdown

        
        
      }
      if(selectedMjesto){
        inputRefUlice.current.focus();

      }
    }
  };


  const handleKeyDownUlicaST = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedUlicaST && highlightedOptionST) {
        console.log(highlightedOptionST);
        setSelectedUlicaST(highlightedOptionST);

        // blur the input after selection
        if (inputRefUliceST.current) {
          inputRefUliceST.current.blur();
        }
        setOpenST(false); // close dropdown
      }
      if(selectedUlicaST){

            kbrStrukt_ref.current.focus();
      }
    }
  };

  const handleKeyDownUlicaZute = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // prevent form submit or default behavior

      if (!selectedUlicaZute && highlightedOptionZute) {
        console.log(highlightedOptionZute);
        setSelectedUlicaZute(highlightedOptionZute);

        // blur the input after selection
        if (inputRefUliceZute.current) {
          inputRefUliceZute.current.blur();
        }
        setOpenZute(false); // close dropdown

        
      }
      if(selectedUlicaZute){
        kbr_refZute.current.focus();
      }
    }
  };


async function searchForUlica(val, list){

    console.log("Searching for ulica");
    console.log("Mjesto");
    console.log(mjesto);
    console.log(selectedMjesto);

    if(val.length>2){
       
        APICall(
            '/getUlicaSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val,
                mjesto: selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        
                           if (list=="ulice") {
                            console.log("Obicne uliceeeeeeeeeeeeee")
                            console.log(response.data.strukture)
                            setListUlice(response.data.strukture)

                            console.log("Gotten the list of ulice");
                            console.log(ulica);
                            
                           }else if(list=="uliceST"){ 
                            console.log("Struktura uliceeeeeeeeeeeeeeeee")
                            console.log(response.data.strukture)
                            setListUliceST(response.data.strukture)
                           }else if(list=="uliceZute"){ 
                            console.log("Zute uliceeeeeeeeeeeeeeeee")
                            console.log(response.data.strukture)
                            setListUliceZute(response.data.strukture)
    
                            }
                        }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListUlice([])
        if (list=="ulice")  setListUlice([])
            else if(list=="uliceST")  setListUliceST([])
        else if(list=="uliceZute")  setListUliceZute([])

    }
}

async function searchForMjesto(val){

    if(val.length>2){
       
        APICall(
            '/getMjestoSuggestion',
            {
    
                platform: '0',
                version:'1.0',

                val: val
    
            },
            {
                token
            }).then(
    
    
                (response) => {
                    console.log(response)
    
    
                    if (response.status==200) {
                        

                                    setListMjesta(response.data.strukture)

                                    if(response.data.strukture.length == 1){
                                        console.log("Samo jedno mjesto!!");
                                        console.log(response.data.strukture);


                                    }
    
    
                    }
    
            
                        
                
                },
    
                (error) => {
    
                    dispatch(actions.isNotLoading());
    
                
       
    
    
                
                            if(!error.response){
    
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
    
    
                            } else {
    
    
                                if(!error.response.status){
    
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
    
                                }else{
    
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
    
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });
    } else{
        setListMjesta([])
    }
}



function cleanString(input) {
  let str = input ?? '';
  return str
    .replace(/"/g, '') // remove all double quotes
    .replace(/([^a-zA-Z0-9])\1+/g, '$1'); // collapse repeated non-alphanumerics
}


async function setBijeleCompany() {


    //console.log("TKC")
    //console.log(tkc2);

    //let tmp2 = tkc2.pozivni;
    //let tmp = tkc2.tkc;

    let tmp = '';

    if(tkcFirma && tkcFirma!=''){
        console.log("Setting from firma")
        console.log(tkcFirma)

        tmp = tkcFirma;
        
    } else if(selectedNetwork && selectedNetwork.tkc && selectedNetwork.tkc!=''){

        console.log("setting from selected");
        console.log(selectedNetwork)
        tmp = selectedNetwork?selectedNetwork.tkc:'';

    } else {

        console.log("Nema nikakvog tkc-a, uzmi iz mjesta?")

        console.log(setSelectedMjesto);
        
        tmp = selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc;
    }




    console.log("Setting firma");
    console.log(tmp);
    //console.log(codeCompany)
    dispatch(actions.isLoading());

    let tmpOb = 7;

    if(objavaStrukt) tmpOb = 1;

    console.log("Should I create new?");
    console.log(newCompany);



    let tmpNazivMas = nazivMas?nazivMas.trim().toUpperCase():'';
    tmpNazivMas = cleanString(tmpNazivMas);

    console.log("Naziviiiiiiiii****************************************************")
    console.log(nazivMas);
    console.log(tmpNazivMas);

    setNazivMas(tmpNazivMas);


    let tmpNazivZnak = nazivZnak?nazivZnak.trim().toUpperCase():' '; 
    tmpNazivZnak=cleanString(tmpNazivZnak);

    setNazivZnak(tmpNazivZnak);

    console.log('++++++++++++++++')
    console.log('++++++++++++++++')
    console.log('++++++++++++++++')

    console.log(nazivNemas);
    
    console.log('++++++++++++++++')
    console.log('++++++++++++++++')
    console.log('++++++++++++++++')

    let tmpNazivNemas =  nazivNemas?nazivNemas.trim():'';
    console.log(tmpNazivNemas)
    tmpNazivNemas = cleanString(tmpNazivNemas);
    console.log(tmpNazivNemas)

    setNazivNemas(tmpNazivNemas);

    console.log(tmpNazivMas);
    console.log(tmpNazivZnak);
    console.log(tmpNazivNemas);

    let tmpNaziv = tmpNazivMas + '' + tmpNazivZnak + ' ' + tmpNazivNemas;

    setNaziv(tmpNaziv);

    console.log("Spremam kao naziv:");
    console.log(tmpNaziv)

    let nazKratki = generirajSkraceniNaziv(tmpNazivMas, tmpNazivNemas);

    console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    console.log(nazKratki);


    console.log("Setting the ulica:");
    console.log(selectedUlica);
    console.log("Setting Mjesto");
    console.log(selectedMjesto);

    if(selectedMjesto && (selectedMjesto.MJESTO_ID?selectedMjesto.MJESTO_ID:selectedMjesto.mjesto_id) 
        && selectedUlica && (selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:selectedUlica.ulica_id)){        

            console.log("Setting the correct tkc: " + tmp);

            console.log(selectedMjesto);

            let selMjTKC = selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc;

        if((selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc && (selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc) != '' &&
           
                (tmp === selMjTKC)) || (!selectedMjesto.ID_TKC && !selectedMjesto.id_tkc && (tmp || tmp!==''))
            ){
        

                console.log("OK su podaci?");

                console.log(tmp);
                console.log(selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc);
                if(tmp==selectedMjesto.id_tkc){
                    console.log("JE");
                }else{
                    console.log("Nije")
                }
                console.log(tmp === selectedMjesto.ID_TKC?selectedMjesto.ID_TKC:selectedMjesto.id_tkc);
                

        
    if(newCompany){

    
                APICall(
                
                    '/CreateBijeleCompany',
                    {


                        platform: '0',
                        version:'1.0',
                       
                        tkc: tmp,
                        //naziv_mas: nazivMas?nazivMas.trim().toUpperCase():'',
                        naziv_mas: tmpNazivMas,
                        //naziv: naziv,
                        naziv:tmpNaziv,
                        //naziv_nemas: nazivNemas.trim(),
                        naziv_names: tmpNazivNemas,
                        //naziv_znak: nazivZnak?nazivZnak.trim().toUpperCase():' ',
                        naziv_znak: tmpNazivZnak,
                        naziv_kratki: nazKratki?nazKratki.toUpperCase():'',
                      
                        alfa: kbr_znak?kbr_znak.toUpperCase():'',
                        komentar: komentar,
                        komentar2: komentar2,
                        objava: objava,
                        mb: MatBr,
                        oib: OIB,
                        kontakti: kontakti,
                        sifra_ulice: selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:''),
                        kbr: kbr,
                        ref: ref


                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);
                            } else {


                                if (response.status == 401) {
                        
                                    
                                    toast.error(response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   
    
                                
                            
                                } else {
                            
                            
                                            toast.error(response.data.message,
                                                toastError);
                                                                        
                                    
                                }

                            }
                
                    
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });

    } else {

        APICall(

            '/SetBijeleCompany',
            {
        
                platform: '0',
                version:'1.0',
                sifra: sifra,
                tkc: tmp,
              
                //naziv_mas: nazivMas?nazivMas.trim().toUpperCase():'',
                naziv_mas: tmpNazivMas,
                naziv: tmpNaziv,
                //naziv_nemas: nazivNemas?nazivNemas.trim():'',
                naziv_nemas: tmpNazivNemas,
                //naziv_znak: nazivZnak?nazivZnak.trim().toUpperCase():' ',
                naziv_znak: tmpNazivZnak,
                naziv_kratki: nazKratki?nazKratki.toUpperCase():'',
                

                alfa: kbr_znak?kbr_znak.toUpperCase():'',
                komentar: komentar,
                komentar2: komentar2,
                objava: objava,
                mb: MB,
                oib: OIB,
                kontakti: kontakti,
                sifra_ulice: selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:''),
                kbr: kbr,
                oldComp: currentCompany,
                ref: ref
        
        
            },
            {
                token
            }).then(
        
        
                (response) => {
                    console.log(response)
                    dispatch(actions.isNotLoading());
        
                    if(response==undefined) dispatch(actions.isNotLoading());
                    if (response.status==200) {
                        
                        var dataTmp = response.data.msg;
        
        
        
                        console.log(dataTmp)
        
                        toast.success("Uspješno spremljene izmjene",
                            toastSuccess);

                        let tempCompany = currentCompany;

                        console.log("Temp comp prije **********++++++++++++++++++++++++")
                        console.log(tempCompany);

                        tempCompany.naziv_mas = nazivMas?nazivMas.toUpperCase():'';
                        tempCompany.alfa = kbr_znak;
                        tempCompany.kbr = kbr;
                        tempCompany.naziv_kratki = nazivKratki?nazivKratki.toUpperCase():'';
                        tempCompany.naziv = tmpNaziv;
                        tempCompany.naziv_nemas = nazivNemas;
                        tempCompany.naziv_znak = nazivZnak?nazivZnak.toUpperCase():' ';
                        tempCompany.sifra_ulice = selectedUlica.ULICA_ID?selectedUlica.ULICA_ID:(selectedUlica.ulica_id?selectedUlica.ulica_id:'');
                        

                        setCurrentCompany(tempCompany);

                        console.log("Temp comp nakon **********++++++++++++++++++++++++")
                        console.log(tempCompany);


                    } else {
        
                    if (response.status == 401) {
                        
                                    
                        toast.error(response.data.message,
                                toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   

                    
                
                    } else {
                
                
                                toast.error(response.data.message,
                                    toastError);
                                                            
                        
                    }
                }
                        
                
                },
        
                (error) => {
        
                    dispatch(actions.isNotLoading());
        
                
        
        
        
                
                            if(!error.response){
        
                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            
        
        
                            } else {
        
        
                                if(!error.response.status){
        
                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
        
                                }else{
        
                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   
        
                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });


    }

} else {

    dispatch(actions.isNotLoading());
    toast.error("Mjesto ne pripada TKC-u tvrtke, provjerite unešene podatke", toastError);

}
} else {

    dispatch(actions.isNotLoading());
    toast.error("Niste ispravno odabrali mjesto i/ili ulicu tvrtke", toastError);
}




        
        
}  
    
const handlePublishChange = (event) => {
    
    setObjava(event.target.id);
    
    console.log(event);
    console.log(event.target.id);

    console.log("Tražena vrijednost objave je: " + event.target.id);


};

const handleOwnerChange = (event) => {
    
    setVrstaSloga(event.target.id);
    
    console.log(event);
    console.log(event.target.id);

    console.log("Tražena vrijednost sloga je: " + event.target.id);


};

/***************************************************************************************************** */



async function getDataPhone (oznaka) {


    dispatch(actions.isLoading());

    
    APICall(

        '/GetTelefonDnevne',
        
        {

             platform: '0',
             version:'1.0',
             oznaka: oznaka,

         },
        {
            token
        }).then(


            (response) => {
               
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                if(response.status==200){
            
                        if(response.data.naziv && response.data.naziv != ""){
                                
                                        let mj = '';
                                        let adr = '';
                                        let pt = '';
                            

                                        if(response.data.nazivMjesto && response.data.nazivMjesto!=''){

                                            mj = response.data.nazivMjesto;

                                        }
                                        if(response.data.nazivUlica && response.data.nazivUlica!=''){

                                            adr = response.data.nazivUlica;

                                        }
                                        if(response.data.adm_kucni_broj && response.data.adm_kucni_broj!=''){

                                            adr = adr + ' ' + response.data.adm_kucni_broj;

                                        }                                
                                        if(response.data.ptt && response.data.ptt!=''){

                                            pt = response.data.ptt;

                                        }
                                        if(response.data.adm_kbr_dodatak && response.data.adm_kbr_dodatak!=''){
                                            adr = adr + response.data.adm_kbr_dodatak;
                                        }
                                        setBureInfo("" + response.data.naziv + " --- " + mj + " --- " + adr + " --- " + pt +   
                                            " --- "  + response.data.tip + 
                                            " --- " + response.data.tk_oper + "---" + response.data.tk_operator
                                        )



                        
                                            
                        }else if(response.data.setMsg && response.data.setMsg==1){

                                        setBureInfo(response.data.message);
                        }

                } else {

                    if(response.status == 401){

                            console.log("Istekla sesija");
    
                            toast.error(response.data.message, toastError);
                            
                            dispatch(actions.logOut());
                            navigate('/');

                    } else {
                            toast.error(response.data.message,
                                toastError);
                                                

                    }
  
               
                }        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
            


            
                        if(!error.response){

                             toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);
                          


                        } else {


                             if(!error.response.status){

                                  toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                  toastError);

                             }else{

                                  if (error.response.status == 401) {
              
                           
                                       toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                  
                             
                                  } else {
                             
                             
                                            toast.error(error.response.data.message,
                                                 toastError);
                                                                           
                                       
                                  }
                             }
                        }
                    
                   
            
            
            });

            
            
} 
/************************************************** */




const getDjelatnosti = () => {
    APICall("/getDjelatnosti", {

        platform: '0',
        version:'1.0',

    searchNaziv

    }, {
        token
    }).then(response=>{
        
        console.log(response)
        if(response.status !== 200) {

            if(response.status == 401){

                console.log("Istekla sesija");

                toast.error(response.data.message, toastError);
                
                dispatch(actions.logOut());
                navigate('/');

        } else{

                toast.error(response.data.message, toastError);

                

        }


        } else {
            
            if(response.data.list && response.data.list.length!=0){
                var dataTmp = response.data;
                setAllDjelatnosti(dataTmp)



                //setData(dataTmp.list);

                let i = 0;

                /*let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                    var a = column.charAt(0).toUpperCase() + column.slice(1)
                        return(
                            {
                                "field": column,
                                "getRowId": index
                            }
                        )
                })*/
                let columns = [{
                    "field": "naziv",
                    "getRowId": 1, minWidth: 250
                }]
                let rows =dataTmp.list.map((item, index)=> {
                        console.log(item.naziv)
                    return({naziv:item.naziv, 
                        id:index})
                })
                console.log({
                    columns,
                    rows
            })

                setFilteredTableData({
                        columns,
                        rows
                })

                console.log("Set filtered stuff")


                    
                }else{



                        //toast.info(response.data.message,
                        //    toastInfo);
                    
                        //setTableData([]);


                    

                }




        }
        
    
    }).catch(error=> {
            
            console.log(error);


            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                toastError);                    

        
    })
}

const addDjelatnost = (data) => {

        //let tmpTKC = tkc?tkc.tkc:'';
        let tmpTKC = tkcFirma?tkcFirma:'';

        console.log("Adding djelatnost");




        let tmpNazivMas = nazivMas?nazivMas.trim().toUpperCase():'';
        tmpNazivMas = cleanString(tmpNazivMas);

        console.log("Naziviiiiiiiii****************************************************")
        console.log(nazivMas);
        console.log(tmpNazivMas);

        let tmpNazivZnak = nazivZnak?nazivZnak.trim().toUpperCase():' '; 
        tmpNazivZnak=cleanString(tmpNazivZnak);

        let tmpNazivNemas =  nazivNemas?nazivNemas.trim():'';
        tmpNazivNemas = cleanString(tmpNazivNemas);


        console.log(tmpNazivMas);
        console.log(tmpNazivZnak);
        console.log(tmpNazivNemas);

        let tmpNaziv = tmpNazivMas + '' + tmpNazivZnak + ' ' + tmpNazivNemas;


        let nazKratki = generirajSkraceniNaziv(tmpNazivMas, tmpNazivNemas);



        console.log("Adding with data");
        console.log(data);
        console.log(data.sifra);
        let tmpDjel = data.sifra;
        console.log(naziv);
        console.log(sifra);
        console.log(ulica);
        console.log(kbr)
        console.log(selectedUlica)
        console.log(selectedUlica.ULICA_ID)


        console.log(tmpTKC);

        //if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !naziv || naziv==''){
        if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !nazKratki || nazKratki==''){

                toast.warning("Morate odabrati mrežu u izborniku u gornjem desnom kutu ekrana te unijeti ispravnu šifru tvrtke", toastInfo)

        } else {

                console.log(mjesto);
                console.log(ulica);
                APICall("/addDjelatnostBijele", {


                    platform: '0',
                    version:'1.0',
                    tkc: tmpTKC,
                    //naziv: naziv,
                    naziv: nazKratki,
                    sifra: sifra,
                    //ulica: ulica,
                    ulica:selectedUlica.ULICA_ID,
                    kbr: kbr,
                    alfa: '',
                    data: data,
                    ref:ref

                }, {
                    token
                }).then(response=>{
                    
                    console.log(response)
                    if(response.status !== 200) {

                                    if(response.status == 401){

                                        console.log("Istekla sesija");

                                        toast.error(response.data.message, toastError);
                                        
                                        dispatch(actions.logOut());
                                        navigate('/');

                                    } else{
                                    
                                        toast.error(response.data.message, toastError);

                                        

                                    }


                    } else {
                        console.log("Success");
                        console.log(response.data);

                        setZuteStranice(false);
                        //toast.success(response.data.message, toastSuccess);


                        console.log(tmpDjel)
                        changeOldDjelatnostBijele(tmpDjel)

                        


                        //getCompanySifra(sifra);





                    }
                    
                
                }).catch(error=> {
                        
                        console.log(error);


                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                            toastError);                    

                    
                })

        }
    } 



const changeOldDjelatnostBijeleArr = (arrSifre) => {

    //let tmpTKC = tkc?tkc.tkc:'';

    let tmpTKC = tkcFirma?tkcFirma:'';

    console.log("Changing djelatnost");

    console.log(arrSifre);


    console.log(tmpTKC);



    if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !arrSifre || arrSifre.length < 1){

            toast.warning("Morate odabrati mrežu u izborniku u gornjem desnom kutu ekrana te ispravno odabrati tvrtku i djelatnost koju želite obrisati", toastInfo)

    } else {


            APICall("/changeOldDjelatnostBijeleArr", {


                platform: '0',
                version:'1.0',
                tkc: tmpTKC,
            
                sifra: sifra,

                data: arrSifre,
                ref: ref


            }, {
                token
            }).then(response=>{
                
                console.log(response)
                if(response.status !== 200) {

                                if(response.status == 401){

                                    console.log("Istekla sesija");

                                    setZuteStranice(false);

                                    toast.error(response.data.message, toastError);


                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                                } else{
                                
                                    setZuteStranice(false);
                                    toast.error(response.data.message, toastError);

                                    

                                }


                } else {
                    console.log("Success");
                    console.log(response.data);

                    setZuteStranice(false);

                    toast.success(response.data.message, toastSuccess);


                    //getCompanySifra(sifra);


                }
                
            
            }).catch(error=> {
                    
                    console.log(error);

                    setZuteStranice(false);


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 

const changeOldDjelatnostBijele = (sifra_djel) => {

    //let tmpTKC = tkc?tkc.tkc:'';

    let tmpTKC = tkcFirma?tkcFirma:'';

    console.log("Changing djelatnost");

    console.log(sifra_djel);


    console.log(tmpTKC);



    


    if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !sifra_djel || sifra_djel==''){

            toast.warning("Morate odabrati mrežu u izborniku u gornjem desnom kutu ekrana te ispravno odabrati tvrtku i djelatnost koju želite obrisati", toastInfo)

    } else {


            APICall("/changeOldDjelatnostBijele", {


                platform: '0',
                version:'1.0',
                tkc: tmpTKC,
            
                sifra: sifra,

                data: sifra_djel,
                ref: ref


            }, {
                token
            }).then(response=>{
                
                console.log(response)
                if(response.status !== 200) {

                                if(response.status == 401){

                                    console.log("Istekla sesija");

                                    setZuteStranice(false);

                                    toast.error(response.data.message, toastError);


                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                                } else{
                                
                                    setZuteStranice(false);
                                    toast.error(response.data.message, toastError);

                                    

                                }


                } else {
                    console.log("Success");
                    console.log(response.data);

                    setZuteStranice(false);

                    toast.success(response.data.message, toastSuccess);


                    //getCompanySifra(sifra);


                }
                
            
            }).catch(error=> {
                    
                    console.log(error);

                    setZuteStranice(false);


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 

const kopirajNaslov = (data) => {




    //let tmpTKC = tkc?tkc.tkc:'';
    let tmpTKC = tkcFirma?tkcFirma:'';

    console.log("Copying naslov u djelatnost");

    console.log("Adding with data");
    
    console.log(data);
    
    console.log(naziv);


    console.log(sifra);
    console.log(ulica);
    console.log(kbr)
    console.log(selectedUlica)
    console.log(selectedUlica.ULICA_ID)


    console.log(selectedUlica)


            let tmpNazivMas = nazivMas?nazivMas.trim().toUpperCase():'';
        tmpNazivMas = cleanString(tmpNazivMas);

        console.log("Naziviiiiiiiii****************************************************")
        console.log(nazivMas);
        console.log(tmpNazivMas);

        let tmpNazivZnak = nazivZnak?nazivZnak.trim().toUpperCase():' '; 
        tmpNazivZnak=cleanString(tmpNazivZnak);

        let tmpNazivNemas =  nazivNemas?nazivNemas.trim():'';
        tmpNazivNemas = cleanString(tmpNazivNemas);


        console.log(tmpNazivMas);
        console.log(tmpNazivZnak);
        console.log(tmpNazivNemas);

        let tmpNaziv = tmpNazivMas + '' + tmpNazivZnak + ' ' + tmpNazivNemas;


        let nazKratki = generirajSkraceniNaziv(tmpNazivMas, tmpNazivNemas);

    console.log(tmpTKC);

    if(!tmpTKC || tmpTKC=="" || !sifra || sifra=="" || !naziv || naziv==''){

            toast.warning("Morate odabrati mrežu u izborniku u gornjem desnom kutu ekrana te unijeti ispravnu šifru tvrtke", toastInfo)

    } else {

            console.log(mjesto);
            console.log(ulica);
            APICall("/kopirajNaslovUDjelatnost", {


                platform: '0',
                version:'1.0',
                tkc: tmpTKC,
                //naziv: naziv,
                naziv: nazKratki,
                sifra: sifra,
                //ulica: ulica,
                ulica:selectedUlica.ULICA_ID,
                kbr: kbr,
                alfa: '',
                data: data

            }, {
                token
            }).then(response=>{
                
                console.log(response)
                if(response.status !== 200) {

                                if(response.status == 401){

                                    console.log("Istekla sesija");

                                    toast.error(response.data.message, toastError);
                                    
                                    dispatch(actions.logOut());
                                    navigate('/');

                                } else{
                                
                                    toast.error(response.data.message, toastError);

                                    

                                }


                } else {
                    console.log("Success");
                    console.log(response.data);

                    setZuteStranice(false);
                    toast.success(response.data.message, toastSuccess);

                    


                    //getCompanySifra(sifra);





                }
                
            
            }).catch(error=> {
                    
                    console.log(error);


                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                        toastError);                    

                
            })

    }
} 


/************************************************** */

const [PHTableDate, setPHTableDate] = useState('');

async function getPHInfo() {



    console.log("Getting ph");

    dispatch(actions.isLoading());

    APICall(
        '/GetPHInfo',
        {

            platform: '0',
            version:'1.0',

        },
        {
            token
        }).then(


            (response) => {

                console.log(response)

                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
                if (response.status==200) {
                    

                    console.log(response.data.message)

                    console.log(response.data.date)
                    setPHTableDate(response.data.date)

                    setIsPoslovnaHrvaska(true);



                } else {



                    if (response.status == 401) {
            
                        
                        toast.error(response.data.message,
                                toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   

                    
                
                    } else {
                
                
                        toast.error(response.data.message,
                                    toastError);

                                                            
                        
                    }


                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  


async function getPH(oibTmp, mjestoTmp, pttTmp, nazivTmp) {



    console.log("Getting ph");

    dispatch(actions.isLoading());

    APICall(
        '/GetPH',
        {

            platform: '0',
            version:'1.0',
            oib: oibTmp,
            naziv:nazivTmp,
            mjesto: mjestoTmp,
            ptt: pttTmp

        },
        {
            token
        }).then(


            (response) => {

                console.log(response)

                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
                if (response.status==200) {
                    

                    console.log(response.data.message)

                    console.log(response.data)

            
                    if(response.data.company && response.data.company.length>0){

                            let columns= Object.getOwnPropertyNames(response.data.company[0]).map((column,index)=>{
                            
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index,
                                        
                                    
                                    }
                                )
                            })
            
        
                
                                
                            let rows =response.data.company.map((item, index)=> {
                                    return({...item,id:index})
                            })
                
                            console.log("Setting ph company array--------------------------------");
                            console.log(columns);
                            console.log(rows);
                            
                
                            setPHCompany({
                                        columns,
                                        rows
                            })
                        

                    } else {

                        toast.error("Nisu pronađene tvrtke koje odgovaraju unesenim podacima", toastError);
                        setPHCompany([],[]);
                    }






                } else {



                    if (response.status == 401) {
            
                        
                        toast.error(response.data.message,
                                toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   

                    
                
                    } else {
                
                
                        toast.error(response.data.message,
                                    toastError);

                        setPHCompany([],[]);
                                                            
                        
                    }


                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  

async function GetPHDetalji(id) {



    console.log("Getting ph detalji: " + id);

    dispatch(actions.isLoading());

    APICall(
        '/GetPHDetalji',
        {

            platform: '0',
            version:'1.0',
            id: id

        },
        {
            token
        }).then(


            (response) => {

                console.log(response)

                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
                if (response.status==200) {
                    

                    console.log(response.data.message)

                    console.log(response.data)

            
                    if(response.data.company && response.data.company.length!=''){

                        let tmp = response.data.company;


                        

                        setPHNaziv(tmp.naziv?tmp.naziv:'');
                        setPHMjesto(tmp.mjesto?tmp.mjesto:'');
                        setPHPTT(tmp.postanski_broj?tmp.postanski_broj:'');
                        setPHAdresa(tmp.adresa?tmp.adresa:'');

                        setPHOpis(tmp.nkd2007_opis?tmp.nkd2007_opis:'');
                        setPHPravni(tmp.pravni_oblik?tmp.pravni_oblik:'');
                        setPHRegSud(tmp.reg_sud?tmp.reg_sud:'');
                        setPHTel(tmp.telefon?tmp.telefon:'');
                        setPHMob(tmp.mobitel?tmp.mobitel:'');
                        setPHMail(tmp.e_mail?tmp.e_mail:'');
                        setPHAktivan(tmp.aktivnost?tmp.aktivnost:'');



                        setPHOIB(tmp.oib?tmp.oib:'');
                        setPHSubjekt(tmp.id_subjekta);
                        setPHBlokiran(tmp.blokiran?tmp.blokiran:'');
                        setPHOsnovano(tmp.godina_osnivanja?tmp.godina_osnivanja:'');
                        setPHVlasnik(tmp.vlasnik?tmp.vlasnik:'');
                        setPHOdgovoran(tmp.odgovorna_osoba?tmp.odgovorna_osoba:'');
                        let zaposleni_3 = tmp.last_year_br_zap?tmp.last_year_br_zap:0 + tmp.last_year_minus_1_br_zap?tmp.last_year_minus_1_br_zap:0 + 
                        tmp.last_year_minus_2_br_zap?tmp.last_year_minus_2_br_zap:0 + tmp.last_year_minus3__br_zap?tmp.last_year_minus3__br_zap:0;
                        setPHZaposleni(zaposleni_3);
                        let prihodi_3 = tmp.last_year_prihodi?tmp.last_year_prihodi:0 + tmp.last_year_minus_1_prihodi?tmp.last_year_minus_1_prihodi:0 + 
                        tmp.last_year_minus_2_prihodi?tmp.last_year_minus_2_prihodi:0 + tmp.last_year_minus3__prihodi?tmp.last_year_minus3__prihodi:0;
                        setPHPrihodi(prihodi_3);
                        let rashodi_3 = tmp.last_year_rashodi?tmp.last_year_rashodi:0 + tmp.last_year_minus_1_rashodi?tmp.last_year_minus_1_rashodi:0 + 
                        tmp.last_year_minus_2_rashodi?tmp.last_year_minus_2_rashodi:0 + tmp.last_year_minus3__rashodi?tmp.last_year_minus3__rashodi:0;
                        setPHRashodi(rashodi_3);


                    } else {

                        toast.error("Nisu pronađene detaljni podaci tražene tvrtke", toastError);


                        setPHOIB('');
                        setPHSubjekt('');
                        setPHBlokiran('');
                        setPHOsnovano('');
                        setPHVlasnik('');
                        setPHOdgovoran('');
                        setPHZaposleni('');
                        setPHPrihodi('');
                        setPHRashodi('');

                        setPHMjesto('');
                        setPHPTT('');
                        setPHAdresa('');

                        setPHOpis('');
                        setPHPravni('');
                        setPHRegSud('');
                        setPHTel('');
                        setPHMob('');
                        setPHMail('');
                        setPHAktivan('');
                        setPHNaziv('');
                        
                    }






                } else {


                    setPHOIB('');
                    setPHSubjekt('');
                    setPHBlokiran('');
                    setPHOsnovano('');
                    setPHVlasnik('');
                    setPHOdgovoran('');
                    setPHZaposleni('');
                    setPHPrihodi('');
                    setPHRashodi('');

                    setPHMjesto('');
                    setPHPTT('');
                    setPHAdresa('');

                    setPHOpis('');
                    setPHPravni('');
                    setPHRegSud('');
                    setPHTel('');
                    setPHMob('');
                    setPHMail('');
                    setPHAktivan('');
                    setPHNaziv('');

                    if (response.status == 401) {
            
                        
                        toast.error(response.data.message,
                                toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   

                    
                
                    } else {
                
                
                        toast.error(response.data.message,
                                    toastError);

                        setPHCompany([],[]);
                                                            
                        
                    }


                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            } else {

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  


async function getMB() {



    console.log("Getting MB");

    dispatch(actions.isLoading());

    APICall(
        '/GetMBData',
        {

            platform: '0',
            version:'1.0',
            oib: OIB,
            mb:'',

        },
        {
            token
        }).then(


            (response) => {

                console.log(response)

                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
                if (response.status==200) {
        

                    console.log(response.data)

                    
                    if(response.data && response.data.length>0){

                            let columns= Object.getOwnPropertyNames(response.data[0]).map((column,index)=>{
                            
                                return(
                                    {
                                        "field": column,
                                        "getRowId": index,
                                        
                                    
                                    }
                                )
                            })
            





                            const updatedColumns = columns.map((col) => {
                                
                
                                        if(col.field == "Naziv" || col.field == "naziv"){
                                            return {
                                                field: col.field,
                                                headerName: 'Naziv',
                                                
                                            }
                                        }else if(col.field== 'Mjesto_naziv' || col.field== 'mjesto_naziv'){
                                            return {
                                                field: col.field,
                                                headerName: 'Mjesto',
                                                
                                            }
                                        } else if(col.field=='Ulica_naziv' || col.field=='ulica_naziv'){

                                            return {
                                                field: col.field,
                                                headerName: 'Ulica',
                                                
                                            }
                                        }else if(col.field== 'Kbr' || col.field== 'kbr'){
                                            return {
                                                field: col.field,
                                                headerName: 'Kbr',
                                                
                                            }
                                        }else if(col.field== 'Alfa' || col.field== 'alfa' ){
                                            return {
                                                field: col.field,
                                                headerName: 'Slovo',
                                                
                                            }
                                        }else if(col.field== 'Kontakt' || col.field== 'kontakt'){
                                            return {
                                                field: col.field,
                                                headerName: 'Kontakt',
                                                
                                            }
                                        }else if(col.field== 'Oib' || col.field== 'oib'){
                                            return {
                                                field: col.field,
                                                headerName: 'OIB',
                                                
                                            }
                                        }else if(col.field== 'Koliko_ih_ima' || col.field== 'koliko_ih_ima'){
                                            return {
                                                field: col.field,
                                                headerName: 'Br. djel.',
                                                
                                            }
                                        }else if(col.field== 'Kaj' || col.field== 'kaj'){
                                            return {
                                                field: col.field,
                                                headerName: 'Djelatnost',
                                                
                                            }
                                        }else if(col.field== 'Tkc' || col.field== 'tkc'){
                                            return {
                                                field: col.field,
                                                headerName: 'TKC',
                                                
                                            }
                                        } else if(col.field == 'Sifra' || col.field == 'sifra'){
                        
                                            return {
                                                ...col,
                                                headerName:'Šifra',
                                               
                                            }
                                            
                        
                                        } else if(col.field== 'Naziv_mali_full' || col.field== 'naziv_mali_full'){

                                            return {
                                                ...col,
                                                headerName:'Naziv mali',
                                                hide:true

                                            }
                                            
                                        } else {

                                            return {
                                                field: col.field,
                                                hide:true
                                                
                                            }
                                        }
                        
                        
                                        //return col;
                                    });
                        
                        
                            columns = updatedColumns;


                
                                
                            let rows =response.data.map((item, index)=> {
                                    return({...item,id:index})
                            })
                
                            console.log("Setting MB company array--------------------------------");
                            console.log(columns);
                            console.log(rows);
                            
                
                            setTableDataMB({
                                        columns,
                                        rows
                            })
                        

                            setMB(true);

                    } else {

                        toast.error("Nisu pronađene tvrtke koje odgovaraju unesenim podacima", toastError);
                        setTableDataMB([],[]);
                    }


                

                            



                } else {



                    if (response.status == 401) {
            
                        
                        toast.error(response.data.message,
                                toastError);
                        
                                setTimeout(() => {
                                    dispatch(actions.logOut());
                                    navigate('/');
                                }, 5000);   

                    
                
                    } else {
                
                
                        toast.error(response.data.message,
                                    toastError);

                        setTableDataMB([],[]);
                                                            
                        
                    }


                }

        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
   


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

            
            
}  


async function updateFromMemoMB() {


    console.log("Setting MEmo")
    console.log(memoMB);
    console.log(chosenMB);


    if(!memoMB){

        toast.error("Niste zapamtili tvrtku čije podatke kopirate", toastError);

    } else {

        if(!chosenMB || chosenMB==memoMB){

            toast.error("Niste odabrali tvrtku u koju želite kopirati ili su odabrane tvrtke jednake", toastError)
        
        } else {

                APICall(

                    '/updateMB',
                    {
                
                        platform: '0',
                        version:'1.0',
                        chosenMB: chosenMB,
    
                        memoMB: memoMB,
                
                
                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);

                                    setMemoMB(null)
                                    setMemoMBName('')
                                    setMemoMBSifra('')
                                    setMemoMBTKC('')
                                    
                                    
                                        
                            } else {

                                    if(response.status==401){
                                                toast.error(response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   

                                    } else {

                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                    } 


                            }
                
                    
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });
                    
        }

    }




        
        
}  

async function updateContactsMB() {


    console.log("Setting contacts")
    console.log(kontakti);
    console.log(OIB);


    if(!OIB || OIB==''){

        toast.error("Ne postoji OIB/MB po kojem bi se kopirali podaci", toastError);

    } else {

        if(!kontakti || kontakti==''){

            toast.error("Nisu upisani kontakti za upis", toastError)
        
        } else {

                APICall(


                    '/updateContactMB',
                    {
                
                        platform: '0',
                        version:'1.0',
                        oib: OIB,
                  
    
                        contact: kontakti,
                
                
                    },
                    {
                        token
                    }).then(
                
                
                        (response) => {
                            console.log(response)
                            dispatch(actions.isNotLoading());
                
                            if(response==undefined) dispatch(actions.isNotLoading());
                            if (response.status==200) {
                                
                                var dataTmp = response.data.msg;
                
                
                
                                console.log(dataTmp)
                
                                toast.success("Uspješno spremljene izmjene",
                                    toastSuccess);
                                    
                                    
                                        
                            } else {

                                    if(response.status==401){
                                                toast.error(response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   

                                    } else {

                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                    toastError);
                                    } 


                            }
                
                    
                                
                        
                        },
                
                        (error) => {
                
                            dispatch(actions.isNotLoading());
                
                        
                
                
                
                        
                                    if(!error.response){
                
                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                                    
                
                
                                    } else {
                
                
                                        if(!error.response.status){
                
                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                            toastError);
                
                                        }else{
                
                                            if (error.response.status == 401) {
                        
                                    
                                                toast.error(error.response.data.message,
                                                        toastError);
                                                
                                                        setTimeout(() => {
                                                            dispatch(actions.logOut());
                                                            navigate('/');
                                                        }, 5000);   
                
                                            
                                        
                                            } else {
                                        
                                        
                                                        toast.error(error.response.data.message,
                                                            toastError);
                                                                                    
                                                
                                            }
                                        }
                                    }
                                
                            
                        
                        
                        });
                    
        }

    }




        
        
} 


const handleChangeTel = (event) => {
  if (event.target.value.match(/[^0-9]/)) {
    event.preventDefault();
  } else {

    setTelStrukt(event.target.value);
    }

}
const handleChangeMreza = (event) => {
  if (event.target.value.match(/[^0-9]/)) {
    event.preventDefault();
  } else {

    setMrezaStrukt(event.target.value);
    }

}
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/*********************************MODAL RESIZE/MOVE****************************************************************************** */
/******************************************************************************************************************************** */

const resetPositionModal=(e)=>{




    if(e.keyCode==81 ) {
        console.log("Testing");
        console.log(propsInfoVisible);

        if(propsInfoVisible){
            console.log(e.keyCode);
            setModalPositionPropsBijele({x:0,y:0});
        } else if(MB){
            setModalPositionMB({x:0,y:0});

        } else if(tvrtkeModal){
            setModalTvrtkePosition({x:0,y:0});
        } else if(isPoslovnaHrvaska){
            setModalPositionPH({x:0,y:0});
        }else{
            console.log("Ignore!!!");
        }
    }
}

const [isDraggingPropsBijele, setIsDraggingPropsBijele] = useState(false)
const [propsBijelePosition,setPropsBijelePosition] = useState(false)

const [modalPositionPropsBijele, setModalPositionPropsBijele] = useState({x:0,y:0})
const startPositionPropsBijele = useRef({x:0,y:0})
const popupRefPropsBijele = useRef(null)


const [isDraggingMB, setIsDraggingMB] = useState(false)
const [MBPosition,setMBPosition] = useState(false)

const [modalPositionMB, setModalPositionMB] = useState({x:0,y:0})
const startPositionMB = useRef({x:0,y:0})
const popupRefMB = useRef(null)

const [isDraggingPH, setIsDraggingPH] = useState(false)
const [PHPosition,setPHPosition] = useState(false)

const [modalPositionPH, setModalPositionPH] = useState({x:0,y:0})
const startPositionPH = useRef({x:0,y:0})
const popupRefPH = useRef(null)


const [isDraggingTvrtke, setIsDraggingTvrtke] = useState(false)
const [tvrtkePosition,setTvrtkePosition] = useState(false)

const [modalTvrtkePosition, setModalTvrtkePosition] = useState({x:0,y:0})
const startPositionTvrtke = useRef({x:0,y:0})
const popupRefTvrtke = useRef(null)

const onMouseMove = useCallback((e) => {
    //console.log(e.clientx, startPosition);
  if (!isDraggingPropsBijele) return;
  setModalPositionPropsBijele({
    x: e.clientX - startPositionPropsBijele.current.x,
    y: e.clientY - startPositionPropsBijele.current.y,
  });
  if (!isDraggingMB) return;
  setModalPositionMB({
    x: e.clientX - startPositionMB.current.x,
    y: e.clientY - startPositionMB.current.y,
  });
  
  if (!isDraggingPH) return;
  setModalPositionPH({
    x: e.clientX - startPositionPH.current.x,
    y: e.clientY - startPositionPH.current.y,
  });

  if (!isDraggingTvrtke) return;
  setModalTvrtkePosition({
    x: e.clientX - startPositionTvrtke.current.x,
    y: e.clientY - startPositionTvrtke.current.y,
  });

  if (!isDragging) return;
  setModalPosition({
    x: e.clientX - startPosition.current.x,
    y: e.clientY - startPosition.current.y,
  });
  
},
[isDragging, isDraggingPropsBijele, isDraggingMB, isDraggingPH, isDraggingTvrtke]
);

// Function to handle the end of a drag event
const onMouseUp = () => {
    setIsDraggingPropsBijele(false);
    setIsDraggingMB(false);

    setIsDraggingPH(false);
   
    setIsDraggingTvrtke(false);
    setIsDragging(false);
};

const onMouseDown = (e) => {
console.log("on mouse down")
e.stopPropagation();

console.log("Modal is open?");
console.log(openModal)

setIsDraggingMB(true);
startPositionMB.current = { x: e.clientX - modalPositionMB.x, y: e.clientY - modalPositionMB.y }

setIsDraggingPH(true);
startPositionPH.current = { x: e.clientX - modalPositionPH.x, y: e.clientY - modalPositionPH.y }


setIsDraggingTvrtke(true);
startPositionTvrtke.current = { x: e.clientX - modalTvrtkePosition.x, y: e.clientY - modalTvrtkePosition.y }
setIsDragging(true);
startPosition.current = { x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y }

setIsDraggingPropsBijele(true);
startPositionPropsBijele.current = { x: e.clientX - modalPositionPropsBijele.x, y: e.clientY - modalPositionPropsBijele.y }



}


const onMouseDownMB = (e) => {
console.log("on mouse down")
e.stopPropagation();



setIsDraggingMB(true);
startPositionMB.current = { x: e.clientX - modalPositionMB.x, y: e.clientY - modalPositionMB.y }

setIsDraggingTvrtke(true);
startPositionTvrtke.current = { x: e.clientX - modalTvrtkePosition.x, y: e.clientY - modalTvrtkePosition.y }

setIsDragging(true);
startPosition.current = { x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y }

setIsDraggingPropsBijele(true);
startPositionPropsBijele.current = { x: e.clientX - modalPositionPropsBijele.x, y: e.clientY - modalPositionPropsBijele.y }

setIsDraggingPH(true);
startPositionPH.current = { x: e.clientX - modalPositionPH.x, y: e.clientY - modalPositionPH.y }



}

const onMouseDownPH = (e) => {
console.log("on mouse down")
e.stopPropagation();


setIsDraggingPH(true);
startPositionPH.current = { x: e.clientX - modalPositionPH.x, y: e.clientY - modalPositionPH.y }


setIsDraggingMB(true);
startPositionMB.current = { x: e.clientX - modalPositionMB.x, y: e.clientY - modalPositionMB.y }

setIsDraggingTvrtke(true);
startPositionTvrtke.current = { x: e.clientX - modalTvrtkePosition.x, y: e.clientY - modalTvrtkePosition.y }

setIsDragging(true);
startPosition.current = { x: e.clientX - modalPosition.x, y: e.clientY - modalPosition.y }

setIsDraggingPropsBijele(true);
startPositionPropsBijele.current = { x: e.clientX - modalPositionPropsBijele.x, y: e.clientY - modalPositionPropsBijele.y }





}




useEffect(() => {
window.addEventListener("mousemove", onMouseMove);
window.addEventListener("mouseup", onMouseUp);
window.addEventListener("keydown", resetPositionModal);

return () => {
  window.removeEventListener("mousemove", onMouseMove);
  window.removeEventListener("mouseup", onMouseUp);
  window.removeEventListener("keydown", resetPositionModal);

};
}, [onMouseMove], resetPositionModal);

// Reset position when the popup is closed
useEffect(() => {
if (!propsInfoVisible) {
    setPropsBijelePosition({ x: 0, y: 0 });
}
if (!MB) {
    setMBPosition({ x: 0, y: 0 });
  }

if (!isPoslovnaHrvaska) {
    setPHPosition({ x: 0, y: 0 });
  }

if (!tvrtkeModal) {
    setTvrtkePosition({ x: 0, y: 0 });
}
if (!modalIsOpen) {
    setModalPosition({ x: 0, y: -150 });
  }
}, [modalIsOpen, propsInfoVisible, MB, isPoslovnaHrvaska, tvrtkeModal]);



/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */



const generirajSkraceniNaziv = (nazivMasni, nazivNemasni) => {
  let tempSkraceni = "";

  const suffixes = [
    { text: "D.D.", label: " D.D." },
    { text: "d.d.", label: " d.d." },
    { text: "J.D.O.O", label: " J.D.O.O." },
    { text: "j.d.o.o", label: " j.d.o.o." },
    { text: "D.O.O", label: " D.O.O." },
    { text: "d.o.o", label: " d.o.o." },
    { text: "K.D.", label: " K.D." },
    { text: "k.d.", label: " k.d." },
    { text: "vl.", label: null } // Special case: append suffix with comma
  ];

  let found = false;

  for (const suffix of suffixes) {
    const pos = nazivNemasni.indexOf(suffix.text);
    if (pos !== -1) {
      if (suffix.label !== null) {
        tempSkraceni = nazivMasni + suffix.label;
      } else {
        tempSkraceni = nazivMasni + ", " + nazivNemasni.substring(pos);
      }
      found = true;
      break;
    }
  }

  if (!found) {
    tempSkraceni = nazivMasni;
  }

  return tempSkraceni;
};


/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


  return (
    <Box theme={theme} className={modalIsOpen ? "DPDonat-modal-container bijele" : "" }      
    style={{ transform: modalIsOpen && !MB && !tvrtkeModal && !propsInfoVisible ? `translate(${modalPosition.x}px, ${modalPosition.y}px)` : "translate(0px,0px)"}} //to move out popup
    >

 {/*-----------Poslovna HR-----------------------*/}

            <Modal
                open={isPoslovnaHrvaska}
                onClose={()=> {
                    setIsPoslovnaHrvaska(false);
                    setPHOIB('');
                    setPHSubjekt('');
                    setPHBlokiran('');
                    setPHOsnovano('');
                    setPHVlasnik('');
                    setPHOdgovoran('');
                    setPHZaposleni('');
                    setPHPrihodi('');
                    setPHRashodi('');

                    setPHMjesto('');
                    setPHPTT('');
                    setPHAdresa('');

                    setPHOpis('');
                    setPHPravni('');
                    setPHRegSud('');
                    setPHTel('');
                    setPHMob('');
                    setPHMail('');
                    setPHAktivan('');
                    setPHNaziv('');
                    setPHCompany([],[]);

                    setZadajDioNaziva('');
                    setZadajMjesto('');
                    setZadajOIB('');
                    setZadajPTT('');
                    setOIBIzBijelihStranica('');
                }}
            >

                        <Box className="DPDonat-modal-container"  ref={popupRefPH}      
                                style={{resize: "both", 
                                transform: `translate(${modalPositionPH.x}px, ${modalPositionPH.y}px)`
                                 }}> 

                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      
                                onMouseDown={(e)=> onMouseDownPH(e)}>
                    
                                        
                                        <Typography className="DPDonat-header-title-text" variant="h6">
                                        <Typography>Poslovna Hrvatska {PHTableDate}</Typography>
                                        </Typography>  
                                    
                                    

                                </Box>

                                {/*<Box className="BijeleStranice-modal-container" >
                                    <Typography className="BijeleStranice-modal-title" variant="h5" style={{margin: "10px"}}>
                                        Poslovna Hrvatska {PHTableDate}
                                    </Typography>*/}
                                    <Box className="BijeleStranice-modal-content">
                                        {/*<Box sx={{width:"600px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>*/}
                                        
                                        <Grid container xs={10}  sx={{maxWidth: '100%',  
                                            display:"flex", flexDirection: 'row', alignItems:"center", justifyContent:"space-between", marginBottom:'1px'}}>
                                        <Grid xs={5} sx={{marginRight:'5px'}}>
                                        <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}  
                                            sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="OIB iz Bijelih stranica"
                                            variant="outlined"
                                            value={OIB}
                                            disabled
                                            />
                                        </Grid>
                                        <Grid xs={3}>
                                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                             color="info"
                                                //sx={{width:"100px"}} 
                                                fullWidth
                                                variant="contained" 
                                                onClick={() => {
                                                  
                                                    if(OIB && OIB!=''){

                                                        console.log("postoji oib!");
                                                        getPH(OIB, '', '', '');

                                                    } else {

                                                        toast.error("Ne postoji OIB iz bijelih stranica, unesite podatke i pretražite po zadanim parametrima", toastError)
                                                    }
                                                    
                                            }}>
                                             Traži po oibu
                                             </Button>
                                             </Grid>
                                        <Grid  xs={3}></Grid>

                                        </Grid>
                                      
                                        <Grid container xs={10}  sx={{maxWidth: '100%',  
                                            display:"flex", flexDirection: 'row', alignItems:"center", justifyContent:"space-between", marginBottom:'1px'}}>
                                        <Grid xs={5}  sx={{marginRight:'5px'}}>
                                           <TextField
                                            InputProps={{sx:{height:30}}}
                                            InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Zadani OIB"
                                            variant="outlined"
                                            value={zadajOIB}
                                            onChange={(event) => {
                                                setZadajOIB(event.target.value)
                                            }}/>


                                        </Grid>
                                        <Grid xs={3}>
                                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                             color="info"
                                                //sx={{width:"100px"}} 
                                                fullWidth
                                                variant="contained" 
                                                onClick={() => {
                                                  
                                              

                                                        console.log("postoji oib!");
                                                        getPH(zadajOIB, zadajMjesto, zadajPTT, zadajDioNaziva);

                                                    
                                                    
                                            }}>
                                             Traži po zadanom
                                             </Button>
                                             </Grid>
                                             <Grid xs={3}>

                                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                                //sx={{width:"100px"}} 
                                                fullWidth
                                                color="error"
                                                variant="contained" 
                                                onClick={() => {
                                                    setZadajDioNaziva('');
                                                    setZadajMjesto('');
                                                    setZadajOIB('');
                                                    setZadajPTT('');
                                                    setOIBIzBijelihStranica('');
                                                  
                                            }}>
                                             Briši polja
                                             </Button>
                                         
                                             </Grid>
                                        </Grid>

                                        <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                        <Grid xs={5}>
                                           <TextField
                                            InputProps={{sx:{height:30}}}
                                            InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Zadan dio naziva"
                                            variant="outlined"
                                            value={zadajDioNaziva}
                                            onChange={(event) => {
                                                setZadajDioNaziva(event.target.value)
                                            }}/>


                                        </Grid>
                                        </Grid>

                                        <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                        <Grid xs={5}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Zadano mjesto"
                                            variant="outlined"
                                            value={zadajMjesto}
                                            onChange={(event) => {
                                                setZadajMjesto(event.target.value)
                                            }} />

                                        </Grid>
                                        </Grid>

                                        <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                        <Grid xs={5}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Zadan PTT"
                                            variant="outlined"
                                            value={zadajPTT}
                                            onChange={(event) => {
                                                setZadajPTT(event.target.value)
                                            }}/>
                                    
                                    </Grid>
                                    </Grid>

                                        <Box className="BijeleStranice-PHmodal-data-display">



                                        {phCompany.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                rowData={phCompany.rows}
                                                columnDefs={phCompany.columns}

                                        

                                            
                                                ref={gridRef_PH}
                                                theme={themeAG}
                                            
                                                autoSizeStrategy={autoSizeStrategy_PH}
                                                onGridReady={onGridReady_PH}
                                                onColumnResized={onColumnResized_PH}

                                                onRowSelected={onRowSelected_PH}
                                                onSelectionChanged={onSelectionChanged_PH}

                                                
                                                rowSelection="single"
                                
                                                onRowClicked={cellClicked_PH}


                                        /></div> } 
                                        </Box>


                                        <Grid sx={{width:"100%", margin:"0px", gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                <Grid xs={4}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Naziv"
                                                        variant="outlined"
                                                        disabled
                                                        value={phNaziv}
                                                        
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Mjesto"
                                                        variant="outlined"
                                                        disabled
                                                        value={phMjesto}
                                                        
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="PTT"
                                                        variant="outlined"
                                                        disabled
                                                        value={phPTT}
                                                        
                                                />
                                                </Grid>
                                                <Grid xs={4}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Adresa"
                                                        variant="outlined"
                                                        value={phAdresa}
                                                        disabled
                                                />
                                                </Grid>

                                                <Grid xs={3}>
                                                   <TextField
                                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="OIB"
                                                        variant="outlined"
                                                        value={phOIB}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={9}>
                                                   <TextField
                                                    InputProps={{sx:{height:30}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                                    size="small"
                                                                    fullWidth
                                                                    id=""
                                                                    label="Opis"
                                                                    variant="outlined"
                                                                    value={phOpis}
                                                                    disabled
                                                                    
                                                />
                                                </Grid>

                                                <Grid xs={1}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Subjekt"
                                                        variant="outlined"
                                                        value={phSubjekt}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Reg. sud"
                                                        variant="outlined"
                                                        value={phRegSud}
                                                        disabled
                                                       
                                                />
                                                </Grid>
                                                <Grid xs={1}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Aktivnost"
                                                        variant="outlined"
                                                        value={phAktivan}
                                                        disabled
                                                       
                                                />
                                                </Grid>
                                                <Grid xs={1}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Blokiran"
                                                        variant="outlined"
                                                        value={phBlokiran}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={1}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Osnovano"
                                                        variant="outlined"
                                                        value={phOsnovano}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={6}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Pravni oblik"
                                                        variant="outlined"
                                                        value={phPravni}
                                                        disabled
                                                />
                                                </Grid>

                                                <Grid xs={3}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Vlasnik"
                                                        variant="outlined"
                                                        value={phVlasnik}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Odgovoran"
                                                        variant="outlined"
                                                        value={phOdgovoran}
                                                        disabled
                                                        
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                         <TextField
                                            InputProps={{sx:{height:30}}}
                                            InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Telefon"
                                                        variant="outlined"
                                                        value={phTel}
                                                        disabled
                                                        
                                                />
                                                </Grid>
                                                <Grid xs={2}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Mobitel"
                                                        variant="outlined"
                                                        value={phMob}
                                                        disabled
                                                       
                                                />
                                                </Grid>
                                                <Grid xs={3}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="E-mail"
                                                        variant="outlined"
                                                        value={phMail}
                                                        disabled
                                                        
                                                />
                                                </Grid>

                                                <Grid xs={4}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Zaposleni"
                                                        variant="outlined"
                                                        value={phZaposleni}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={4}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Prihodi"
                                                        variant="outlined"
                                                        value={phPrihodi}
                                                        disabled
                                                />
                                                </Grid>
                                                <Grid xs={4}>
                                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                        size="small"
                                                        fullWidth
                                                        id=""
                                                        label="Rashodi"
                                                        variant="outlined"
                                                        value={phRashodi}
                                                        disabled
                                                />
                                                </Grid>

                                        </Grid>

                                    </Box>

                                    <div className='DPDonat-modal-bottom'
        
                                        onMouseDown={(e)=>onMouseDown(e)}>

                                    </div>                                    
                                </Box>

          </Modal>
        
 {/*----------------------------------*/}

 {/*-----------EDIT ZUTE-----------------------*/}

            <Modal
                open={isEditZute}
                onClose={()=> {
                    setIsEditZute(false);
                    setEditMrezaZute('');
                    setEditTelZute('');
                    setEditNazivZute('');
                    
                    setEditKBRZute('');
                    setEditAlfaZute('');
                    setEditKomentarZute('');
                    setEditObjavaZute('1');
                    setEditKnjigaZute('1');

                    setSelectedUlicaZute({ULICA_ID:0,NAZIV:''});
                    
                }}
            >
                                <Box className="BijeleStranice-modal-container" >
                                    <Typography className="BijeleStranice-modal-title" variant="h5" style={{margin: "10px"}}>
                                        Uredi žute stranice tvrtke
                                    </Typography>
                                    <Box className="BijeleStranice-modal-content">
                                        {/*<Box sx={{width:"600px", display:"flex", alignItems:"center", justifyContent:"space-between"}}>*/}
                                        
                                        <Grid container xs={10}  sx={{maxWidth: '100%',  
                                            display:"flex", flexDirection: 'row', alignItems:"center", justifyContent:"space-between", marginBottom:'1px'}}>
                                        <Grid xs={5} sx={{marginRight:'5px'}}>
                                        <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}  
                                            sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Naziv"
                                            variant="outlined"
                                            value={editNazivZute}
                                            onChange={(event)=>{

                                                setEditNazivZute(event.target.value)
                                            }}
                                            />
                                        </Grid>

                                        <Grid  xs={3}></Grid>

                                        </Grid>
                                      
                                        <Grid container xs={10}  sx={{maxWidth: '100%',  
                                            display:"flex", flexDirection: 'row', alignItems:"center", justifyContent:"space-between", marginBottom:'1px'}}>

                                        <Grid xs={2}  sx={{marginRight:'5px'}}>
                                           <TextField
                                            InputProps={{sx:{height:30}}}
                                            InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"50px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Mreža"
                                            variant="outlined"
                                            value={editMrezaZute}
                                            onChange={(event) => {
                                                setEditMrezaZute(event.target.value)
                                            }}/>


                                        </Grid>                                                
                                        <Grid xs={5}  sx={{marginRight:'5px'}}>
                                           <TextField
                                            InputProps={{sx:{height:30}}}
                                            InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"300px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Tel."
                                            variant="outlined"
                                            value={editTelZute}
                                            onChange={(event) => {
                                                setEditTelZute(event.target.value)
                                            }}/>


                                        </Grid>
                                        
                                        </Grid>

                                        <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                        <Grid xs={7}>
                                                            <Autocomplete

                                                       
                                                                options={listUliceZute}
                                                                getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} 

                                                                isOptionEqualToValue={(option, value) => (option.ULICA_ID == value.ULICA_ID || option.ulica_id==value.ulica_id)}
                                                                
                                                

                                                                renderOption={(props, option) => {

                                                                    
                                                                                    const { key, ...optionProps } = props;
                                                                                    return (
                                                                                    <Box

                                                                                        key={option.ULICA_ID?option.ULICA_ID:(option.ulica_id?option.ulica_id:'')}
                                                                                        component="li"
                                                                                        sx={{backgroundColor: (option.AKTIVNA==1||option.aktivna==1)?'white':'yellow'}}                                                                        
                                                                                    
                                                                                        {...optionProps}
                                                                                    >   
                                                                                        {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} - {(option.AKTIVNA==1||option.aktivna==1)?"aktivna":"neaktivna"}
                                                                                    </Box>
                                                                                    );
                                                                }}                                                                
                                                                value={selectedUlicaZute}
                                                                inputValue={ulicaZute}
                                                                onHighlightChange={(event, option) => {
                                                                    setHighlightedOptionZute(option);
                                                                  }}
                                                                  onOpen={() => {
                                                                    setOpenZute(true); // Open only when clicked/focused
                                                                  }}
                                                                  onClose={() => {
                                                                    setOpenZute(false);
                                                                  }}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                      console.log('Selected:', newValue);
                                                                      
                                                                      //setLoading(false);
                                                                      //setOpen(false);
                                                                      console.log(newValue)
                                                                      setSelectedUlicaZute(newValue)
                                                                      setUlicaZute(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))
                                                                      setListUliceZute([])
                                                                      // Remove focus (blur)

                                                                      if (inputRefUliceZute.current) {
                                                                        inputRefUliceZute.current.blur();
                                                                      }
                                                                      setOpenZute(false);
                                                                    }

                                                                    
                                                                  }}
                                                                loading={loadingZute}
                                                           
                                                                onInputChange={(event, newInputValue, reason) => {
                                                                    console.log("New input value is here!!!!")
                                                                    console.log(newInputValue);
                                                                    setUlicaZute(newInputValue);
                                                                    // Don't open while typing manually
                                                                    if (reason === 'reset') {
                                                                        setOpenZute(false);
                                                                    }
                                                                }}
                                                   
                                                                renderInput={(params) => (
                                                                    <TextField

                                                                    {...params}

                                                                    label="Ulica"
                                                                    size="small" // smaller baseline size
                                                                    InputProps={{
                                                                      ...params.InputProps,
                                                                      sx: {
                                                                        height: '30px',
                                                                        minHeight: '30px',
                                                                        '& input': {
                                                                          padding: '0 8px',
                                                                          height: '30px',
                                                                          boxSizing: 'border-box',
                                                                        },
                                                                      },
                                                                    }}
                                                                    InputLabelProps={{
                                                                      sx: {
                                                                        fontSize: '0.75rem', // smaller label font
                                                                        top: '-6px', // shift label slightly up
                                                                      }
                                                                    }}
                                                                    inputRef={inputRefUliceZute}
                                                                    onKeyDown={handleKeyDownUlicaZute}
                                                                    onClick={() => setOpenZute(true)} // Open on click
                                                                    onFocus={() => setOpenZute(true)} // Open on focus
                                                                    />
                                                                )}
                                                                disableCloseOnSelect={false}
                                                             
                                                                autoHighlight

                                                                onFocus={event => {
                                                                
                                                                    event.target.select()
                                                
                                                                }}                                                               

                                                                                                                         
                                                                />

                                        </Grid>
                                        </Grid>

                                        <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                        <Grid xs={4}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"100px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="KBR"
                                            variant="outlined"
                                            value={editKBRZute}
                                            onChange={(event) => {
                                                setEditKBRZute(event.target.value)
                                            }} 
                                            
                                            inputRef={kbr_refZute}
                                            onKeyDown={(event) => {
                                                if (event.key === 'Enter'){

                                                    kbrZnak_refZute.current.focus();
                                                }
                                            }}

                                            onFocus={event => {
                                                
                                                event.target.select()
                                
                                            }}                                            
                                            />

                                        </Grid>

                                        <Grid xs={4}>
                                           <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }} sx={{width:"100px"}}
                                            size="small"
                                            fullWidth
                                            id=""
                                            label="Znak"
                                            variant="outlined"
                                            value={editAlfaZute}
                                            onChange={(event) => {
                                                setEditAlfaZute(event.target.value)
                                            }}
                                            
                                            inputRef={kbrZnak_refZute}
                                            /*onKeyDown={(event) => {
                                                if (event.key === 'Enter'){

                                                    kbrZnak_refZute.current.focus();
                                                }
                                            }}*/

                                            onFocus={event => {
                                                
                                                event.target.select()
                                
                                            }}                                               
                                            />                                        
                                        </Grid>
                                        </Grid>

                                    <Grid container xs={10} sx={{marginBottom:'1px'}}>
                                             <Grid xs={5}>

                                             <Button sx={{height:"30px", fontSize:"10px"}} 
                                                //sx={{width:"100px"}} 
                                                fullWidth
                                                color="error"
                                                variant="contained" 
                                                onClick={() => {
                                                    //editDjelatnostZute();

                                                    console.log(flagEditZute);
                                                    console.log('Ediitram')

                                                    if(flagEditZute == 0){

                                                        editDjelatnostZute();
                                                    } else {

                                                        editStrukturaZute();
                                                    }
                                                  
                                            }}>
                                             Spremi promjene
                                             </Button>
                                         
                                             </Grid>

                                    </Grid>






                                    </Box>
                                </Box>

          </Modal>
        
 {/*----------------------------------*/}


 {/*--------------MB Modal--------------------*/}

            <Modal
                          open={MB}
                          onClose={()=> {
                            setMemoMBName('');
                            setMemoMBSifra('');
                            setMemoMBTKC('');
                            setMB_Current('');
                              setMB(false)
                          }}
            >

                        <Box className="DPDonat-modal-container"  ref={popupRefMB}      
                                style={{resize: "both", 
                                transform: `translate(${modalPositionMB.x}px, ${modalPositionMB.y}px)`
                                 }}> 

                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      
                                onMouseDown={(e)=> onMouseDownMB(e)}>
                    
                                        
                                        <Typography className="DPDonat-header-title-text" variant="h6">
                                        <Typography>Pregled po OIB - u po cijeloj RH</Typography>
                                        </Typography>  
                                    
                                    

                                </Box>


                                    
                                    <Box className="BijeleStranice-modal-content" sx={{width:"90%", marginTop:"10px"}}>
                                        <Box sx={{width:"100%", display:"flex", alignItems:"center", justifyContent:"space-between"}}>


                                                <Grid sx={{width:"100%", margin:"0px", gap:"0px"}} container spacing={0.75} >
                                                    
                                                    <Grid xs={12} container spacing={0.75}>
                                                        <Grid xs={6}>
                                                            <Typography className="BijeleStranice-modal-title" variant="p">
                                                            Kopiranje kontaktnih podataka u sve instance iste firme (po OIB-u)
                                                            </Typography>
                                                        </Grid>                                                        
                                                        <Grid xs={3}>
                                                            <Button sx={{height:"30px", fontSize:"10px"}}  color="success"
                                                            variant="contained" fullWidth
                                                                    onClick={() => {
                                                                    
                                                                        updateContactsMB();
                                                                }}>
                                                               Snimi
                                                            </Button>
                                                    
                                                        </Grid>                                                        
                                                        <Grid xs={3}>
                                                            <Button sx={{height:"30px", fontSize:"10px"}}  color="error"
                                                            variant="contained" fullWidth
                                                                    onClick={() => {

                                                                        setMemoMBName('');
                                                                        setMemoMBSifra('');
                                                                        setMemoMBTKC('');
                                                                        setMB_Current('');
                                                                        setMB(false);

                                                                    
                                                                }}>
                                                                Odustani
                                                            </Button>
                                                        
                                                        </Grid>
                                                    </Grid>
                                                    
                                               
                                                    
                                                    
                                                    <Grid xs={12} container spacing={0.75}>
                                                        <Grid xs={6}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                size="small"
                                                                fullWidth
                                                                value={MB_Current}
                                                                id=""
                                                                label="Naziv u trenutnom retku"
                                                                variant="outlined"
                                                                disabled
                                                                
                                                                onChange={(event) => {
                                                                    setMB_Current(event.value);
                                                                }}
                                                            />
                                                        
                                                        </Grid>
                                                
                                                        <Grid xs={6}>

                                                            <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightgray', color:'gray'}}  
                                                            variant="contained" fullWidth
                                                                    onClick={() => {
                                                                        if(chosenMB){
                                                                            setMemoMBName(chosenMB.naziv)
                                                                            setMemoMBSifra(chosenMB.sifra);
                                                                            setMemoMBTKC(chosenMB.tkc);
                                                                            setMemoMB(chosenMB);
                                                                        }
                                                                }}>
                                                                Spremi ispod
                                                            </Button>
                                                        </Grid>
                                                    
                                                    </Grid>
                                               
                                                    
                                                    <Grid xs={12} container spacing={0.75}>

                                                        <Grid xs={1}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                size="small"
                                                                fullWidth
                                                                value={memoMBTKC}
                                                                id=""
                                                                label="Memorirano"
                                                                variant="outlined"
                                                                disabled
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                        
                                                        </Grid>
                                                        
                                                        <Grid xs={2}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                size="small"
                                                                fullWidth
                                                                id=""
                                                                value={memoMBSifra}
                                                                label=""
                                                                variant="outlined"
                                                                disabled
                                                                
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                        
                                                        </Grid>
                                                        
                                                        <Grid xs={5}>
                                                            <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                size="small"
                                                                fullWidth
                                                                value={memoMBName}
                                                                id=""
                                                                label=""
                                                                variant="outlined"
                                                                disabled
                                                                
                                                                onChange={(event) => {
                                                                    
                                                                }}
                                                            />
                                                        
                                                        </Grid>
                                                
                                                        <Grid xs={4}>

                                                            <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'gray'}}  
                                                            variant="contained" fullWidth
                                                                    onClick={() => {
                                                                        updateFromMemoMB();
                                                                }}>
                                                               Ažuriraj naziv
                                                            </Button>
                                                        </Grid>
                                                    
                                                    </Grid>
                                               

                                               
                                                    

                                               
                                                </Grid>
                                    </Box>
                                    <Box className="BijeleStranice-modal-data-display">




                                        {tableDataMB.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                rowData={tableDataMB.rows}
                                                columnDefs={tableDataMB.columns}

                                        

                                            
                                                ref={gridRef_MB}
                                                theme={themeAG}
                                            
                                                autoSizeStrategy={autoSizeStrategy_MB}
                                                onGridReady={onGridReady_MB}
                                                onColumnResized={onColumnResized_MB}

                                                onRowSelected={onRowSelected_MB}
                                                onSelectionChanged={onSelectionChanged_MB}

                                                
                                                rowSelection="single"
                                
                                                onRowClicked={cellClicked_MB}


                                        /></div> } 
                                      
                                        
                                    </Box>    
                                        
                                       
                                       

                                    </Box>

                                    <div className='DPDonat-modal-bottom'
        
                                        onMouseDown={(e)=>onMouseDown(e)}>

                                    </div>
                                </Box>

            </Modal>
        
 {/*----------------------------------*/}


 {/*--------------Zute Stranice Modal--------------------*/}

            <Modal
                          open={zuteStranice}
                          onClose={()=> {
                                setTableDataZuteStranice([],[]);
                                setSelectedDjel('');
                                setSelectedZuteStr([])
                                setNewDjel(false);
                                setZuteStranice(false)
                          }}
            >
                                <Box className="BijeleStranice-modal-container" >
                                    <Typography className="BijeleStranice-modal-title" variant="h5">
                                        Kopiranje strukture u žute stranice
                                    </Typography>
                                    
                                    <Typography className="BijeleStranice-modal-title" variant="p">
                                        Osim slogova s objavom 7 ili 9
                                    </Typography>
                                    
                                    <Box className="BijeleStranice-modal-content" sx={{width:"90%", marginTop:"10px"}}>
                                        <Box sx={{width:"90%", display:"flex", alignItems:"center", justifyContent:"space-between"}}>


                                                <Grid sx={{width:"100%", margin:"0px", gap:"0px"}} container spacing={0.75} >
                                                    
                                                    <Grid xs={3}>
                                                        <Button sx={{height:"50px", fontSize:"10px"}}  variant="contained" fullWidth color="success"
                                                                onClick={() => {
                                                                
                                                                    console.log(selectedDjel);

                                                                    console.log(selectedZuteStr);

                                                                    if(selectedZuteStr && selectedZuteStr.length>1){
                                                                        console.log("Ima ih punooooo");
                                                                        console.log(selectedZuteStr.length);

                                                                        changeOldDjelatnostBijeleArr(selectedZuteStr);
                                                                    
                                                                    } else if(selectedDjel){

                                                                        changeOldDjelatnostBijele(selectedDjel)

                                                                    } else {

                                                                        toast.warning("Morate odabrati djelatnost u koju želite spremiti podatke", toastInfo);
                                                                    }
                                                            }}>
                                                            U odabranu djelatnost
                                                        </Button>
                                                    
                                                    </Grid>
                                                    
                                                    <Grid xs={3}>
                                                        <Button sx={{height:"50px", fontSize:"10px"}}  variant="contained" color="success" fullWidth
                                                                onClick={() => {

                                                                    //setNewDjel(true);

                                                                    setAddNew(true);
                                                                
                                                            }}>
                                                            U novu djelatnost
                                                        </Button>
                                                    
                                                    </Grid>
                                               
                                                    
                                                    <Grid xs={3}>
                                                        <Button sx={{height:"50px", fontSize:"10px", backgroundColor:'lightyellow', color: 'black'}}  variant="contained" fullWidth
                                                                onClick={() => {
                                                                    
                                                                    //setIsPoslovnaHrvaska(true)
                                                                    getPHInfo();
                                                            }} 
                                                            //disabled={true}
                                                            >
                                                            POSLOVNA HRVATSKA
                                                        </Button>
                                                    
                                                    </Grid>
                                               
                                                    <Grid xs={3}>
                                                        <Button sx={{height:"50px", fontSize:"10px"}}  variant="contained" 
                                                        fullWidth
                                                        color="error"
                                                                onClick={() => {
                                                                    
                                                                    setTableDataZuteStranice([],[]);
                                                                    setSelectedDjel('');
                                                                    setSelectedZuteStr([]);
                                                                    setNewDjel(false);
                                                                    setZuteStranice(false)
                                                            }} 
                                                         
                                                            >
                                                            Kraj
                                                        </Button>
                                                    
                                                    </Grid>
                                               
                                                    

                                               
                                                </Grid>
                                    </Box>
                                    <Box className="BijeleStranice-modal-data-display">


                                        {tableDataZuteStranice.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                rowData={tableDataZuteStranice.rows}
                                                columnDefs={tableDataZuteStranice.columns}

                                                getRowStyle={getRowStyle}

                                        

                                            
                                                ref={gridRef}
                                                theme={themeAG}
                                            
                                                autoSizeStrategy={autoSizeStrategy}
                                                onGridReady={onGridReady}
                                                onColumnResized={onColumnResized}

                                             
                                        
                                                onRowSelected={onRowSelected}
                                                onSelectionChanged={onSelectionChanged}

                                                

                                                selectAll={selectAll}


                                                rowSelection="multiple"
                                
                                                //onRowClicked={cellClicked}
                                                onRowClicked={debounceClickZute}


                                    /></div> } 

                                    
                                    </Box>    
                                        
                                    <Box>

                                    {addNew && <div className='ZuteStranice-form-add-naziv-container'>
                            <div className='ZuteStranice-form-search-naziv'>
                                <div className='ZuteStranice-naziv-djel'>
                                    Naziv djelatnosti:
                                </div>
                                <div className='ZuteStranice-naviv-search-field'>
                                 <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        autoFocus
                                        id=""
                                        label={searchNaziv=== "" ? "Naziv": ""}
                                        
                                      
                                        variant="outlined"

                                        value={searchNaziv}
                                        
                                        onChange={(event) => {
                                            setSearchNaziv(event.target.value);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){
                                                console.log('Enter Pressed')
                                                console.log(searchNaziv);
                                                getDjelatnosti()
                                            }
                                        }}
                                    />

                                </div>
                                <div className='ZuteStranice-naviv-search-box-action'>
                                 <Button sx={{height:"30px", fontSize:"10px"}} 
                                        variant="contained" 
                                        style={{}}
                                        onClick={() => {
                                            getDjelatnosti()
                                            }}
                                        >
                                            Sve nove djelatnosti
                                    </Button>

                                </div>
                            </div>

                            <div className='ZuteStranice-form-naziv-search-results'>
                            {filteredTableData.rows && <DataGrid
                                        rows={filteredTableData.rows}
                                        columns={filteredTableData.columns}
                                        initialState={{
                                            pagination: {
                                            paginationModel: {
                                                pageSize: 15,
                                            },
                                            },
                                        }}
                                        pageSizeOptions={[15]}
                                        onRowClick={(data)=> {
                                            console.log("clicked");
                                            console.log(data);
                                            const dataRow = allDjelatnosti.list.find(item=>item.naziv==data.row.naziv)
                                            console.log("Saljem djel:")
                                            console.log(dataRow)
                                            
            
                                            addDjelatnost(dataRow);

                                            setAddNew(false);
                                            setSearchNaziv('');
                                            setFilteredTableData([],[])
                                       
                                        }}

                                    
                                    />
                                    }
                            </div>
                        </div>}

                                    </Box>
                                       

                                    </Box>
                                </Box>

            </Modal>
        
 {/*----------------------------------*/}

 {/*--------------Tvrtke Modal--------------------*/}
                <Modal
                          open={tvrtkeModal}
                          onClose={()=> {
                              setTvrtkeModal(false)
                              setTableDataZuteTvrtke([],[])
                          }}
            >

                        <Box className="DPDonat-modal-container"  ref={popupRefTvrtke}      
                                style={{resize: "both", transform: `translate(${modalTvrtkePosition.x}px, ${modalTvrtkePosition.y}px)` }}> 

                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      
                                        onMouseDown={(e)=> onMouseDown(e)}>
                    
                                        
                                        <Typography className="DPDonat-header-title-text" variant="h6">
                                        <Typography> Tvrtke</Typography>
                                        </Typography>  
                                    
                                    

                                </Box>

                                    

                                    <Box className="BijeleStranice-modal-content" sx={{width:"90%", marginTop:"10px"}}>

                                    <Box className="BijeleStranice-modal-data-display">

                                        {tableDataZuteTvrtke && tableDataZuteTvrtke.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                    rowData={tableDataZuteTvrtke.rows}
                                                    columnDefs={tableDataZuteTvrtke.columns}

                                            

                                                
                                                    ref={gridRef_Tvrtke}
                                                    theme={themeAG}
                                                
                                                    autoSizeStrategy={autoSizeStrategy_Tvrtke}
                                                    onGridReady={onGridReady_Tvrtke}
                                                    onColumnResized={onColumnResized_Tvrtke}

                                                
                                    
                                                    onRowClicked={cellClicked_Tvrtke}


                                        /></div> } 

                                        
                                    </Box>    

                                       
                                       

                                    </Box>
                                    <div className='DPDonat-modal-bottom'
        
                                        onMouseDown={(e)=>onMouseDown(e)}>

                                    </div>
                                </Box>

                </Modal>


{/*---------------------------------ODABRANI TEL U BIJELIM STR--------------------*/}

                <Modal
                                    open={propsInfoVisible}
                                    onClose={()=> {
                                        setPropsInfoVisible(false)
                                    }}

                        >
                            <Box className="DPDonat-modal-container"  ref={popupRefPropsBijele}      
                                style={{resize: "both", transform: `translate(${modalPositionPropsBijele.x}px, ${modalPositionPropsBijele.y}px)` }}> 

                                <Box className = "DPDonat-modal-header" onClick={(e) => e.stopPropagation()}      
                                onMouseDown={(e)=> onMouseDown(e)}>
                    
                                        
                                        <Typography className="DPDonat-header-title-text" variant="h6">
                                        {propsInfo && <Typography> {propsNaziv}</Typography>}
                                        </Typography>  
                                    
                                    

                                </Box>
                                {/*<Box sx={{ display:"flex", flexDirection: "column", alignItems: "center", justifyContent:"center", gap:"20px", width:"100%", 
                                    }}>*/}
                                <Box className="BijeleStranice-modal-data-display">





                                        {propsRow.rows && <div style={{ width: "100%", height: "100%" }}> <AgGridReact
                                                rowData={propsRow.rows}
                                                columnDefs={propsRow.columns}

                                        

                                            
                                                ref={gridRef_Props}
                                                theme={themeAG}
                                            
                                                //autoSizeStrategy={autoSizeStrategy_Props}
                                                onGridReady={onGridReady_Props}
                                                onColumnResized={onColumnResized_Props}

                                                onRowSelected={onRowSelected_Props}
                                                onSelectionChanged={onSelectionChanged_Props}

                                                
                                                rowSelection="single"
                                
                                                
                                                onCellDoubleClicked={handleCellDoubleClick}


                                        /></div> }                                        
                                </Box>


                        <div className='DPDonat-modal-bottom'
                        
                        onMouseDown={(e)=>onMouseDown(e)}>

                    </div>

                </Box>
                </Modal>




 <div className="BijeleStranice-main-container"  style={{resize: modalIsOpen ? "both" : "unset",width: modalIsOpen ? "97vw" : "100%", height: modalIsOpen ? "97vh" : ""}} 
        ref={popupRef}
         onClick={(e) => e.stopPropagation()}
       
         >
            <div className={`BijeleStranice-header ${isMenuOpen ? "is-extended": ""}`} 
                   
                   onMouseEnter={()=> dispatch(actions.openMenu())}
                   onMouseLeave={()=> dispatch(actions.closeMenu())}
                   onMouseDown={(e)=> onMouseDown(e)}

            >

                <div className="BijeleStranice-header-title">
                    <Typography  className="BijeleStranice-header-title-text" variant="h5">
                        Val - BIJELE STRANICE
                    </Typography>
                    <Fab variant="extended" color="secondary"
                           onClick={() => {
                                          
                                //setIsPoslovnaHrvaska(true);
                                getPHInfo();
                            }}
                    >
        
                            Poslovna Hrvatska
                    </Fab>
                </div>

            </div>
            
            <div className="BijeleStranice-body">
                <div className="BijeleStranice-form">
                    <div className="BijeleStranice-form-first-part">
                        <div className="BijeleStranice-form-first-part-left">
                            <Grid sx={{padding:'0 0 0 10px '}} container spacing={0.75} columns={{xs:12}}>
                                {/*first row*/}
                                {/*xs <600px   600px<sm<1000px 1000px<lg<1200px xl>1200px*/}
                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Šifra"
                                        value={sifra}
                                        variant="outlined"

                                        disabled
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>

                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="1.unos"
                                        value={datumUnos}

                                        disabled
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>

                                <Grid xs={4} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Ažuriranje"

                                        disabled
                                        value={datumAzur}
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            
                                        }}
                                    />

                                </Grid>

                                <Grid xs={6} >
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id="naz_mas"
                                        inputRef={nazMas_ref}
                                        label="Naziv (masni dio):"
                                        variant="outlined"
                                        value={nazivMas}
                                        
                                        onChange={(event) => {
                                            //setNazivMas(event.target.value.toUpperCase());
                                            setNazivMas(event.target.value);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){

                                                nazZnak_ref.current.focus();
                                            }
                                        }}

                                        onFocus={event => {
                                                                
                                            event.target.select()
                                                
                                        }}                                          
                                    />

                                </Grid>

                                <Grid xs={6} >
                                   

                                    {/*<Typography>Znak za vezu (Razmak, Crtica, Zrez)</Typography>*/}
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        inputRef={nazZnak_ref}
                                        id=""
                                        label="Znak za vezu (razmak, crtica, zarez)"
                                        variant="outlined"
                                        value={nazivZnak}
                                        //disabled
                                        
                                        onChange={(event) => {
                                            setNazivZnak(event.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){
                                              
                                                nazNemas_ref.current.focus();

                                            }
                                        }}
                                        onFocus={event => {
                                                                
                                            event.target.select()
                                                
                                        }}  
                                    />
                                        
                                </Grid>


                                <Grid xs={12} >
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        inputRef={nazNemas_ref}
                                        id=""
                                        label="Naziv (nemasno):"
                                        variant="outlined"
                                        
                                    
                                        value={nazivNemas}
                                        
                                        onChange={(event) => {
                                            setNazivNemas(event.target.value)
                                            
                                        }}
                                        
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){

                                                mb_ref.current.focus();
                                            }
                                        }}

                                        onFocus={event => {
                                                                
                                            event.target.select()
                                                
                                        }}            

                                    />

                                </Grid>


                                <Grid xs={12} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Kratki naziv"
                                        variant="outlined"
                                        value={nazivKratki}
                                        disabled
                                        
                                        onChange={(event) => {
                                            setNazivKratki(event.target.value)
                                        }}

                                    
                                    />

                                </Grid>

                                <Grid container xs={5}  sx={{border:1, padding:0, paddingLeft:0.5,paddingRight:0.5, margin:0.5}} className="BijeleStranice-grid-border">
                                    <Grid xs={12}>
                                        <Typography  sx={{fontSize:'11px'}}>
                                            Vrsta naslova
                                        </Typography>
                                    </Grid>         
     
                                    <Grid xs={12}>

                                            <FormControl  sx={{width:'100%'}}>
                                                <RadioGroup 
                                              
                                                row
                                                name="Vrsta naslova"
                                                onChange={handleOwnerChange}
                                                >
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} control={<Radio id='1' size="small"  />} checked={vrstaSloga=='1'?true:false} label="Ime tvrtke" />  
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} control={<Radio id='5' size="small" />} checked={vrstaSloga=='5'?true:false} label="Ime vlasnika" />
                                                </RadioGroup>
                                            </FormControl>             
                                    </Grid>
                                </Grid>

                                <Grid container xs={5} sx={{border:1, padding:0, paddingLeft:0.5,paddingRight:0.5, margin:0.5}} className="BijeleStranice-grid-border" >
                                    <Grid xs={12}>
                                       <Typography  sx={{fontSize:'11px'}}>
                                            Objava
                                        </Typography>
                                    </Grid>         

                                    <Grid xs={12}>

                                            <FormControl  sx={{width:'100%'}}>
                                                <RadioGroup 
                                              
                                                row
                                                name="Objava"
                                                onChange={handlePublishChange}
                                                >
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} control={<Radio id='1' size="small"  />} checked={objava=='1'?true:false} label="Sve" />  
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} control={<Radio id='9' size="small" />} checked={objava=='9'?true:false} label="988" />
                                                     <FormControlLabel sx={{height:"30px",  '& .MuiFormControlLabel-label': { fontSize: '13px' } }} control={<Radio id='7' size="small" />} checked={objava=='7'?true:false} label="Nigdje" />
                                                </RadioGroup>
                                            </FormControl>             
                                    </Grid>
                                </Grid>

                                <Grid container xs={12} sx={{padding:0, margin:0}} className="BijeleStranice-grid-border">
                                    <Grid xs={6}>
                                       <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="MB"
                                                variant="outlined"
                                                inputRef={mb_ref}
                                                value={MatBr}
                                                //disabled
                                                
                                                onChange={(event) => {
                                                    setMatBr(event.target.value)
                                                }}
                                                
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter'){

                                                        oib_ref.current.focus();
                                                    }
                                                }}

                                                onFocus={event => {
                                                
                                                    event.target.select()
                                
                                                }}                                                            

                                            />
                                    </Grid>

                                    <Grid xs={6}>

                                       <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="OIB"
                                                variant="outlined"
                                                //disabled
                                                value={OIB}
                                                
                                                onChange={(event) => {
                                                    setOIB(event.target.value);
                                                }}

                                                inputRef={oib_ref}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter'){

                                                        kontakti_ref.current.focus();
                                                    }
                                                }}
                                                onFocus={event => {
                                                
                                                    event.target.select()
                                
                                                }}            
                                            />
                                    </Grid>




                                </Grid>

                                <Grid xs={12} >
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="E-mail, www, radno vrijeme i profil:"
                                        variant="outlined"
                                        disabled
                                        
                                        onChange={(event) => {

                                            
                                            
                                        }}
                                    />

                                </Grid>

                                <Grid xs={8} >
                                   <TextField
                                        InputProps={{sx:{height:30}}}
                                        InputLabelProps={{
                                            sx: {
                                                
                                                fontSize: "10px",
                                                
                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                            }
                                            }}
                                        size="small"
                                        fullWidth
                                        id=""
                                        label="Kontakti:"
                                        variant="outlined"
                                        
                                        onChange={(event) => {
                                            setKontakti(event.target.value);
                                            
                                        }}

                                        inputRef={kontakti_ref}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter'){

                                                inputRefMjesto.current.focus();
                                            }
                                        }}    
                                        
                                        onFocus={event => {
                                        
                                            event.target.select()
                        
                                        }}                                                    
                                    />

                                </Grid>
                                <Grid xs={4} >
                                         <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="primary" 
                                            disabled={(OIB || MB)?false:true}
                                                onClick={() => {

                                                    if(OIB && OIB!=''){

                                                        getMB()

                                                    } else {

                                                        toast.error("Odabrana tvrtka nema definiran niti OIB niti MB, molimo provjerite podatke tvrtke", toastError)
                                                    }
                                                    
                                        
                                            }}>
                                            Svi isti Mb/Oib
                                        </Button>
                                </Grid>

                            </Grid>
                        </div>            
                        <div className="BijeleStranice-form-first-part-right">
                            <Container style={{margin:'0', padding:'0 10px 0 0'}}>
                                    <div style={{  padding: 0}}>
                                            <Grid sx={{padding:'5px', gap:"5px"}} container spacing={0} columns={{xs:12}}>

                                                
                                                <Grid xs={12} sx={{display:"flex", flexWrap:"wrap",flexDirection:"row", gap:"5px"}} >

                                                     <Button sx={{height:"30px", fontSize:"10px", marginBottom:'5px'}} variant="contained" color="success" 
                                                            onClick={() => {
                                                                
                                                                getFirmaBijeleNazivSifra()
                                                               /* if(sifra && sifra!= ''){
                                                                getFirmaBijele();
                                                                } else if (naziv && naziv!= ''){

                                                                    getFirmaBijeleNaziv();

                                                                }else {

                                                                    toast.info("Morate zadati kriterij pretraživanja!", toastInfo);
                                                                }*/
                                                    
                                                        }}>
                                                        Prihvati
                                                    </Button>


                                                    <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" color="error"  
                                                            onClick={() => {



                                                                setNaziv('');

                                                                
                    
                    
                                                                setMjesto('');
                        
                                                                setUlica('');

                                                              
                                                                setKbr('');

                                                                setKbr_znak('');
                        
                                                                setKomentar('');
                        
                                                                setKomentar2('');
    
                                                                setSifra('');

                                                                setTkcFirma('');

                                                                setDisableSelNet(false);
    
                                                                setNazivKratki('');
                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                setSelectedMjesto({'MJESTO_ID':0, 'NAZIV':''});
                                                                setNazivMas('');
                                                                setNazivNemas('');
                                                                setNazivZnak('');
    
                                                                setDatumUnos('');
                                                                setDatumAzur('');

                                                                setTableDataModal([]);

                                                                setRedosStrukt('')
                                                                setNivoStrukt('')
                                                                setMrezaStrukt('')
                                                                setTelStrukt('')
                                                                
                                                               // setObjavaStrukt(false);
                                                               // setObjavaStruktChecked('NE');

                                                                setObjavaStrukt(1);
                                                                setObjavaStruktChecked(1);
                                                                
                                                                setUlicaStrukt('')
                                                                setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});

                                                                setKbrStrukt('')
                                                                setKbr_znakStrukt('')
                                                                setNazivStrukt('')
                                                                setKomentStrukt('')
                                                                setDatStr1('')
                                                                setDatStr2('')
                                                                setKnjigaStrukt('')
                                                                setPojam1Strukt('')
                                                                setPojam2Strukt('')
                                                                setPojam3Strukt('')
                                                                setTableDataModal([]);
                                                                setMatBr('');
                                                                setOIB('');

                                                                setBelow(false);
                                                                setAbove(false);

                                                                setMemoStrukt('');
                                                                setStruktureArr([],[]);

                                                                setSelectedStrukt([]);
                                                                setMemoStrukt('');

                                                                
                                                    
                                                        }}>
                                                        Odustani
                                                    </Button>

                                                    <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" color="primary"  
                                                            onClick={() => {

                                                                console.log(propsInfo);
                                                                console.log(propsRow)

                                                                if(propsInfo){
                                                                    
                                                                    setPropsInfoVisible(true);
                                                                    

                                                                }
                                                                
                                                    
                                                        }}>
                                                        MEMO
                                                    </Button>

                                                    <FormControl 
                                                            fullWidth
                                                            //variant="standard" 
                                                            sx={{ m: 1, width:'25%', margin:0, marginLeft: 10}}
                                                            size="small"
                                                            variant="outlined"
                                                            >
                                                        <InputLabel sx={{fontSize: 12}}>Mreža</InputLabel>
                                                        <Select 
                                                            sx={{height:32}}
                                                            disabled = {disableSelNet}
                                                            value={selectedNetwork?.pozivni || ""} onChange={handleChange}>
                                                        {listOfPozivni.map((obj) => (
                                                            <MenuItem key={obj.tkc} value={obj.pozivni}>
                                                            {obj.pozivni}
                                                            </MenuItem>
                                                        ))}
                                                        <MenuItem value={''} name={''} >Svi</MenuItem>
                                                        </Select>
                                                    </FormControl>

                                                     <Button sx={{height:"30px", fontSize:"10px"}} variant="contained" color="primary"  
                                                            onClick={() => {

                                                                //console.log(propsInfo);
                                                                //console.log(propsRow)

                                                                /*
                                                                if(propsInfo){
                                                                    
                                                                    setPropsInfoVisible(true);
                                                                    

                                                                }

                                                                */
                                                                if(lastComp && lastComp!='' && lastCompTKC && lastCompTKC!=''){

                                                                        getFirmaBijeleNazivSifraWithParams('', lastComp, lastCompTKC);

                                                                } else {

                                                                        toast.error("Nema upamćene tvrtke od zadnjeg pokretanja preglednika", toastError)
                                                                }
                                                                
                                                    
                                                        }}>
                                                        Ponovi zadnju firmu
                                                    </Button>                                        

                                                </Grid> 
                                                
                                                
                                                
                                                <Grid container xs={12} sx={{border:"1px solid black", backgroundColor:'#AFE1AF'}} spacing={0.75}>
                                                    <Grid xs={12}>
                                                       <Typography  sx={{fontSize:'11px'}}>
                                                            Izbor tvrtke
                                                        </Typography>
                                                    </Grid>         
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Naziv"
                                                                                variant="outlined"

                                                                                value={naziv}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setNaziv(event.target.value)

                                                                                    
                                                                                }}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){
                                                                                        console.log('Enter Pressed')
                                                                                        console.log(naziv);
                                                                                        getFirmaBijeleNazivSifra();
                                                                                    }
                                                                                }}
                                                                            />

                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                            size="small"
                                                            fullWidth
                                                            id=""
                                                            label="Zadana šifra:"
                                                            variant="outlined"

                                                            value={sifra}
                                                            
                                                            onChange={(event) => {
                                                                setSifra(event.target.value);
                                                            }}
                                                            onKeyDown={(event) => {
                                                                if (event.key === 'Enter'){
                                                                    console.log('Enter Pressed')
                                                                    console.log(sifra);
                                                                    getFirmaBijeleNazivSifra();
                                                                }
                                                            }}
                                                        />


                                                    </Grid>
                                                </Grid>

                                                <Grid container xs={12}>
                                                    <Grid xs={6}>
                                                        <FormControlLabel control={<Checkbox size="small" checked={newCompanyChecked} onClick={()=>{
                                                                                            if(!newCompany) {
                                                                                                
                                                                                                setNaziv('');
                        
                        
                                                                                                setMjesto('');
                                                        
                                                                                                setUlica('');
                                                        
                                                                                                setKbr('');

                                                                                                setKbr_znak('');


                                                        
                                                                                                setKomentar('');
                                                        
                                                                                                setKomentar2('');
                                    
                                                                                                setSifra('');

                                                                                                setTkcFirma('');
                                    
                                                                                                setNazivKratki('');
                                                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                                                setSelectedMjesto({'MJESTO_ID': 0, 'NAZIV':''});
                                                                                                setNazivMas('');
                                                                                                setNazivNemas('');
                                                                                                setNazivZnak('');
                                    
                                                                                                setDatumUnos('');
                                                                                                setDatumAzur('');

                                                                                                setTableDataModal([]);

                                                                                                setRedosStrukt('')
                                                                                                setNivoStrukt('')
                                                                                                setMrezaStrukt('')
                                                                                                setTelStrukt('')
                                                                                                
                                                                                               // setObjavaStrukt(false);
                                                                                                //setObjavaStruktChecked('NE');

         setObjavaStrukt(1);
        setObjavaStruktChecked(1);                                                                                               
                                                                                                
                                                                                                setUlicaStrukt('')
                                                                                                setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                                                                                setKbrStrukt('')
                                                                                                setKbr_znakStrukt('')
                                                                                                setNazivStrukt('')
                                                                                                setKomentStrukt('')
                                                                                                setDatStr1('')
                                                                                                setDatStr2('')
                                                                                                setKnjigaStrukt('')
                                                                                                setPojam1Strukt('')
                                                                                                setPojam2Strukt('')
                                                                                                setPojam3Strukt('')
                                                                                                setTableDataModal([]);
                                                                                                setMatBr('');
                                                                                                setOIB('');

                                                                                                setBelow(false);
                                                                                                setAbove(false);

                                                                                                setSelectedStrukt([]);
                                                                                                setMemoStrukt('')
                                                                                                    
                                                                                                    

                                                                                            }
                                                                                            setNewCompany(!newCompany);
                                                                                            setNewCompanyChecked(!newCompanyChecked);
                                                                                            


                                                                        }}/>} label={<Typography sx={{fontSize:'11px'}}>Unos nove tvrtke</Typography>}/> 
                                                    
                                                    </Grid>         
                                                    <Grid xs={6}>

                                                        <Button sx={{height:"30px", fontSize:"10px", marginBottom:'5px', marginTop:'5px'}} 
                                                                variant="contained" 
                                                                fullWidth
                                                                color="success" 
                                                                onClick={() => {
                                                                    
                                                                    //toast.error("Nije uspjelo dodavanje tvrtke, provjerite unešene podatke i pokušajte ponovno", toastError);
                                                                    setBijeleCompany();
                                                                }}>
                                                            Spremi tvrtku
                                                        </Button>
                                                    </Grid>
                                                    <Grid xs={6}>

                                                        <Button sx={{height:"30px", fontSize:"10px", marginBottom:'5px', marginTop:'5px'}} 
                                                                variant="contained" 
                                                                fullWidth
                                                                color="error" 
                                                                onClick={() => {
                                                                    
                                                                    deleteBijeleCompany();
                                                                }}>
                                                            Obriši tvrtku
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>    
                                            <Grid sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                    <Grid xs={4}>
                                                        <Autocomplete

                                                                    //freeSolo
                                                                    //open={open}
                                                                
                                                                    options={listMjesta}


                                                                    getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} 

                                                                  
                                                      
                                                                    renderOption={(props, option) => {
                                                                        const { key, ...optionProps } = props;
                                                                        return (
                                                                        <Box
                                                                            key={key}
                                                                            component="li"
                                                                            sx={{}}
                                                                            {...optionProps}
                                                                        >   
                                                                            {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')}   -   {option.ID_DOSTAVNE_POSTE?option.ID_DOSTAVNE_POSTE:(option.id_dostavne_poste?option.id_dostavne_poste:'')}  -  {option.NAZIV_OPCINE?option.NAZIV_OPCINE:(option.naziv_opcine?option.naziv_opcine:'')}
                                                                        </Box>
                                                                        );
                                                                    }}


                                                                    value={selectedMjesto}
                                                                    inputValue={mjesto}
                                                                    onHighlightChange={(event, option) => {
                                                                        setHighlightedOptionMjesto(option);
                                                                    }}
                                                                    onOpen={() => {
                                                                        setOpenMjesto(true); // Open only when clicked/focused
                                                                    }}
                                                                    onClose={() => {
                                                                        setOpenMjesto(false);
                                                                    }}
                                                                    onChange={(event, newValue) => {
                                                                        if (newValue) {
                                                                                console.log('Selected:', newValue);
                                                                                
                                                                                //setLoading(false);
                                                                                //setOpen(false);
                                                                                console.log(newValue)
                                                                                setSelectedMjesto(newValue)
                                                                                setMjesto(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))

                                                                                //setTkcFirma(newValue.ID_TKC?newValue.ID_TKC:(newValue.id_tkc?newValue.id_tkc:''))

                                                                                setSelectedUlica({'ULICA_ID': 0, 'NAZIV':''});
                                                                                setUlica('');
                                                                                setKbr('');
                                                                                setKbr_znak('');
                                                                            

                                                                                setListMjesta([])
                                                                                // Remove focus (blur)

                                                                                if (inputRefMjesto.current) {
                                                                                    inputRefMjesto.current.blur();
                                                                                }
                                                                                setOpenMjesto(false);
                                                                        }

                                                                        
                                                                    }}
                                                                    loading={loadingMjesto}
                                                                
                                                                    onInputChange={(event, newInputValue, reason) => {
                                                                        console.log("New input value is here!!!!")
                                                                        console.log(newInputValue);
                                                                       
                                                                        setMjesto(newInputValue);


                                                                      
                                                                        // Don't open while typing manually
                                                                        //if (reason === 'reset') {
                                                                        //    setOpenMjesto(false);
                                                                       // }
                                                                    }}

                                                                    renderInput={(params) => (
                                                                        <TextField

                                                                        {...params}

                                                                        label="Mjesto"
                                                                        size="small" // smaller baseline size
                                                                        InputProps={{
                                                                        ...params.InputProps,
                                                                        sx: {
                                                                            height: '30px',
                                                                            minHeight: '30px',
                                                                            '& input': {
                                                                            padding: '0 8px',
                                                                            height: '30px',
                                                                            boxSizing: 'border-box',
                                                                            },
                                                                        },
                                                                        }}
                                                                        InputLabelProps={{
                                                                        sx: {
                                                                            fontSize: '0.75rem', // smaller label font
                                                                            top: '-6px', // shift label slightly up
                                                                        }
                                                                        }}
                                                                        inputRef={inputRefMjesto}
                                                                        onKeyDown={handleKeyDownMjesto}
                                                                        onClick={() => setOpenMjesto(true)} // Open on click
                                                                        onFocus={() => setOpenMjesto(true)} // Open on focus
                                                                        />
                                                                    )}
                                                                    disableCloseOnSelect={false}

                                                                    autoHighlight

                                                                    onFocus={event => {
                                                                    
                                                                        event.target.select()
                                                    
                                                                    }}                                                                                                                                         
                                                                    />



                                                    
                                                    </Grid>
                                                    <Grid xs={8}>
                                              

                                                            <Autocomplete

                                                                //freeSolo
                                                                //open={open}
                                                                options={listUlice}
                                                                getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} 
                                                                
                                                

                                                                renderOption={(props, option) => {

                                                                    
                                                                                    const { key, ...optionProps } = props;
                                                                                    return (
                                                                                    <Box

                                                                                        key={option.ULICA_ID?option.ULICA_ID:(option.ulica_id?option.ulica_id:'')}
                                                                                        component="li"
                                                                                        sx={{backgroundColor: (option.AKTIVNA==1||option.aktivna==1)?'white':'yellow'}}                                                                        
                                                                                    
                                                                                        {...optionProps}
                                                                                    >   
                                                                                        {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} - {(option.AKTIVNA==1||option.aktivna==1)?"aktivna":"neaktivna"}
                                                                                    </Box>
                                                                                    );
                                                                }}                                                                
                                                                value={selectedUlica}
                                                                inputValue={ulica}
                                                                onHighlightChange={(event, option) => {
                                                                    setHighlightedOption(option);
                                                                  }}
                                                                  onOpen={() => {
                                                                    setOpen(true); // Open only when clicked/focused
                                                                  }}
                                                                  onClose={() => {
                                                                    setOpen(false);
                                                                  }}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                      console.log('Selected:', newValue);
                                                                      
                                                                      //setLoading(false);
                                                                      //setOpen(false);
                                                                      console.log(newValue)
                                                                      setSelectedUlica(newValue)
                                                                      setUlica(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))
                                                                      setListUlice([])
                                                                      // Remove focus (blur)

                                                                      if (inputRefUlice.current) {
                                                                        inputRefUlice.current.blur();
                                                                      }
                                                                      setOpen(false);
                                                                    }

                                                                    
                                                                  }}
                                                                loading={loading}
                                                           
                                                                onInputChange={(event, newInputValue, reason) => {
                                                                    console.log("New input value is here!!!!")
                                                                    console.log(newInputValue);
                                                                    setUlica(newInputValue);
                                                                    // Don't open while typing manually
                                                                    if (reason === 'reset') {
                                                                        setOpen(false);
                                                                    }
                                                                }}
                                                   
                                                                renderInput={(params) => (
                                                                    <TextField

                                                                    {...params}

                                                                    label="Ulica"
                                                                    size="small" // smaller baseline size
                                                                    InputProps={{
                                                                      ...params.InputProps,
                                                                      sx: {
                                                                        height: '30px',
                                                                        minHeight: '30px',
                                                                        '& input': {
                                                                          padding: '0 8px',
                                                                          height: '30px',
                                                                          boxSizing: 'border-box',
                                                                        },
                                                                      },
                                                                    }}
                                                                    InputLabelProps={{
                                                                      sx: {
                                                                        fontSize: '0.75rem', // smaller label font
                                                                        top: '-6px', // shift label slightly up
                                                                      }
                                                                    }}
                                                                    inputRef={inputRefUlice}
                                                                    onKeyDown={handleKeyDownUlica}
                                                                    onClick={() => setOpen(true)} // Open on click
                                                                    onFocus={() => setOpen(true)} // Open on focus
                                                                    />
                                                                )}
                                                                disableCloseOnSelect={false}
                                                             
                                                                autoHighlight

                                                                onFocus={event => {
                                                                
                                                                    event.target.select()
                                                
                                                                }}                                                               

                                                                                                                         
                                                                />
                                                           
                                                       
                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Kbr"
                                                                                variant="outlined"

                                                                                value={kbr}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setKbr(event.target.value);
                                                                                    
                                                                                }}
                                                                                inputRef={kbr_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        kbrZnak_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                onFocus={event => {
                                                                                  
                                                                                    event.target.select()
                                                                 
                                                                                }}

                                                        />
                                                        


                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Dodatak"
                                                                                variant="outlined"

                                                                                value={kbr_znak}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setKbr_znak(event.target.value);
                                                                                    
                                                                                }}

                                                                                inputRef={kbrZnak_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        komentar1_ref.current.focus();
                                                                                    }
                                                                                }}

                                                                                onFocus={event => {
                                                                                  
                                                                                    event.target.select()
                                                                 
                                                                                }}

                                                        />


                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Komentar:"
                                                                                variant="outlined"

                                                                                value={komentar}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setKomentar(event.target.value)
                                                                                }}

                                                                                inputRef={komentar1_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        komentar2_ref.current.focus();
                                                                                    }
                                                                                }}  
                                                                                
                                                                                onFocus={event => {
                                                                                
                                                                                    event.target.select()
                                                                
                                                                                }}                                                                                      
                                                        />

                                                    </Grid>
                                                    <Grid xs={6}>
                                                       <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                size="small"
                                                                                fullWidth
                                                                                id=""
                                                                                label="Komentar 2:"
                                                                                variant="outlined"

                                                                                value={komentar2}
                                                                                
                                                                                onChange={(event) => {
                                                                                    setKomentar2(event.target.value);
                                                                                }}


                                                                                inputRef={komentar2_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        pojam1_ref.current.focus();
                                                                                    }
                                                                                }}    
                                                                                
                                                                                onFocus={event => {
                                                                                
                                                                                    event.target.select()
                                                                
                                                                                }}                                                                                       

                                                        />

                                                    </Grid>
                                                    <Grid xs={12} container spacing={0.75} > 

                                                        <Grid xs={12}>
                                                           <Typography  sx={{fontSize:'11px'}}>
                                                                Pojmovi (asocijacije za 988):
                                                            </Typography>
                                                        </Grid>
                                                        <Grid xs={4}>
                                                           <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                                        size="small"
                                                                                        fullWidth
                                                                                        id=""
                                                                                        label=""
                                                                                        variant="outlined"
                                                                                        
                                                                                        onChange={(event) => {
                                                                                            
                                                                                        }}

                                                                                inputRef={pojam1_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        pojam2_ref.current.focus();
                                                                                    }
                                                                                }}    
                                                                                
                                                                                onFocus={event => {
                                                                                
                                                                                    event.target.select()
                                                                
                                                                                }}                                                                                       
                                                            />

                                                        </Grid>
                                                        <Grid xs={4}>
                                                           <TextField
                                                                InputProps={{sx:{height:30}}}
                                                                InputLabelProps={{
                                                                    sx: {
                                                                        
                                                                        fontSize: "10px",
                                                                        
                                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                    }
                                                                    }}
                                                                                        size="small"
                                                                                        fullWidth
                                                                                        id=""
                                                                                        label=""
                                                                                        variant="outlined"
                                                                                        
                                                                                        onChange={(event) => {
                                                                                            
                                                                                        }}


                                                                                inputRef={pojam2_ref}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter'){

                                                                                        pojam3_ref.current.focus();
                                                                                    }
                                                                                }}   
                                                                                
                                                                                onFocus={event => {
                                                                                
                                                                                    event.target.select()
                                                                
                                                                                }}                                                                                       
                                                            />

                                                        </Grid>
                                                        <Grid xs={4}>
                                                           <TextField
                                                            InputProps={{sx:{height:30}}}
                                                            InputLabelProps={{
                                                                sx: {
                                                                    
                                                                    fontSize: "10px",
                                                                    
                                                                    "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                }
                                                                }}
                                                                                    size="small"
                                                                                    fullWidth
                                                                                    id=""
                                                                                    label=""
                                                                                    variant="outlined"
                                                                                    
                                                                                    onChange={(event) => {
                                                                                        
                                                                                    }}

                                                                                inputRef={pojam3_ref}

                                                                                onFocus={event => {
                                                                                
                                                                                    event.target.select()
                                                                
                                                                                }}                                                                                       
                                                                                                                                                                        
                                                            />

                                                        </Grid>
                                                    </Grid>





       
                                            </Grid>    

                                    </div>
                            </Container>
                        </div>                

                    </div>  
                    <div className="BijeleStranice-form-second-part" style={{display:struktureArr.rows? "flex":"none" }}>


                        {struktureArr.rows && 
                        <div style={{ width: "100%", height:"100%" , marginTop:10}}> 
                            <AgGridReact
                                rowData={struktureArr.rows}
                                columnDefs={struktureArr.columns}

                        

                               
                                ref={gridRef_Strukt}
                                theme={themeAG}
                              
                                autoSizeStrategy={autoSizeStrategy_Strukt}
                                onGridReady={onGridReady_Strukt}
                                onColumnResized={onColumnResized_Strukt}
                                

  
                                 
                                 frameworkComponents={{ specialCellRenderer: SpecialCellRenderer }}
                                 context={{ handleUp, handleDown }}

                         
                                
                                onRowSelected={onRowSelected_Strukt}
                                onSelectionChanged={onSelectionChanged_Strukt}

                   

                                rowSelection="multiple"
                   
                                //onRowClicked={cellClicked_Strukt}
                                onRowClicked={debounceClick}
                                


                        />
                        </div> }
               
                                       
                    </div>  
                    <div className="BijeleStranice-form-third-part">
                        <Grid sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>

                            <Grid xs={12} sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                            <Grid xs={1}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Nivo"
                                                                                                variant="outlined"
                                                                                                
                                                                                                value={nivoStrukt}
                                                                                                
                                                                                                onChange={(event) => {
                                                                                                    setNivoStrukt(event.target.value);
                                                                                                }}
                                                                                                inputRef={nivoStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        mrezaStrukt_ref.current.focus();
                                                                                                    }
                                                                                                }}  
                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}                                                                                                    
                                                                                                
                                                                />
                                                            </Grid>
                                                            <Grid xs={1}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Redos"
                                                                                                variant="outlined"
                                                                                                disabled
                                                                                                
                                                                                                value={redosStrukt}
                                                                                                
                                                                                                onChange={(event) => {
                                                                                                    setRedosStrukt(event.target.value);
                                                                                                }}
                                                                />
                                                            </Grid>
                                                            <Grid xs={1}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Mreža"
                                                                                            
                                                                                                
                                                                                                variant="outlined"
                                                                                                value={mrezaStrukt}

                                                                                                //disabled
                                                                                                
                                                                                                //onChange={(event) => {
                                                                                                //    console.log(event);
                                                                                                //    console.log(event.target.value)
                                                                                                //    setMrezaStrukt(event.target.value);
                                                                                                    
                                                                                                //}}
                                                                                                inputProps={{ inputMode: 'numeric' }}
                                                                                                onChange={handleChangeMreza}

                                                                                                inputRef={mrezaStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        telStrukt_ref.current.focus();
                                                                                                    }
                                                                                                }}

                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}                                                                                                    

                                                                />
                                                            </Grid>
                                                            <Grid xs={2}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Tel:"
                                                                                                variant="outlined"
                                                                                                value={telStrukt}
                                                                                                
                                                                                                //onChange={(event) => {
                                                                                                //    setTelStrukt(event.target.value);
                                                                                                    
                                                                                                //}}
                                                                                                inputProps={{ inputMode: 'numeric' }}
                                                                                                onChange={handleChangeTel}

                                                                                                inputRef={telStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        nazivStrukt_ref.current.focus();
                                                                                                    }
                                                                                                }}
                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}           

                                                                                               
                                                                />
                                                            </Grid>
                                                            <Grid xs={7}>
                                    <MyTextField
                                            InputProps={{sx:{height:30, backgroundColor:'orange', color: 'black', fontWeight:400,
                                                
                                                
                                            }}}

                                            InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px", shrink: true,
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                }
                                            }}  
                                                                                            size="small"
                                                                                            fullWidth
                                                                                            id=""
                                                                                            disabled
                                                                                            label=  {`"Bure"`}
                                                                                            value={bureInfo}
                                                                                            onChange={(event) => {
                                                                                                
                                                                                            }}
                                                                />
                                                            </Grid>
                                                            <Grid xs={4}>


                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Naziv"
                                                                                                variant="outlined"
                                                                                                value={nazivStrukt}
                                                                                             
                                                                                                onChange={(event) => {

                                                                                                    setNazivStrukt(event.target.value);
                                                                                                    
                                                                                                }}

                                                                                                inputRef={nazivStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        inputRefUliceST.current.focus();
                                                                                                    }
                                                                                                }}
                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}           


                                                                />
                                                            </Grid>
                                                            <Grid xs={4}>

                                                                    <Autocomplete

                                                                                //freeSolo
                                                                                //open={open}
                                                                                options={listUliceST}
                                                                                getOptionLabel={(option) => option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} // 👈 how to display text
                                                                                
                                                                                renderOption={(props, option) => {

                                                                                    
                                                                                                    const { key, ...optionProps } = props;
                                                                                                    return (
                                                                                                    <Box

                                                                                                        key={option.ULICA_ID?option.ULICA_ID:(option.ulica_id?option.ulica_id:'')}
                                                                                                        component="li"
                                                                                                        sx={{backgroundColor: (option.AKTIVNA==1||option.aktivna==1)?'white':'yellow'}}                                                                        
                                                                                                    
                                                                                                        {...optionProps}
                                                                                                    >   
                                                                                                        {option.NAZIV?option.NAZIV:(option.naziv?option.naziv:'')} - {(option.AKTIVNA==1||option.aktivna==1)?"aktivna":"neaktivna"}
                                                                                                    </Box>
                                                                                                    );
                                                                                }}                                                                                                       
                                                                                
                                                                                value={selectedUlicaST}
                                                                                inputValue={ulicaStrukt}
                                                                                onHighlightChange={(event, option) => {
                                                                                    setHighlightedOptionST(option);
                                                                                }}
                                                                                onOpen={() => {
                                                                                    setOpenST(true); // Open only when clicked/focused
                                                                                }}
                                                                                onClose={() => {
                                                                                    setOpenST(false);
                                                                                }}
                                                                                onChange={(event, newValue) => {
                                                                                    if (newValue) {
                                                                                        console.log('Selected:', newValue);
                                                                                        
                                                                                        //setLoading(false);
                                                                                        //setOpen(false);
                                                                                        console.log(newValue)
                                                                                        setSelectedUlicaST(newValue)
                                                                                        setUlicaStrukt(newValue.NAZIV?newValue.NAZIV:(newValue.naziv?newValue.naziv:''))
                                                                                        setListUliceST([])
                                                                                        // Remove focus (blur)


                                                                                        if (inputRefUliceST.current) {
                                                                                            inputRefUliceST.current.blur();
                                                                                        }
                                                                                        setOpenST(false);
                                                                                    }

                                                                                    
                                                                                }}
                                                                                loading={loadingST}

                                                                                onInputChange={(event, newInputValue, reason) => {
                                                                                    console.log("New input value is here!!!!")
                                                                                    console.log(newInputValue);
                                                                                    setUlicaStrukt(newInputValue);
                                                                                    // Don't open while typing manually
                                                                                    if (reason === 'reset') {
                                                                                        setOpenST(false);
                                                                                    }
                                                                                }}

                                                                                renderInput={(params) => (
                                                                                    <TextField

                                                                                    {...params}

                                                                                    label="Ulica"
                                                                                    size="small" // smaller baseline size
                                                                                    InputProps={{
                                                                                    ...params.InputProps,
                                                                                    sx: {
                                                                                        height: '30px',
                                                                                        minHeight: '30px',
                                                                                        '& input': {
                                                                                        padding: '0 8px',
                                                                                        height: '30px',
                                                                                        boxSizing: 'border-box',
                                                                                        },
                                                                                    },
                                                                                    }}
                                                                                    InputLabelProps={{
                                                                                    sx: {
                                                                                        fontSize: '0.75rem', // smaller label font
                                                                                        top: '-6px', // shift label slightly up
                                                                                    }
                                                                                    }}
                                                                                    inputRef={inputRefUliceST}
                                                                                    onKeyDown={handleKeyDownUlicaST}
                                                                                    onClick={() => setOpenST(true)} // Open on click
                                                                                    onFocus={() => setOpenST(true)} // Open on focus
                                                                                    />
                                                                                )}
                                                                                disableCloseOnSelect={false}

                                                                                autoHighlight
                                                                                onFocus={event => {
                                                                                                        
                                                                                    event.target.select()
                                                                                        
                                                                                }}           

                                                                    />





                                                               {/*<TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Ulica"
                                                                                                variant="outlined"
                                                                                                value={ulicaStrukt}
                                                                                                
                                                                                                onChange={(event) => {

                                                                                                    setUlicaStrukt(event.target.value);
                                                                                                    searchForUlica(event.target.value, "uliceST");
                                                                                                    
                                                                                                }}
                                                                />
                                                                {listUliceST.length!=0 && 
                                                                    <Box className="BijeleStranice-lista-ulice">
                                                                
                                                                        {listUliceST.map(ulica=> {
                                                                                return (
                                                                                    <div className="BijeleStranice-lista-ulice-ulica" onClick={()=>{
                                                                                        console.log(ulica)
                                                                                        setSelectedUlicaST(ulica);
                                                                                        setUlicaStrukt(ulica.NAZIV?ulica.NAZIV:ulica.naziv);
                                                                                        console.log(ulica.NAZIV)
                                                                                        setListUliceST([])
                                                                                    }}>{ulica.NAZIV?ulica.NAZIV:ulica.naziv}</div>
                                                                                )
                                                                            })}
                                                                    </Box>} */}
                                                            </Grid>
                                                            <Grid xs={2}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Kbr"
                                                                                                variant="outlined"
                                                                                                value={kbrStrukt}
                                                                                                
                                                                                                onChange={(event) => {

                                                                                                    setKbrStrukt(event.target.value)
                                                                                                    
                                                                                                }}
                                                                                                inputRef={kbrStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        kbrZnakStrukt_ref.current.focus();
                                                                                                    }
                                                                                                }}

                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}                                                                                                       

                                                                />
                                                            </Grid>
                                                            <Grid xs={2}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Dodatak"
                                                                                                value={kbr_znakStrukt}
                                                                                                
                                                                                                variant="outlined"

                                                                                            
                                                                                                
                                                                                                onChange={(event) => {

                                                                                                   setKbr_znakStrukt(event.target.value) 
                                                                                                    
                                                                                                }}

                                                                                                inputRef={kbrZnakStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        komentarStrukt_ref.current.focus();
                                                                                                    }
                                                                                                }}     
                                                                                                
                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}                                                                                                       

                                                                />
                                                            </Grid>
                                                            <Grid xs={3}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                                                size="small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label="Web-ID podruznice"
                                                                                                value={webPodruznice}
                                                                                                variant="outlined"
                                                                                                disabled
                                                                                                
                                                                                                onChange={(event) => {
                                                                                                    
                                                                                                }}


                                                                />
                                                            </Grid>
                                                            <Grid xs={9}>
                                                               <TextField
                                                                    InputProps={{sx:{height:30}}}
                                                                    InputLabelProps={{
                                                                        sx: {
                                                                            
                                                                            fontSize: "10px",
                                                                            
                                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                        }
                                                                        }}
                                                                               
                                                                        
                                                                     
                                                                                                size = "small"
                                                                                                fullWidth
                                                                                                id=""
                                                                                                label = "Komentar"
                                                                                                variant = "outlined"
                                                                                                value = {komentStrukt}
                                                                                                
                                                                                                onChange={(event) => {

                                                                                                    setKomentStrukt(event.target.value);
                                                                                                    
                                                                                                }}

                                                                                                inputRef={komentarStrukt_ref}
                                                                                                onKeyDown={(event) => {
                                                                                                    if (event.key === 'Enter'){

                                                                                                        pojam1Strukt_ref.current.focus();
                                                                                                    }
                                                                                                }}      
                                                                                                onFocus={event => {
                                                                                                                        
                                                                                                    event.target.select()
                                                                                                        
                                                                                                }}                                                                                                       
                                                                                                
                                                                />
                                                            </Grid>

                                                                <Grid xs={4}>
                                                                   <TextField
                                                                        InputProps={{sx:{height:30}}}
                                                                        InputLabelProps={{
                                                                            sx: {
                                                                                
                                                                                fontSize: "10px",
                                                                                
                                                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                            }
                                                                            }}
                                                                                                        size="small"
                                                                                                        fullWidth
                                                                                                        id=""
                                                                                                        label="Pojmovi"
                                                                                                        variant="outlined"
                                                                                                        value={pojam1Strukt}

                                                                                                        //disabled
                                                                                                        
                                                                                                        
                                                                                                        onChange={(event) => {
                                                                                                            
                                                                                                        }}
                                                                                                        inputRef={pojam1Strukt_ref}
                                                                                                        onKeyDown={(event) => {
                                                                                                            if (event.key === 'Enter'){

                                                                                                                pojam2Strukt_ref.current.focus();
                                                                                                            }
                                                                                                        }}

                                                                                                        onFocus={event => {
                                                                                                                                
                                                                                                            event.target.select()
                                                                                                                
                                                                                                        }}                                                                                                               

                                                                    />

                                                                </Grid>
                                                                <Grid xs={4}>
                                                                   <TextField
                                                                        InputProps={{sx:{height:30}}}
                                                                        InputLabelProps={{
                                                                            sx: {
                                                                                
                                                                                fontSize: "10px",
                                                                                
                                                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                            }
                                                                            }}
                                                                                                        size="small"
                                                                                                        fullWidth
                                                                                                        id=""
                                                                                                        label="Pojmovi"
                                                                                                        variant="outlined"
                                                                                                        value={pojam2Strukt}

                                                                                                        //disabled
                                                                                                        
                                                                                                        onChange={(event) => {
                                                                                                            
                                                                                                        }}

                                                                                                        inputRef={pojam2Strukt_ref}
                                                                                                        onKeyDown={(event) => {
                                                                                                            if (event.key === 'Enter'){

                                                                                                                pojam3Strukt_ref.current.focus();
                                                                                                            }
                                                                                                        }}    
                                                                                                        
                                                                                                        onFocus={event => {
                                                                                                                                
                                                                                                            event.target.select()
                                                                                                                
                                                                                                        }}                                                                                                                
                                                                    />

                                                                </Grid>
                                                                <Grid xs={4}>
                                                                   <TextField
                                                                        InputProps={{sx:{height:30}}}
                                                                        InputLabelProps={{
                                                                            sx: {
                                                                                
                                                                                fontSize: "10px",
                                                                                
                                                                                "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                                            }
                                                                            }}
                                                                                                        size="small"
                                                                                                        fullWidth
                                                                                                        id=""
                                                                                                        label="Pojmovi"
                                                                                                        variant="outlined"
                                                                                                        value={pojam3Strukt}

                                                                                                        //disabled
                                                                                                        
                                                                                                        onChange={(event) => {
                                                                                                            
                                                                                                        }}

                                                                                                        inputRef={pojam3Strukt_ref}

                                                                                                        onFocus={event => {
                                                                                                                                
                                                                                                            event.target.select()
                                                                                                                
                                                                                                        }}                                                                                                                
                                                                                                                                                                                                          
                                                                    />

                                                                </Grid>
                                                                <Grid xs={3} sx={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
                                                                   <Typography  sx={{fontSize:'11px', marginRight: '10px'}}>Objava: </Typography>

                                                                   <RadioGroup
                                                                                row
                                                                                name="value"
                                                                                sx={{fontSize:'11px'}}
                                                                                //defaultValue={objavaStruktChecked}
                                                                                value={objavaStruktChecked}
                                                                                size='small'
                                                                                onChange={(event, value)=>{
                                                                                    console.log("clicked");
                                                                                    console.log(event);
                                                                                    console.log(value);

                                                                                    console.log(objavaStrukt)
                                                                                    console.log(objavaStruktChecked)

                                                                                    //if(value.localeCompare('1')){
                                                                                    if(value==1){

                                                                                        console.log("SVEEEEEEEEE")
                                                                                        setObjavaStrukt(1);
                                                                                    //} else if(value.localeCompare('9')){

                                                                                    } else if(value==9){
                                                                                        console.log("98888888")
                                                                                        setObjavaStrukt(9);
                                                                                    //} else if(value.localeCompare('7')){
                                                                                    } else if(value==7){

                                                                                        console.log("NEEEEEEE")
                                                                                        setObjavaStrukt(7);

                                                                                    }
                                                                                    
                                                                                    setObjavaStruktChecked(value)
    
                                                                                    //setObjavaStrukt(!objavaStrukt);
                                                                                    //console.log(objavaStrukt);
                                                                                    //console.log(objavaStruktChecked)
                                                                                }} 
                                                                            >

                                                                                                                                  
                                                                    <FormControlLabel sx={{'& .MuiSvgIcon-root': {fontSize: 15,},}} value="1"  control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 13,},}} size="small"/>}  
                                                                    label="SVE" />
                                                                    <FormControlLabel sx={{'& .MuiSvgIcon-root': {fontSize: 15,},}} value="9"  control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 13,},}} size="small"/>}  
                                                                    label="988" />                                                                    
                                                                    <FormControlLabel sx={{'& .MuiSvgIcon-root': {fontSize: 15,},}} value="7"  control={<Radio sx={{'& .MuiSvgIcon-root': {fontSize: 13,},}} size="small"/>} label="Ne" />

                                                                </RadioGroup>
                                                          


                                                                </Grid>

                                                                <Grid xs={2} sx={{display:"flex", alignItems:"center", justifyContent:"flex-start"}}>
                                                                                <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightblue', color:'black'}} fullWidth variant="contained" 
                                                                                 
                                                                                        onClick={() => {
                                                                                
                                                                                            console.log("Setting remembered structure!!!!")
                                                                                            console.log(memoStrukt);

                                                                                            if(memoStrukt && memoStrukt!=''){
                                                                                            
                                                                                                    let tmpPhone = "0" + memoStrukt.mreza + "" + memoStrukt.telefon;
                                                                                                    getDataPhone(tmpPhone);
                                                                                                    setNewStrukt(true);

                                                                                                    setNewStruktChecked(true);

                                                                                                    //setRedosStrukt('')
                                                                                                    setNivoStrukt('');
                                                                                                    setMrezaStrukt(memoStrukt.mreza);
                                                                                                    setTelStrukt(memoStrukt.telefon);
                                                                                                    
                                                                                                    
                                                                                                    //let tmp = memoStrukt.objava==7?false:true;
                                                                                                    //if(tmp) { setObjavaStruktChecked('DA')} else {setObjavaStruktChecked('NE')};
                                                                                                    
                                                                                                    setObjavaStrukt(memoStrukt.objava);
                                                                                                    setObjavaStruktChecked(memoStrukt.objava)


                                                                                                    setUlicaStrukt(memoStrukt.ulica_naziv);
                                                                                                    setSelectedUlicaST({'ULICA_ID': memoStrukt.sifr_ul, 'NAZIV':memoStrukt.ulica_naziv});
                                                                                                    setKbrStrukt(memoStrukt.kbr?memoStrukt.kbr:'');
                                                                                                    setKbr_znakStrukt(memoStrukt.alfa?memoStrukt.alfa:'');


                                                                                                    setNazivStrukt(memoStrukt.naziv);
                                                                                                    setKomentStrukt(memoStrukt.komentar?memoStrukt.komentar:'');
                                                                                                    setDatStr1(memoStrukt.datum_unosa);
                                                                                                    setDatStr2(memoStrukt.dat_zadnjeg_azur);
                                                                                                    setKnjigaStrukt(memoStrukt.knjiga);
                                                                                                    setPojam1Strukt(memoStrukt.pojam1);
                                                                                                    setPojam2Strukt(memoStrukt.pojam2);
                                                                                                    setPojam3Strukt(memoStrukt.pojam3);
                    
                                                                                                    //setBelow(false);
                                                                                                    //setAbove(false);

                                                                                            } else {

                                                                                                    toast.error("Niste kopirali nijednu strukturu, nema podataka za unos", toastError)
                                                                                            }
            
            
            

                                                                                    }}>
                                                                                    MEMO 
                                                                                </Button>

                                                                </Grid>                                                                     

                                                                <Grid xs={3} sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                                                    <FormControlLabel   sx={{fontSize:20}} control={<Checkbox size="small" checked={newStruktChecked} onClick={()=>{
                                                                                        if(!newStrukt) {
                                                                                              
                                                                                            setRedosStrukt('')
                                                                                            setNivoStrukt('')
                                                                                            setMrezaStrukt('')
                                                                                            setTelStrukt('')
                                                                                            
                                                                                            //setObjavaStrukt(false);
                                                                                            //setObjavaStruktChecked('NE');

                                                                                            setObjavaStrukt(1);
                                                                                            setObjavaStruktChecked(1);
                                                                                            
                                                                                            setUlicaStrukt('')
                                                                                            setSelectedUlicaST({'ULICA_ID': 0, 'NAZIV':''});
                                                                                            setKbrStrukt('')
                                                                                            setKbr_znakStrukt('');
                                                                                            setNazivStrukt('')
                                                                                            setKomentStrukt('')
                                                                                            setDatStr1('')
                                                                                            setDatStr2('')
                                                                                            setKnjigaStrukt('')
                                                                                            setPojam1Strukt('')
                                                                                            setPojam2Strukt('')
                                                                                            setPojam3Strukt('')
                                                                                                

                                                                                        }
                                                                                        setNewStrukt(!newStrukt);
                                                                                        setNewStruktChecked(!newStruktChecked);

                                                                                        //setBelow(false);
                                                                                        //setAbove(false);

                                                                                        setBureInfo('');

                                                                                        setSelectedStrukt([]);
                                                                                        setMemoStrukt('');
                                                                                    
                                                                                        


                                                                    }}/>} label={<span style={{ fontSize: '15px' }}>- UNOS NOVE STRUKTURE</span>} /> 

                                                                </Grid>

                                                                <Grid xs={2} sx={{display:"flex", alignItems:"center", justifyContent:"flex-end"}}>
                                                                            <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} 
                                                                            fullWidth variant="contained" 
                                                                            
                                                                                    onClick={() => {
                                                                                        //setZuteStranice(true)

                                                                                        getZuteStranice();
                                                                            
                                                                                }} 
                                                                                //disabled
                                                                                >
                                                                                Žute stranice
                                                                            </Button>

                                                                </Grid>    
                                                                
                                                                <Grid xs={2} sx={{display:"flex", alignItems:"center", justifyContent:"flex-end"}}>
                                                                            <Button sx={{height:"30px", fontSize:"10px", backgroundColor:'lightyellow', color:'black'}} 
                                                                            fullWidth variant="contained" 
                                                                                    onClick={() => {
                                                                                        if(OIB && OIB!=''){

                                                                                            getMB()

                                                                                        } else {

                                                                                            toast.error("Odabrana tvrtka nema definiran niti OIB niti MB, molimo provjerite podatke tvrtke", toastError)
                                                                                        }
                                                                                }} >
                                                                                MB
                                                                            </Button>

                                                                </Grid>  
    
                                                            
                                                            
                                                                <Grid xs={15} sx={{padding:'5px', gap:"0px"}} container spacing={0.75} columns={{xs:12}}>
                                                                    <Grid xs={4}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" 
                                                                                        onClick={() => {
                                                                                

                                                                                            console.log("Copying strukt!!!");

                                                                                            if(selectedStrukt && selectedStrukt!=''
                                                                                                && selectedStrukt.length==1
                                                                                            ){

                                                                                                console.log(selectedStrukt);

                                                                                                setMemoStrukt(selectedStrukt);

                                                                                            } else {


                                                                                                toast.error("Niste ispravno odabrali strukturu za kopirati", toastError);
                                                                                            }

            

                                                                                    }}>
                                                                                    Kopiraj strukturu 
                                                                                </Button>

                                                                    </Grid>           

                                                                    <Grid xs={4}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="success"
                                                                                        onClick={() => {
                                                                                            console.log("Ide ispod");
                                                                                            console.log(below);
                                                                                            console.log("Ide iznad:");
                                                                                            console.log(above);


                                                                                            if(below){
                                                                                                setBijeleStrukture_Above(1);
                                                                                            } else if(above){

                                                                                                setBijeleStrukture_Above(0);

                                                                                            } else {

                                                                                                setBijeleStrukture();
                                                                                            }
                                                                                    }}>
                                                                                    SPREMI PROMJENE U STRUKTURI
                                                                                </Button>

                                                                    </Grid>    

                                                                    <Grid xs={4}>
                                                                                <Button sx={{height:"30px", fontSize:"10px"}} fullWidth variant="contained" color="error"
                                                                                    disabled={!(sifra&&redosStrukt&&tkcFirma)}    
                                                                                    onClick={() => {
                                                                                            console.log("Brišem?");
                                                                                            console.log(redosStrukt);
                                                                                            console.log(sifra);
                                                                                            console.log(tkcFirma);

                                                                                            if(redosStrukt && redosStrukt!=0){

                                                                                                brisiStrukt();

                                                                                            } else {

                                                                                                toast.error("Niste odabrali nijednu strukturu za brisanje. Za odabrati strukturu morate kliknuti na redak željene strukture.");
                                                                                            }
                                                                                    }}>
                                                                                    OBRIŠI STRUKTURU
                                                                                </Button>

                                                                    </Grid>          


 

                                                                

                                                                </Grid>  
                            </Grid>  

                        </Grid>  


                            
                    </div>                
                </div>
            </div>

        <div className='BijeleStranice-bottom' style={{display: modalIsOpen? 'flex':'none'}}
        
            onMouseDown={(e)=>onMouseDown(e)}>

        </div>

        </div>
    </Box >
  );
}

export default BijeleStranice;
